var $f6d2e675cb3f0a02$export$2e2bcd8739ae039 = [
    [
        {
            "rus": "\u042D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u0438\u043D\u043E\u0433\u0434\u0430 \u0441\u043C\u043E\u0442\u0440\u0438\u0442 \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u043E\u0440",
            "eng": "This woman sometimes watches TV"
        },
        {
            "rus": "\u042D\u0442\u0438 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u0438\u043D\u043E\u0433\u0434\u0430 \u0441\u043C\u043E\u0442\u0440\u044F\u0442 \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u043E\u0440",
            "eng": "These women sometimes watch TV"
        },
        {
            "rus": "\u0415\u0451 \u0440\u0435\u0431\u0451\u043D\u043E\u043A \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u0435\u0451",
            "eng": "Her child always listens to her",
            "regEng": "/Her (?:child|kid) always listens to her/gm"
        },
        {
            "rus": "\u0415\u0451 \u0434\u0435\u0442\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u044E\u0442 \u0435\u0451",
            "eng": "Her children always listen to her",
            "regEng": "/Her (?:children|kids) always listen to her/gm"
        },
        {
            "rus": "\u0422\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u0432\u0438\u0434\u0435\u043E \u0438\u0433\u0440\u044B",
            "eng": "That man never plays video games"
        },
        {
            "rus": "\u0422\u0435 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0438\u0433\u0440\u0430\u044E\u0442 \u0432 \u0432\u0438\u0434\u0435\u043E \u0438\u0433\u0440\u044B",
            "eng": "Those men never play video games"
        },
        {
            "rus": "\u041D\u0430\u0448 \u0440\u0435\u0431\u0451\u043D\u043E\u043A \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0435\u0441\u0442 \u0433\u0430\u043C\u0431\u0443\u0440\u0433\u0435\u0440\u044B",
            "eng": "Our child never eats hamburgers"
        },
        {
            "rus": "\u041D\u0430\u0448\u0438 \u0434\u0435\u0442\u0438 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0435\u0434\u044F\u0442 \u0433\u0430\u043C\u0431\u0443\u0440\u0433\u0435\u0440\u044B",
            "eng": "Our children never eat hamburgers"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0447\u0430\u0441\u0442\u043E \u0447\u0438\u0442\u0430\u0435\u0442 \u0433\u0430\u0437\u0435\u0442\u044B \u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u044B",
            "eng": "This person often reads newspapers and magazines"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0447\u0430\u0441\u0442\u043E \u0447\u0438\u0442\u0430\u044E\u0442 \u0433\u0430\u0437\u0435\u0442\u044B \u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u044B",
            "eng": "These people often read newspapers and magazines"
        },
        {
            "rus": "\u0422\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u043E\u043A\u0443\u043F\u0430\u0435\u0442 \u0434\u043E\u0440\u043E\u0433\u0438\u0435 \u043A\u043E\u0441\u0442\u044E\u043C\u044B",
            "eng": "That man usually buys expensive suits"
        },
        {
            "rus": "\u0422\u0435 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u043E\u043A\u0443\u043F\u0430\u044E\u0442 \u0434\u043E\u0440\u043E\u0433\u0438\u0435 \u043A\u043E\u0441\u0442\u044E\u043C\u044B",
            "eng": "Those men usually buy expensive suits"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0440\u0435\u0434\u043A\u043E \u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u0444\u0443\u0442\u0431\u043E\u043B",
            "eng": "This person rarely plays football",
            "regEng": "/This person (?:rarely|seldom) plays football/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0440\u0435\u0434\u043A\u043E \u0438\u0433\u0440\u0430\u044E\u0442 \u0432 \u0444\u0443\u0442\u0431\u043E\u043B",
            "eng": "These people rarely play football",
            "regEng": "/These people (?:rarely|seldom) play football/gm"
        },
        {
            "rus": "\u042D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043D\u043E\u0441\u0438\u0442 \u0442\u0430\u043A\u0438\u0445 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0445 \u044E\u0431\u043E\u043A",
            "eng": "This woman never wears such short skirts"
        },
        {
            "rus": "\u042D\u0442\u0438 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043D\u043E\u0441\u044F\u0442 \u0442\u0430\u043A\u0438\u0445 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0445 \u044E\u0431\u043E\u043A",
            "eng": "These women never wear such short skirts"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u043E\u0431\u044B\u0447\u043D\u043E \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u0442\u0443 \u0436\u0435\u043D\u0449\u0438\u043D\u0443",
            "eng": "This man usually listens to that woman"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043E\u0431\u044B\u0447\u043D\u043E \u0441\u043B\u0443\u0448\u0430\u044E\u0442 \u0442\u0435\u0445 \u0436\u0435\u043D\u0449\u0438\u043D",
            "eng": "These men usually listen to those women"
        },
        {
            "rus": "\u042D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0441\u043C\u043E\u0442\u0440\u0438\u0442 \u0442\u0430\u043A\u0438\u0435 \u0448\u043E\u0443",
            "eng": "This woman never watches such shows"
        },
        {
            "rus": "\u042D\u0442\u0438 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0441\u043C\u043E\u0442\u0440\u044F\u0442 \u0442\u0430\u043A\u0438\u0435 \u0448\u043E\u0443",
            "eng": "These women never watch such shows"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u043D\u043E\u0441\u0438\u0442 \u0442\u0430\u043A\u0438\u0435 \u0431\u0440\u044E\u043A\u0438",
            "eng": "This man always wears such trousers"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u043D\u043E\u0441\u044F\u0442 \u0442\u0430\u043A\u0438\u0435 \u0431\u0440\u044E\u043A\u0438",
            "eng": "These men always wear such trousers"
        },
        {
            "rus": "\u0412\u0430\u0448 \u0440\u0435\u0431\u0451\u043D\u043E\u043A \u0447\u0430\u0441\u0442\u043E \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u044D\u0442\u0443 \u043F\u0435\u0441\u043D\u044E",
            "eng": "Your child often listens to this song",
            "regEng": "/Your (?:child|kid) often listens to this song/gm"
        },
        {
            "rus": "\u0412\u0430\u0448\u0438 \u0434\u0435\u0442\u0438 \u0447\u0430\u0441\u0442\u043E \u0441\u043B\u0443\u0448\u0430\u044E\u0442 \u044D\u0442\u0438 \u043F\u0435\u0441\u043D\u0438",
            "eng": "Your children often listen to these songs",
            "regEng": "/Your (?:children|kids) often listen to these songs/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u0445\u043E\u0442\u044F\u0442 \u043A\u0443\u043F\u0438\u0442\u044C \u0445\u043E\u0440\u043E\u0448\u0443\u044E \u043C\u0430\u0448\u0438\u043D\u0443",
            "eng": "They want to buy a good car"
        },
        {
            "rus": "\u0427\u0442\u043E\u0431\u044B \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u0442\u044C \u0441\u0432\u043E\u044E \u0440\u0430\u0431\u043E\u0442\u0443, \u0435\u043C\u0443 \u043D\u0443\u0436\u043D\u043E \u0441\u043F\u0435\u0448\u0438\u0442\u044C",
            "eng": "To finish his work he needs to hurry",
            "regEng": "/(?:To finish his work he needs to (?:hurry(?: up)?|rush))|(?:He needs to (?:hurry(?: up)?|rush) to finish his work)/gm"
        },
        {
            "rus": "\u0415\u043C\u0443 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u043F\u043E\u0441\u0435\u0449\u0430\u0442\u044C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043C\u0435\u0441\u0442\u0430 \u043A\u0430\u0436\u0434\u044B\u0439 \u0433\u043E\u0434",
            "eng": "He likes to visit interesting places every year"
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u043D\u0430\u0439\u0442\u0438 \u043D\u043E\u0432\u0443\u044E \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443",
            "eng": "We need to find a new flat",
            "regEng": "/We need to find a new (?:flat|apartment)/gm"
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u044C \u0441\u044E\u0434\u0430 \u043A\u0430\u0436\u0434\u0443\u044E \u043D\u0435\u0434\u0435\u043B\u044E",
            "eng": "I like to come here every week"
        },
        {
            "rus": "\u0427\u0442\u043E\u0431\u044B \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u044D\u0442\u043E, \u0442\u0435\u0431\u0435 \u043D\u0443\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0441\u0438\u043B\u044C\u043D\u044B\u043C",
            "eng": "To do this you need to be strong",
            "regEng": "/(?:To do (?:this|it|that) you need to be strong)|(?:You need to be strong to do (?:this|it|that))/gm"
        }
    ],
    [
        {
            "rus": "\u0427\u0442\u043E\u0431\u044B \u0431\u044B\u0442\u044C \u0437\u0434\u043E\u0440\u043E\u0432\u044B\u043C, \u0442\u0435\u0431\u0435 \u043D\u0443\u0436\u043D\u043E \u0435\u0441\u0442\u044C \u0445\u043E\u0440\u043E\u0448\u0443\u044E \u0435\u0434\u0443",
            "eng": "To be healthy you need to eat good food",
            "regEng": "/(?:To be healthy you need to eat good food)|(?:You need to eat good food to be healthy)/gm"
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u043C\u044B\u0442\u044C \u0441\u0432\u043E\u0438 \u0431\u043E\u0442\u0438\u043D\u043A\u0438 \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "I like to wash my shoes every day",
            "regEng": "/(?:I like to wash my (?:shoes|boots) every day)|(?:I like washing my (?:shoes|boots) every day)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442 \u0438\u043C\u0435\u0442\u044C \u043E\u0442\u043B\u0438\u0447\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443",
            "eng": "She wants to have an excellent job"
        },
        {
            "rus": "\u042F \u0445\u043E\u0447\u0443 \u043F\u0438\u0442\u044C \u0437\u0435\u043B\u0451\u043D\u044B\u0439 \u0447\u0430\u0439 \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "I want to drink green tea every day"
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u043F\u043E\u043C\u043E\u0433\u0430\u0442\u044C \u0441\u0432\u043E\u0438\u043C \u0434\u0440\u0443\u0437\u044C\u044F\u043C \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F",
            "eng": "We like to help our friends all the time"
        },
        {
            "rus": "\u0427\u0442\u043E\u0431\u044B \u0431\u044B\u0442\u044C \u0441\u0438\u043B\u044C\u043D\u044B\u043C \u0438 \u0437\u0434\u043E\u0440\u043E\u0432\u044B\u043C, \u0435\u043C\u0443 \u043D\u0443\u0436\u043D\u043E \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
            "eng": "To be strong and healthy he needs to exercise",
            "regEng": "/(?:To be strong and healthy he needs to exercise)|(?:He needs to exercise to be strong and healthy)/gm"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0447\u0430\u0441\u0442\u043E \u043F\u0440\u0438\u0435\u0437\u0436\u0430\u0435\u0442 \u0441\u044E\u0434\u0430",
            "eng": "This person often comes here"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0447\u0430\u0441\u0442\u043E \u043F\u0440\u0438\u0435\u0437\u0436\u0430\u044E\u0442 \u0441\u044E\u0434\u0430",
            "eng": "These people often come here"
        },
        {
            "rus": "\u0422\u043E\u0442 \u0440\u0435\u0431\u0451\u043D\u043E\u043A \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043F\u044C\u0451\u0442 \u0437\u0435\u043B\u0451\u043D\u044B\u0439 \u0447\u0430\u0439",
            "eng": "That child never drinks green tea",
            "regEng": "/(?:That (?:child|kid) never drinks green tea)/gm"
        },
        {
            "rus": "\u0422\u0435 \u0434\u0435\u0442\u0438 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043F\u044C\u044E\u0442 \u0437\u0435\u043B\u0451\u043D\u044B\u0439 \u0447\u0430\u0439",
            "eng": "Those children never drink green tea",
            "regEng": "/(?:Those (?:children|kids) never drink green tea)/gm"
        },
        {
            "rus": "\u042D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u043D\u043E\u0441\u0438\u0442 \u0442\u0430\u043A\u0438\u0435 \u0434\u043B\u0438\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u044C\u044F",
            "eng": "This woman always wears such long dresses"
        },
        {
            "rus": "\u042D\u0442\u0438 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u043D\u043E\u0441\u044F\u0442 \u0442\u0430\u043A\u0438\u0435 \u0434\u043B\u0438\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u044C\u044F",
            "eng": "These women always wear such long dresses"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0438\u043D\u043E\u0433\u0434\u0430 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0437\u0434\u0435\u0441\u044C",
            "eng": "This man sometimes works here"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0438\u043D\u043E\u0433\u0434\u0430 \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0442 \u0437\u0434\u0435\u0441\u044C",
            "eng": "These men sometimes work here"
        },
        {
            "rus": "\u0412\u0430\u0448 \u0440\u0435\u0431\u0451\u043D\u043E\u043A \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043A\u0430\u0440\u0442\u044B",
            "eng": "Your child never plays cards",
            "regEng": "/(?:Your (?:child|kid) never plays cards)/gm"
        },
        {
            "rus": "\u0412\u0430\u0448\u0438 \u0434\u0435\u0442\u0438 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0438\u0433\u0440\u0430\u044E\u0442 \u0432 \u043A\u0430\u0440\u0442\u044B",
            "eng": "Your children never play cards",
            "regEng": "/(?:Your (?:children|kids) never play cards)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0440\u0435\u0434\u043A\u043E \u0441\u043C\u043E\u0442\u0440\u0438\u0442 \u0442\u0430\u043A\u0438\u0435 \u0448\u043E\u0443",
            "eng": "This person rarely watches such shows",
            "regEng": "/(?:This person (?:rarely|seldom) watches such shows)/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0440\u0435\u0434\u043A\u043E \u0441\u043C\u043E\u0442\u0440\u044F\u0442 \u0442\u0430\u043A\u0438\u0435 \u0448\u043E\u0443",
            "eng": "These people rarely watch such shows"
        }
    ],
    [
        {
            "rus": "\u041E\u043D \u0445\u043E\u0447\u0435\u0442 \u043D\u0430\u0439\u0442\u0438 \u043D\u043E\u0432\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443",
            "eng": "He wants to find a new job"
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u044D\u0442\u0438 \u0447\u0443\u0434\u0435\u0441\u043D\u044B\u0435 \u0444\u0438\u043B\u044C\u043C\u044B",
            "eng": "We like to watch these wonderful films",
            "regEng": "/(?:We like to watch these wonderful (?:films|movies))/gm"
        },
        {
            "rus": "\u0427\u0442\u043E\u0431\u044B \u0437\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C \u0434\u0435\u043D\u044C\u0433\u0438, \u0442\u0435\u0431\u0435 \u043D\u0443\u0436\u043D\u043E \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C",
            "eng": "To earn money you need to work",
            "regEng": "/(?:To earn money you need to work)|(?:You need to work to earn money)/gm"
        },
        {
            "rus": "\u041A\u0442\u043E \u0445\u043E\u0447\u0435\u0442 \u0443\u0441\u043B\u044B\u0448\u0430\u0442\u044C \u043E\u0442\u043B\u0438\u0447\u043D\u0443\u044E \u0438\u0441\u0442\u043E\u0440\u0438\u044E?",
            "eng": "Who wants to hear an excellent story?"
        },
        {
            "rus": "\u0415\u0439 \u043D\u0443\u0436\u043D\u043E \u0432\u0437\u044F\u0442\u044C \u0440\u0443\u0447\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0438\u0441\u0430\u0442\u044C",
            "eng": "She needs to take a pen to write",
            "regEng": "/(?:She needs to take a pen to write)|(?:To write she needs to take a pen)/gm"
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u0432\u0438\u0434\u0435\u0442\u044C \u0441\u0432\u043E\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439 \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "I need to see my friends every day"
        }
    ],
    [
        {
            "rus": "\u041E\u043D \u0437\u043D\u0430\u0435\u0442 \u043A\u0430\u0436\u0434\u0443\u044E \u043A\u0440\u0430\u0441\u0438\u0432\u0443\u044E \u0434\u0435\u0432\u0443\u0448\u043A\u0443 \u0437\u0434\u0435\u0441\u044C",
            "eng": "He knows every beautiful girl here"
        },
        {
            "rus": "\u0423 \u043C\u0435\u043D\u044F \u0435\u0441\u0442\u044C \u0445\u043E\u0440\u043E\u0448\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
            "eng": "I have a good question"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442 \u043A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0440\u043E\u0433\u0438\u0435 \u0442\u0443\u0444\u043B\u0438",
            "eng": "She wants to buy new expensive shoes"
        },
        {
            "rus": "\u041D\u0430\u043C \u0432\u0441\u0435\u0433\u0434\u0430 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0441\u043B\u044B\u0448\u0430\u0442\u044C \u0442\u0432\u043E\u0438 \u0438\u0441\u0442\u043E\u0440\u0438\u0438",
            "eng": "We always like to hear your stories"
        },
        {
            "rus": "\u041A\u043E\u043C\u0443 \u043D\u0443\u0436\u043D\u043E \u0438\u0433\u0440\u0430\u0442\u044C \u0432 \u044D\u0442\u0438 \u0432\u0438\u0434\u0435\u043E\u0438\u0433\u0440\u044B?",
            "eng": "Who needs to play these video games?"
        },
        {
            "rus": "\u041C\u044B \u0437\u043D\u0430\u0435\u043C \u0442\u0430\u043A\u043E\u0439 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0439 \u0444\u0438\u043B\u044C\u043C!",
            "eng": "We know such an interesting film!",
            "regEng": "/(?:We know such an interesting (?:film|movie)!)/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u0440\u0435\u0434\u043A\u043E \u043D\u043E\u0441\u044F\u0442 \u0442\u0430\u043A\u0438\u0435 \u0431\u0440\u044E\u043A\u0438",
            "eng": "These women rarely wear such trousers",
            "regEng": "/(?:These women (?:rarely|seldom) wear such (?:trousers|pants))/gm"
        }
    ],
    [
        {
            "rus": "\u041C\u043E\u0438 \u0434\u0435\u0442\u0438 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0441\u043C\u043E\u0442\u0440\u044F\u0442 \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u043E\u0440",
            "eng": "My children never watch TV",
            "regEng": "/(?:My (?:children|kids) never watch TV)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0441\u043B\u0443\u0448\u0430\u044E\u0442 \u043C\u0435\u043D\u044F",
            "eng": "They never listen to me"
        },
        {
            "rus": "\u0423 \u043A\u043E\u0433\u043E \u0435\u0441\u0442\u044C \u0437\u0435\u043B\u0451\u043D\u0430\u044F \u0440\u0443\u0447\u043A\u0430?",
            "eng": "Who has a green pen?"
        },
        {
            "rus": "\u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u043F\u0440\u0438\u0435\u0437\u0436\u0430\u0442\u044C \u0441\u044E\u0434\u0430 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F",
            "eng": "You need to come here all the time"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0445\u043E\u0447\u0435\u0442 \u043F\u043E\u0438\u0433\u0440\u0430\u0442\u044C \u0432 \u043A\u0430\u0440\u0442\u044B",
            "eng": "This man wants to play cards"
        },
        {
            "rus": "\u0423 \u0432\u0430\u0441 \u0443\u0434\u0438\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430",
            "eng": "You have an amazing job"
        },
        {
            "rus": "\u0423 \u044D\u0442\u043E\u0439 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u0437\u0434\u043E\u0440\u043E\u0432\u044B\u0435 \u043C\u0430\u043B\u044B\u0448\u0438",
            "eng": "This woman has healthy babies"
        },
        {
            "rus": "\u0415\u043C\u0443 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0431\u044B\u0442\u044C \u0445\u043E\u0440\u043E\u0448\u0438\u043C \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u043C",
            "eng": "He likes to be a good person"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E\u043C\u0443 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0443 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0438 \u044D\u0442\u0438 \u0433\u0430\u0437\u0435\u0442\u044B",
            "eng": "This person needs you to read these newspapers"
        },
        {
            "rus": "\u041C\u043E\u0439 \u0440\u0435\u0431\u0451\u043D\u043E\u043A \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u044F \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u043B \u0442\u0435 \u0444\u0438\u043B\u044C\u043C\u044B",
            "eng": "My child wants me to watch those films",
            "regEng": "/(?:My (?:child|kid) wants me to watch those (?:films|movies))/gm"
        },
        {
            "rus": "\u0416\u0435\u043D\u0449\u0438\u043D\u044B \u0445\u043E\u0442\u044F\u0442, \u0447\u0442\u043E\u0431\u044B \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043B\u044E\u0431\u0438\u043B\u0438 \u0438\u0445",
            "eng": "Women want men to love them"
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0442\u044B \u0443\u0432\u0438\u0434\u0435\u043B \u0442\u0435\u0445 \u043B\u044E\u0434\u0435\u0439",
            "eng": "I need you to see those people"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u044F \u043F\u043E\u043C\u043E\u0433 \u0435\u0451 \u0434\u0435\u0442\u044F\u043C",
            "eng": "She wants me to help her children",
            "regEng": "/(?:She wants me to help her (?:children|kids))/gm"
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u043E\u043D \u043F\u043E\u0447\u0438\u0441\u0442\u0438\u043B \u0441\u0432\u043E\u0438 \u0437\u0443\u0431\u044B",
            "eng": "We need him to brush his teeth"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u0438\u043C \u043B\u044E\u0434\u044F\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u043F\u043E\u043C\u044B\u043B\u0438 \u0441\u0432\u043E\u0438 \u0441\u0442\u0443\u043F\u043D\u0438",
            "eng": "These people need us to wash our feet"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0430 \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u043B\u0430 \u0442\u0443 \u043F\u0435\u0441\u043D\u044E",
            "eng": "This man wants her to listen to that song"
        },
        {
            "rus": "\u0420\u043E\u0434\u0438\u0442\u0435\u043B\u044F\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0438\u0445 \u0434\u0435\u0442\u0438 \u0447\u0438\u0441\u0442\u0438\u043B\u0438 \u0441\u0432\u043E\u0438 \u0437\u0443\u0431\u044B",
            "eng": "Parents need their children to brush their teeth",
            "regEng": "/(?:Parents need their (?:children|kids) to brush their teeth)/gm"
        },
        {
            "rus": "\u0415\u043C\u0443 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u043B\u0438 \u0435\u0433\u043E",
            "eng": "He needs you to listen to him"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u044F \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B \u0442\u043E\u043C\u0443 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0443",
            "eng": "She wants me to call that person",
            "regEng": "/(?:She wants me to (?:call|phone) that person)/gm"
        },
        {
            "rus": "\u042F \u0445\u043E\u0447\u0443, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0438 \u043F\u043E\u043C\u044B\u043B\u0438 \u0441\u0432\u043E\u0438 \u0441\u0442\u0443\u043F\u043D\u0438",
            "eng": "I want them to wash their feet"
        }
    ],
    [
        {
            "rus": "\u041E\u043D \u0447\u0430\u0441\u0442\u043E \u043F\u0440\u0438\u043D\u043E\u0441\u0438\u0442 \u0435\u0439 \u0446\u0432\u0435\u0442\u044B",
            "eng": "He often brings her flowers"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D \u043F\u0440\u0438\u043D\u0451\u0441 \u0435\u0439 \u0446\u0432\u0435\u0442\u044B",
            "eng": "Yesterday he brought her flowers",
            "regEng": "/(?:Yesterday he brought her flowers)|(?:He brought her flowers yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043E\u043D \u043F\u0440\u0438\u043D\u0435\u0441\u0451\u0442 \u0435\u0439 \u0446\u0432\u0435\u0442\u044B",
            "eng": "Tomorrow he will bring her flowers",
            "regEng": "/(?:Tomorrow (?:he will|he\u2019ll) bring her flowers)|(?:(?:he will|he\u2019ll) bring her flowers tomorrow)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0438\u043D\u043E\u0433\u0434\u0430 \u0431\u0435\u0440\u0451\u0442 \u043C\u043E\u044E \u0440\u0443\u0447\u043A\u0443",
            "eng": "She sometimes takes my pen"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0430 \u0432\u0437\u044F\u043B\u0430 \u043C\u043E\u044E \u0440\u0443\u0447\u043A\u0443",
            "eng": "Yesterday she took my pen",
            "regEng": "/(?:Yesterday she took my pen)|(?:She took my pen yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043E\u043D\u0430 \u0432\u043E\u0437\u044C\u043C\u0451\u0442 \u043C\u043E\u044E \u0440\u0443\u0447\u043A\u0443",
            "eng": "Tomorrow she will take my pen",
            "regEng": "/(?:Tomorrow (?:she will|she\u2019ll) take my pen)|(?:(?:she will|she\u2019ll) take my pen tomorrow)/gm"
        }
    ],
    [
        {
            "rus": "\u042F \u043F\u0438\u0448\u0443 \u0432\u0430\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "I write you messages every day",
            "regEng": "/(?:I write you messages every day)|(?:Every day I write you messages)/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u044F \u043D\u0430\u043F\u0438\u0441\u0430\u043B \u0432\u0430\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
            "eng": "Yesterday I wrote you a message",
            "regEng": "/(?:Yesterday I wrote you a message)|(?:I wrote you a message yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u044F \u043D\u0430\u043F\u0438\u0448\u0443 \u0432\u0430\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
            "eng": "Tomorrow I will write you a message",
            "regEng": "/(?:Tomorrow (?:I will|I\u2019ll) write you a message)|(?:(?:I will|I\u2019ll) write you a message tomorrow)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0440\u0435\u0434\u043A\u043E \u0438\u0433\u0440\u0430\u044E\u0442 \u0432 \u0438\u0433\u0440\u044B",
            "eng": "They rarely play games",
            "regEng": "/They (?:rarely|seldom) play games/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0438 \u043F\u043E\u0438\u0433\u0440\u0430\u043B\u0438 \u0432 \u0438\u0433\u0440\u044B",
            "eng": "Yesterday they played games",
            "regEng": "/(?:Yesterday they played games)|(?:They played games yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043E\u043D\u0438 \u043F\u043E\u0438\u0433\u0440\u0430\u044E\u0442 \u0432 \u0438\u0433\u0440\u044B",
            "eng": "Tomorrow they will play games",
            "regEng": "/(?:Tomorrow (?:they will|they\u2019ll) play games)|(?:(?:They will|They\u2019ll) play games tomorrow)/gm"
        }
    ],
    [
        {
            "rus": "\u0423 \u043D\u0430\u0441 \u0432\u0441\u0435\u0433\u0434\u0430 \u043E\u0442\u043B\u0438\u0447\u043D\u044B\u0435 \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0438",
            "eng": "We always have excellent parties"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u0443 \u043D\u0430\u0441 \u0431\u044B\u043B\u0430 \u043E\u0442\u043B\u0438\u0447\u043D\u0430\u044F \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0430",
            "eng": "Yesterday we had an excellent party",
            "regEng": "/(?:Yesterday we had an excellent party)|(?:We had an excellent party yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u0443 \u043D\u0430\u0441 \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043B\u0438\u0447\u043D\u0430\u044F \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0430",
            "eng": "Tomorrow we will have an excellent party",
            "regEng": "/(?:Tomorrow (?:we will|we\u2019ll) have an excellent party)|(?:(?:We will|We\u2019ll) have an excellent party tomorrow)/gm"
        },
        {
            "rus": "\u042F \u043F\u0440\u0438\u0445\u043E\u0436\u0443 \u0441\u044E\u0434\u0430 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F",
            "eng": "I come here all the time",
            "regEng": "/(?:I come here all the time)|(?:All the time I come here)/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u044F \u043F\u0440\u0438\u0448\u0451\u043B \u0441\u044E\u0434\u0430",
            "eng": "Yesterday I came here",
            "regEng": "/(?:Yesterday I came here)|(?:I came here yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u044F \u043F\u0440\u0438\u0434\u0443 \u0441\u044E\u0434\u0430",
            "eng": "Tomorrow I will come here",
            "regEng": "/(?:Tomorrow (?:I will|I\u2019ll) come here)|(?:(?:I will|I\u2019ll) come here tomorrow)/gm"
        }
    ],
    [
        {
            "rus": "\u0415\u0439 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u044F \u043D\u0430\u0448\u0451\u043B \u043D\u043E\u0432\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443",
            "eng": "She needs me to find a new job",
            "regEng": ""
        },
        {
            "rus": "\u042F \u0445\u043E\u0447\u0443, \u0447\u0442\u043E\u0431\u044B \u044D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u043F\u043E\u043C\u043E\u0433 \u043C\u043D\u0435",
            "eng": "I want this man to help me",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438\u043C \u0436\u0435\u043D\u0449\u0438\u043D\u0430\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u043B\u0438 \u0438\u0445",
            "eng": "These women need you to listen to them",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u0435\u0433\u043E \u0440\u0435\u0431\u0435\u043D\u043E\u043A \u043F\u043E\u0447\u0438\u0441\u0442\u0438\u043B \u0441\u0432\u043E\u0438 \u0437\u0443\u0431\u044B",
            "eng": "He wants his child to brush his teeth",
            "regEng": "/He wants his (?:child|kid) to brush his teeth/gm"
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u044D\u0442\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0434\u0430\u043B \u043D\u0430\u043C \u0445\u043E\u0440\u043E\u0448\u0443\u044E \u0438\u0434\u0435\u044E",
            "eng": "We need this person to give us a good idea",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0430\u0448\u0438 \u0434\u0435\u0442\u0438 \u0445\u043E\u0442\u044F\u0442, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u043E\u0438\u0433\u0440\u0430\u043B\u0438 \u0441 \u043D\u0438\u043C\u0438",
            "eng": "Your children want you to play with them",
            "regEng": "/Your (?:children|kids) want you to play with them/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u043F\u043E\u043A\u0443\u043F\u0430\u0435\u0442 \u043D\u043E\u0432\u044B\u0435 \u043F\u043B\u0430\u0442\u044C\u044F",
            "eng": "She often buys new dresses",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0430 \u043A\u0443\u043F\u0438\u043B\u0430 \u043D\u043E\u0432\u043E\u0435 \u043F\u043B\u0430\u0442\u044C\u0435",
            "eng": "Yesterday she bought a new dress",
            "regEng": "/(?:Yesterday she bought a new dress)|(?:She bought a new dress yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043E\u043D\u0430 \u043A\u0443\u043F\u0438\u0442 \u043D\u043E\u0432\u043E\u0435 \u043F\u043B\u0430\u0442\u044C\u0435",
            "eng": "Tomorrow she will buy a new dress",
            "regEng": "/(?:Tomorrow (?:she will|she\u2019ll) buy a new dress)/gm"
        },
        {
            "rus": "\u041C\u044B \u0447\u0438\u0442\u0430\u0435\u043C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u0433\u0430\u0437\u0435\u0442\u044B \u043A\u0430\u0436\u0434\u0443\u044E \u043D\u0435\u0434\u0435\u043B\u044E",
            "eng": "We read interesting newspapers every week",
            "regEng": "/(?:We read interesting newspapers every week)|(?:Every week we read interesting newspapers)/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043C\u044B \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0443\u044E \u0433\u0430\u0437\u0435\u0442\u0443",
            "eng": "Yesterday we read an interesting newspaper",
            "regEng": "/(?:Yesterday we read an interesting newspaper)|(?:We read an interesting newspaper yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043C\u044B \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0435\u043C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0443\u044E \u0433\u0430\u0437\u0435\u0442\u0443",
            "eng": "Tomorrow we will read an interesting newspaper",
            "regEng": "/(?:Tomorrow (?:we will|we\u2019ll) read an interesting newspaper)|(?:(?:We will|We\u2019ll) read an interesting newspaper tomorrow)/gm"
        },
        {
            "rus": "\u042F \u0432\u0441\u0435\u0433\u0434\u0430 \u0432\u0438\u0436\u0443 \u044D\u0442\u043E\u0433\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430 \u0437\u0434\u0435\u0441\u044C",
            "eng": "I always see this person here",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u044F \u0432\u0438\u0434\u0435\u043B \u044D\u0442\u043E\u0433\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430 \u0437\u0434\u0435\u0441\u044C",
            "eng": "Yesterday I saw this person here",
            "regEng": "/(?:Yesterday I saw this person here)|(?:I saw this person here yesterday)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u044F \u0443\u0432\u0438\u0436\u0443 \u044D\u0442\u043E\u0433\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430 \u0437\u0434\u0435\u0441\u044C",
            "eng": "Tomorrow I will see this person here",
            "regEng": "/(?:Tomorrow (?:I will|I\u2019ll) see this person here)|(?:(?:I will|I\u2019ll) see this person here tomorrow)/gm"
        }
    ],
    [
        {
            "rus": "\u0423 \u044D\u0442\u043E\u0439 \u0441\u0435\u043C\u044C\u0438 \u043E\u0433\u0440\u043E\u043C\u043D\u044B\u0439 \u0434\u043E\u043C",
            "eng": "This family has a huge house",
            "regEng": ""
        },
        {
            "rus": "\u0423 \u0442\u0435\u0431\u044F \u0442\u0430\u043A\u0438\u0435 \u0431\u0435\u043B\u044B\u0435 \u0437\u0443\u0431\u044B!",
            "eng": "You have such white teeth!",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0445\u043E\u0442\u044F\u0442 \u0441\u043B\u0443\u0448\u0430\u0442\u044C \u043C\u0435\u043D\u044F",
            "eng": "They never want to listen to me",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043C\u0430\u043B\u044C\u0447\u0438\u043A\u0438 \u0438\u043D\u043E\u0433\u0434\u0430 \u043F\u0440\u0438\u0445\u043E\u0434\u044F\u0442 \u0441\u044E\u0434\u0430, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0438\u0433\u0440\u0430\u0442\u044C \u0432 \u0444\u0443\u0442\u0431\u043E\u043B",
            "eng": "These boys sometimes come here to play football",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0439 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u043F\u043E\u0441\u0435\u0449\u0430\u0442\u044C \u044D\u0442\u0438 \u0447\u0443\u0434\u0435\u0441\u043D\u044B\u0435 \u0441\u0442\u0440\u0430\u043D\u044B \u043A\u0430\u0436\u0434\u044B\u0439 \u0433\u043E\u0434",
            "eng": "She likes to visit these wonderful countries every year",
            "regEng": "/(?:She likes to visit these wonderful countries every year)|(?:Every year she likes to visit these wonderful countries)/gm"
        },
        {
            "rus": "\u0423 \u043A\u043E\u0433\u043E \u0435\u0441\u0442\u044C \u0441\u043B\u043E\u0436\u043D\u044B\u0439 \u0432\u043E\u043F\u0440\u043E\u0441?",
            "eng": "Who has a difficult question?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u043F\u044C\u0451\u0442 \u0437\u0435\u043B\u0451\u043D\u044B\u0439 \u0447\u0430\u0439",
            "eng": "She often drinks green tea",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0423 \u043C\u0435\u043D\u044F \u0435\u0441\u0442\u044C \u043E\u0442\u043B\u0438\u0447\u043D\u044B\u0439 \u043F\u043E\u0434\u0430\u0440\u043E\u043A \u0434\u043B\u044F \u0442\u0435\u0431\u044F",
            "eng": "I have an excellent present for you",
            "regEng": "/I have an excellent (?:present|gift) for you/gm"
        },
        {
            "rus": "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u043E\u0431\u044B\u0447\u043D\u043E \u0441\u043C\u043E\u0442\u0440\u044F\u0442 \u0442\u0430\u043A\u0438\u0435 \u0444\u0438\u043B\u044C\u043C\u044B",
            "eng": "Men usually watch such films",
            "regEng": "/Men usually watch such (?:films|movies)/gm"
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u0437\u043D\u0430\u0442\u044C \u0432\u0430\u0448\u0438 \u0438\u043C\u0435\u043D\u0430",
            "eng": "I need to know your names",
            "regEng": ""
        },
        {
            "rus": "\u041A\u0442\u043E \u043F\u043E\u043C\u043D\u0438\u0442 \u0442\u0443 \u043A\u0440\u0430\u0441\u0438\u0432\u0443\u044E \u0434\u0435\u0432\u0443\u0448\u043A\u0443?",
            "eng": "Who remembers that beautiful girl?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u0434\u0435\u0442\u0438 \u0440\u0435\u0434\u043A\u043E \u0438\u0433\u0440\u0430\u044E\u0442 \u0432 \u0442\u0430\u043A\u0438\u0435 \u0438\u0433\u0440\u044B",
            "eng": "These children rarely play such games",
            "regEng": "/These (?:children|kids) (?:rarely|seldom) play such games/gm"
        },
        {
            "rus": "\u042F \u0445\u043E\u0447\u0443 \u0434\u0430\u0442\u044C \u0432\u0430\u043C \u043F\u0440\u043E\u0441\u0442\u043E\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435",
            "eng": "I want to give you a simple solution",
            "regEng": ""
        },
        {
            "rus": "\u0423 \u043D\u0435\u0433\u043E \u0442\u0430\u043A\u0438\u0435 \u043E\u0433\u0440\u043E\u043C\u043D\u044B\u0435 \u0441\u0442\u0443\u043F\u043D\u0438!",
            "eng": "He has such huge feet!",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0441\u043B\u0443\u0448\u0430\u0442\u044C \u044D\u0442\u0438 \u0447\u0443\u0434\u0435\u0441\u043D\u044B\u0435 \u0441\u043B\u043E\u0432\u0430",
            "eng": "We like to listen to these wonderful words",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0442\u044B \u043F\u043E\u0448\u0451\u043B \u0442\u0443\u0434\u0430 \u0437\u0430\u0432\u0442\u0440\u0430",
            "eng": "I need you to go there tomorrow",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u043A\u0443\u043F\u0438\u043B\u0438 \u0435\u0439 \u043D\u043E\u0432\u043E\u0435 \u043F\u043B\u0430\u0442\u044C\u0435",
            "eng": "She wants us to buy her a new dress",
            "regEng": ""
        },
        {
            "rus": "\u0414\u0435\u0442\u044F\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0438\u0445 \u0440\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u0440\u0430\u0437\u0433\u043E\u0432\u0430\u0440\u0438\u0432\u0430\u043B\u0438 \u0441 \u043D\u0438\u043C\u0438",
            "eng": "Children need their parents to talk to them",
            "regEng": "/(?:Children|Kids) need their parents to (?:talk|speak) (?:to|with) them/gm"
        },
        {
            "rus": "\u041C\u044B \u0445\u043E\u0442\u0438\u043C, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u043E\u043A\u0430\u0437\u0430\u043B\u0438 \u043D\u0430\u043C \u0442\u0443 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443",
            "eng": "We want you to show us that picture",
            "regEng": ""
        },
        {
            "rus": "\u0415\u043C\u0443 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u044D\u0442\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u043F\u0440\u0438\u0448\u0451\u043B \u0441\u044E\u0434\u0430 \u0437\u0430\u0432\u0442\u0440\u0430",
            "eng": "He needs this person to come here tomorrow",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0438 \u0445\u043E\u0442\u044F\u0442, \u0447\u0442\u043E\u0431\u044B \u044F \u0441\u0434\u0435\u043B\u0430\u043B \u044D\u0442\u043E \u0434\u043B\u044F \u043D\u0438\u0445",
            "eng": "They want me to do it for them",
            "regEng": "/They want me to do (?:it|that) for them/gm"
        }
    ],
    [
        {
            "rus": "\u042F \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u0440\u0438\u0445\u043E\u0436\u0443 \u0441\u044E\u0434\u0430 \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0441\u0435\u0445 \u0441\u0432\u043E\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439",
            "eng": "I usually come here on Monday to see all my friends",
            "regEng": "/(?:I usually come here on Monday to see all my friends)|(?:On Monday I usually come here to see all my friends)|(?:I usually come here to see all my friends on Monday)/gm"
        },
        {
            "rus": "\u042F \u043F\u0440\u0438\u0448\u0451\u043B \u0441\u044E\u0434\u0430 \u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0441\u0435\u0445 \u0441\u0432\u043E\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439",
            "eng": "I came here last Monday to see all my friends",
            "regEng": "/(?:I came here last Monday to see all my friends)|(?:Last Monday I came here to see all my friends)|(?:I came here to see all my friends last Monday)/gm"
        },
        {
            "rus": "\u042F \u043F\u0440\u0438\u0434\u0443 \u0441\u044E\u0434\u0430 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0441\u0435\u0445 \u0441\u0432\u043E\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439",
            "eng": "I will come here next Monday to see all my friends",
            "regEng": ""
        },
        {
            "rus": "\u041C\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u043F\u0440\u0438\u043D\u043E\u0441\u0438\u043C \u0442\u0435\u0431\u0435 \u044D\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0432\u043E \u0432\u0442\u043E\u0440\u043D\u0438\u043A",
            "eng": "We always bring you these documents on Tuesday",
            "regEng": ""
        },
        {
            "rus": "\u041C\u044B \u043F\u0440\u0438\u043D\u0435\u0441\u043B\u0438 \u0442\u0435\u0431\u0435 \u044D\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 \u0432\u0442\u043E\u0440\u043D\u0438\u043A",
            "eng": "We brought you these documents last Tuesday",
            "regEng": ""
        },
        {
            "rus": "\u041C\u044B \u043F\u0440\u0438\u043D\u0435\u0441\u0451\u043C \u0442\u0435\u0431\u0435 \u044D\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0432\u0442\u043E\u0440\u043D\u0438\u043A",
            "eng": "We will bring you these documents next Tuesday",
            "regEng": "/(?:We will|We\u2019ll) bring you these documents next Tuesday/gm"
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u0447\u0430\u0441\u0442\u043E \u0435\u0437\u0434\u0438\u043C \u0432 \u044D\u0442\u043E \u043C\u0435\u0441\u0442\u043E \u0432 \u0444\u0435\u0432\u0440\u0430\u043B\u0435",
            "eng": "We often go to this place in February",
            "regEng": "/(?:We often go to this place in February)|(?:In February we often go to this place)/gm"
        },
        {
            "rus": "\u041C\u044B \u0441\u044A\u0435\u0437\u0434\u0438\u043B\u0438 \u0432 \u044D\u0442\u043E \u043C\u0435\u0441\u0442\u043E \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u0444\u0435\u0432\u0440\u0430\u043B\u0435",
            "eng": "We went to this place last February",
            "regEng": "/(?:We went to this place last February)|(?:Last February we went to this place)/gm"
        },
        {
            "rus": "\u041C\u044B \u0441\u044A\u0435\u0437\u0434\u0438\u043C \u0432 \u044D\u0442\u043E \u043C\u0435\u0441\u0442\u043E \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0444\u0435\u0432\u0440\u0430\u043B\u0435",
            "eng": "We will go to this place next February",
            "regEng": "/(?:(?:We will|We\u2019ll) go to this place next February)|(?:Next February (?:we will|we\u2019ll) go to this place)/gm"
        },
        {
            "rus": "\u041E\u043D \u043E\u0431\u044B\u0447\u043D\u043E \u0445\u043E\u0434\u0438\u0442 \u0432 \u043C\u0443\u0437\u0435\u0438 \u0432 \u044F\u043D\u0432\u0430\u0440\u0435",
            "eng": "He usually goes to museums in January",
            "regEng": "/(?:He usually goes to museums in January)|(?:In January he usually goes to museums)/gm"
        },
        {
            "rus": "\u041E\u043D \u0441\u0445\u043E\u0434\u0438\u043B \u0432 \u044D\u0442\u043E\u0442 \u043C\u0443\u0437\u0435\u0439 \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u044F\u043D\u0432\u0430\u0440\u0435",
            "eng": "He went to this museum last January",
            "regEng": "/(?:He went to this museum last January)|(?:Last January he went to this museum)/gm"
        },
        {
            "rus": "\u041E\u043D \u0441\u0445\u043E\u0434\u0438\u0442 \u0432 \u044D\u0442\u043E\u0442 \u043C\u0443\u0437\u0435\u0439 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u044F\u043D\u0432\u0430\u0440\u0435",
            "eng": "He will go to this museum next January",
            "regEng": "/(?:He will|He\u2019ll) go to this museum next January/gm"
        }
    ],
    [
        {
            "rus": "\u043E\u043D\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u043D\u0430\u0447\u0438\u043D\u0430\u044E\u0442 \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442 \u0432\u0435\u0441\u043D\u043E\u0439",
            "eng": "They always start a new project in spring",
            "regEng": "/(?:They always (?:start|begin) a new project in spring)|(?:In spring they always (?:start|begin) a new project)/gm"
        },
        {
            "rus": "\u043E\u043D\u0438 \u043D\u0430\u0447\u0430\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442 \u043F\u0440\u043E\u0448\u043B\u043E\u0439 \u0432\u0435\u0441\u043D\u043E\u0439",
            "eng": "They started a new project last spring",
            "regEng": "/(?:They (?:started|began) a new project last spring)|(?:Last spring they (?:started|began) a new project)/gm"
        },
        {
            "rus": "\u043E\u043D\u0438 \u043D\u0430\u0447\u043D\u0443\u0442 \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u0432\u0435\u0441\u043D\u043E\u0439",
            "eng": "They will start a new project next spring",
            "regEng": "/(?:(?:They will|They\u2019ll) (?:start|begin) a new project next spring)|(?:Next spring (?:they will|they\u2019ll) (?:start|begin) a new project)/gm"
        },
        {
            "rus": "\u043E\u043D\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u044E\u0442 \u0441\u0432\u043E\u044E \u0440\u0430\u0431\u043E\u0442\u0443 \u043B\u0435\u0442\u043E\u043C",
            "eng": "They always finish their work in summer",
            "regEng": "/(?:They always finish their work in summer)|(?:In summer they always finish their work)/gm"
        },
        {
            "rus": "\u043E\u043D\u0438 \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0438 \u0441\u0432\u043E\u044E \u0440\u0430\u0431\u043E\u0442\u0443 \u043F\u0440\u043E\u0448\u043B\u044B\u043C \u043B\u0435\u0442\u043E\u043C",
            "eng": "They finished their work last summer",
            "regEng": "/(?:They finished their work last summer)|(?:Last summer they finished their work)/gm"
        },
        {
            "rus": "\u043E\u043D\u0438 \u0437\u0430\u043A\u043E\u043D\u0447\u0430\u0442 \u0441\u0432\u043E\u044E \u0440\u0430\u0431\u043E\u0442\u0443 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043B\u0435\u0442\u043E\u043C",
            "eng": "They will finish their work next summer",
            "regEng": "/(?:(?:They will|They\u2019ll) finish their work next summer)|(?:Next summer (?:they will|they\u2019ll) finish their work)/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0430 \u043E\u0431\u044B\u0447\u043D\u043E \u0435\u0437\u0434\u0438\u0442 \u0432 \u044D\u0442\u043E\u0442 \u0433\u043E\u0440\u043E\u0434 \u0432 \u043F\u044F\u0442\u043D\u0438\u0446\u0443",
            "eng": "She usually goes to this city on Friday",
            "regEng": "/(?:She usually goes to this city on Friday)|(?:On Friday she usually goes to this city)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043F\u043E\u0435\u0445\u0430\u043B\u0430 \u0432 \u044D\u0442\u043E\u0442 \u0433\u043E\u0440\u043E\u0434 \u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E \u043F\u044F\u0442\u043D\u0438\u0446\u0443",
            "eng": "She went to this city last Friday",
            "regEng": "/(?:She went to this city last Friday)|(?:Last Friday she went to this city)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043F\u043E\u0435\u0434\u0435\u0442 \u0432 \u044D\u0442\u043E\u0442 \u0433\u043E\u0440\u043E\u0434 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u043F\u044F\u0442\u043D\u0438\u0446\u0443",
            "eng": "She will go to this city next Friday",
            "regEng": "/(?:(?:She will|She\u2019ll) go to this city next Friday)|(?:Next Friday (?:she will|she\u2019ll) go to this city)/gm"
        },
        {
            "rus": "\u041C\u044B \u0438\u043D\u043E\u0433\u0434\u0430 \u0438\u0433\u0440\u0430\u0435\u043C \u0432 \u0442\u0435\u043D\u043D\u0438\u0441 \u0432 \u0441\u0440\u0435\u0434\u0443",
            "eng": "We sometimes play tennis on Wednesday",
            "regEng": "/(?:We sometimes play tennis on Wednesday)|(?:On Wednesday we sometimes play tennis)/gm"
        },
        {
            "rus": "\u041C\u044B \u0438\u0433\u0440\u0430\u043B\u0438 \u0432 \u0442\u0435\u043D\u043D\u0438\u0441 \u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E \u0441\u0440\u0435\u0434\u0443",
            "eng": "We played tennis last Wednesday",
            "regEng": "/(?:We played tennis last Wednesday)|(?:Last Wednesday We played tennis)/gm"
        },
        {
            "rus": "\u041C\u044B \u043F\u043E\u0438\u0433\u0440\u0430\u0435\u043C \u0432 \u0442\u0435\u043D\u043D\u0438\u0441 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0441\u0440\u0435\u0434\u0443",
            "eng": "We will play tennis next Wednesday",
            "regEng": "/(?:(?:We will|We\u2019ll) play tennis next Wednesday)|(?:Next Wednesday (?:we will|we\u2019ll) play tennis)/gm"
        }
    ],
    [
        {
            "rus": "\u042F \u0445\u043E\u0447\u0443, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u043F\u043E-\u0430\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u0438",
            "eng": "I want you to speak English",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438\u043C \u043B\u044E\u0434\u044F\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u0441 \u043D\u0438\u043C\u0438",
            "eng": "These people need us to talk to them",
            "regEng": "/These people need us to (?:talk|speak) (?:to|with) them/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u044F \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u043B\u0441\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "She wants me to exercise every day",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E\u043C\u0443 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0443 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0438 \u043F\u043E\u043C\u043D\u0438\u043B\u0438 \u0442\u0435 \u0441\u043B\u043E\u0432\u0430",
            "eng": "This person needs them to remember those words",
            "regEng": ""
        },
        {
            "rus": "\u0420\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u0445\u043E\u0442\u044F\u0442, \u0447\u0442\u043E\u0431\u044B \u0438\u0445 \u0434\u0435\u0442\u0438 \u0435\u043B\u0438 \u0445\u043E\u0440\u043E\u0448\u0443\u044E \u0435\u0434\u0443",
            "eng": "Parents want their children to eat good food",
            "regEng": "/Parents want their (?:children|kids) to eat good food/gm"
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0430 \u0441\u043B\u0443\u0448\u0430\u043B\u0430 \u043D\u0430\u0441",
            "eng": "We need her to listen to us",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041E\u043D \u0447\u0430\u0441\u0442\u043E \u0435\u0437\u0434\u0438\u0442 \u0432 \u044D\u0442\u0438 \u0443\u0434\u0438\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0441\u0442\u0440\u0430\u043D\u044B \u0437\u0438\u043C\u043E\u0439",
            "eng": "He often goes to these amazing countries in winter",
            "regEng": "/(?:He often goes to these amazing countries in winter)|(?:In winter he often goes to these amazing countries)/gm"
        },
        {
            "rus": "\u041E\u043D \u0441\u044A\u0435\u0437\u0434\u0438\u043B \u0432 \u044D\u0442\u0438 \u0443\u0434\u0438\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0441\u0442\u0440\u0430\u043D\u044B \u043F\u0440\u043E\u0448\u043B\u043E\u0439 \u0437\u0438\u043C\u043E\u0439",
            "eng": "He went to these amazing countries last winter",
            "regEng": "/(?:He went to these amazing countries last winter)|(?:Last winter he went to these amazing countries)/gm"
        },
        {
            "rus": "\u041E\u043D \u0441\u044A\u0435\u0437\u0434\u0438\u0442 \u0432 \u044D\u0442\u0438 \u0443\u0434\u0438\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0441\u0442\u0440\u0430\u043D\u044B \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u0437\u0438\u043C\u043E\u0439",
            "eng": "He will go to these amazing countries next winter",
            "regEng": "/(?:(?:He will|He\u2019ll) go to these amazing countries next winter)|(?:Next winter (?:he will|he\u2019ll) go to these amazing countries)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u043F\u043E\u043A\u0443\u043F\u0430\u044E\u0442 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043A\u043D\u0438\u0433\u0438 \u0432 \u0438\u044E\u043D\u0435",
            "eng": "They always buy interesting books in June",
            "regEng": "/(?:They always buy interesting books in June)|(?:In June they always buy interesting books)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043A\u0443\u043F\u0438\u043B\u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0443\u044E \u043A\u043D\u0438\u0433\u0443 \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u0438\u044E\u043D\u0435",
            "eng": "They bought an interesting book last June",
            "regEng": "/(?:They bought an interesting book last June)|(?:Last June they bought an interesting book)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043A\u0443\u043F\u044F\u0442 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0443\u044E \u043A\u043D\u0438\u0433\u0443 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0438\u044E\u043D\u0435",
            "eng": "They will buy an interesting book next June",
            "regEng": "/(?:They will buy an interesting book next June)|(?:Next June they will buy an interesting book)/gm"
        }
    ],
    [
        {
            "rus": "\u042F \u043E\u0431\u044B\u0447\u043D\u043E \u043D\u043E\u0448\u0443 \u044D\u0442\u0438 \u0442\u0443\u0444\u043B\u0438 \u0432 \u0441\u0443\u0431\u0431\u043E\u0442\u0443",
            "eng": "I usually wear these shoes on Saturday",
            "regEng": "/(?:I usually wear these shoes on Saturday)|(?:On Saturday I usually wear these shoes)/gm"
        },
        {
            "rus": "\u042F \u043D\u043E\u0441\u0438\u043B \u044D\u0442\u0438 \u0442\u0443\u0444\u043B\u0438 \u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E \u0441\u0443\u0431\u0431\u043E\u0442\u0443",
            "eng": "I wore these shoes last Saturday",
            "regEng": "/(?:I wore these shoes last Saturday)|(?:Last Saturday I wore these shoes)/gm"
        },
        {
            "rus": "\u042F \u0431\u0443\u0434\u0443 \u043D\u043E\u0441\u0438\u0442\u044C \u044D\u0442\u0438 \u0442\u0443\u0444\u043B\u0438 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0441\u0443\u0431\u0431\u043E\u0442\u0443",
            "eng": "I will wear these shoes next Saturday",
            "regEng": "/(?:(?:I will|I\u2019ll) wear these shoes next Saturday)|(?:Next Saturday (?:I will|I\u2019ll) wear these shoes)/gm"
        },
        {
            "rus": "\u041C\u044B \u0438\u043D\u043E\u0433\u0434\u0430 \u0445\u043E\u0434\u0438\u043C \u0432 \u0442\u0430\u043A\u0438\u0435 \u0447\u0443\u0434\u0435\u0441\u043D\u044B\u0435 \u043C\u0435\u0441\u0442\u0430 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0433",
            "eng": "We sometimes go to such wonderful places on Thursday",
            "regEng": "/(?:We sometimes go to such wonderful places on Thursday)|(?:On Thursday we sometimes go to such wonderful places)/gm"
        },
        {
            "rus": "\u041C\u044B \u0445\u043E\u0434\u0438\u043B\u0438 \u0432 \u0442\u0430\u043A\u043E\u0435 \u0447\u0443\u0434\u0435\u0441\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0433",
            "eng": "We went to such a wonderful place last Thursday",
            "regEng": "/(?:We went to such a wonderful place last Thursday)|(?:Last Thursday we went to such a wonderful place)/gm"
        },
        {
            "rus": "\u041C\u044B \u043F\u043E\u0439\u0434\u0451\u043C \u0432 \u0442\u0430\u043A\u043E\u0435 \u0447\u0443\u0434\u0435\u0441\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0433",
            "eng": "We will go to such a wonderful place next Thursday",
            "regEng": "/(?:We will go to such a wonderful place next Thursday)|(?:Next Thursday we will go to such a wonderful place)/gm"
        }
    ],
    [
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043C\u044B \u0434\u0430\u0434\u0438\u043C \u0432\u0430\u043C \u043E\u0442\u043B\u0438\u0447\u043D\u0443\u044E \u0438\u0434\u0435\u044E",
            "eng": "Tomorrow we will give you an excellent idea",
            "regEng": "/(?:Tomorrow we will give you an excellent idea)|(?:We will give you an excellent idea tomorrow)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043D\u043E\u0441\u0438\u0442 \u0434\u043B\u0438\u043D\u043D\u044B\u0445 \u044E\u0431\u043E\u043A",
            "eng": "She never wears long skirts",
            "regEng": ""
        },
        {
            "rus": "\u041C\u043E\u0438 \u0434\u0440\u0443\u0437\u044C\u044F \u0440\u0435\u0434\u043A\u043E \u0441\u043C\u043E\u0442\u0440\u044F\u0442 \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u043E\u0440",
            "eng": "My friends rarely watch TV",
            "regEng": "/My friends (?:seldom|rarely) watch TV/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D \u0438\u0433\u0440\u0430\u043B \u0432 \u0442\u0435\u043D\u043D\u0438\u0441 \u0441 \u043C\u043E\u0438\u043C \u0441\u044B\u043D\u043E\u043C",
            "eng": "Yesterday he played tennis with my son",
            "regEng": "/(?:Yesterday he played tennis with my son)|(?:He played tennis with my son yesterday)/gm"
        },
        {
            "rus": "\u041C\u044B \u0445\u043E\u0442\u0438\u043C, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0438 \u043F\u0440\u0438\u0448\u043B\u0438 \u0441\u044E\u0434\u0430 \u0437\u0430\u0432\u0442\u0440\u0430",
            "eng": "We want them to come here tomorrow",
            "regEng": "/(?:We want them to come here tomorrow)|(?:Tomorrow we want them to come here)/gm"
        },
        {
            "rus": "\u0423 \u043C\u0435\u043D\u044F \u0442\u0430\u043A\u0430\u044F \u0443\u0434\u0438\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0438 \u0441\u0447\u0430\u0441\u0442\u043B\u0438\u0432\u0430\u044F \u0436\u0438\u0437\u043D\u044C!",
            "eng": "I have such an amazing and happy life!",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043F\u0440\u0438\u043D\u0435\u0441\u043B\u0438 \u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0432\u0447\u0435\u0440\u0430",
            "eng": "These men brought those documents yesterday",
            "regEng": "/(?:These men brought those documents yesterday)|(?:Yesterday these men brought those documents)/gm"
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043F\u0438\u0448\u0435\u043C \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0445 \u043F\u0438\u0441\u0435\u043C",
            "eng": "We never write short letters",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0438 \u0435\u0451 \u0432\u0430\u0436\u043D\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0432\u0447\u0435\u0440\u0430",
            "eng": "They read her important message yesterday",
            "regEng": "/(?:They read her important message yesterday)|(?:Yesterday they read her important message)/gm"
        },
        {
            "rus": "\u0423 \u044D\u0442\u0438\u0445 \u0436\u0435\u043D\u0449\u0438\u043D \u0437\u0434\u043E\u0440\u043E\u0432\u044B\u0435 \u0438 \u043A\u0440\u0430\u0441\u0438\u0432\u044B\u0435 \u0442\u0435\u043B\u0430",
            "eng": "These women have healthy and beautiful bodies",
            "regEng": ""
        },
        {
            "rus": "\u0423 \u043D\u0435\u0451 \u0435\u0441\u0442\u044C \u0434\u043E\u0440\u043E\u0433\u043E\u0435 \u043A\u0440\u0430\u0441\u043D\u043E\u0435 \u043F\u043B\u0430\u0442\u044C\u0435",
            "eng": "She has an expensive red dress",
            "regEng": ""
        },
        {
            "rus": "\u042F \u0432\u0438\u0434\u0435\u043B \u0432\u0430\u0448\u0443 \u0434\u043E\u0447\u044C \u0432\u0447\u0435\u0440\u0430",
            "eng": "I saw your daughter yesterday",
            "regEng": "/(?:I saw your daughter yesterday)|(?:Yesterday I saw your daughter)/gm"
        },
        {
            "rus": "\u042D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u0442\u0430\u0440\u0430\u0435\u0442\u0441\u044F \u0431\u044B\u0442\u044C \u0434\u0440\u0443\u0436\u0435\u043B\u044E\u0431\u043D\u043E\u0439",
            "eng": "This woman always tries to be friendly",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0438 \u043A\u0443\u043F\u0438\u043B\u0438 \u043D\u043E\u0432\u0443\u044E \u0431\u043E\u043B\u044C\u0448\u0443\u044E \u0441\u0443\u043C\u043A\u0443",
            "eng": "Yesterday they bought a new big bag",
            "regEng": "/(?:Yesterday they bought a new (?:big|large) bag)|(?:They bought a new (?:big|large) bag yesterday)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u0440\u0435\u0431\u0451\u043D\u043E\u043A \u0445\u043E\u0447\u0435\u0442 \u043D\u0430\u0439\u0442\u0438 \u043D\u043E\u0432\u044B\u0445 \u0434\u0440\u0443\u0437\u0435\u0439",
            "eng": "This child wants to find new friends",
            "regEng": "/This (?:child|kid) wants to find new friends/gm"
        }
    ],
    [
        {
            "rus": "\u0412 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A \u044F \u043E\u0431\u044B\u0447\u043D\u043E \u0435\u0437\u0436\u0443 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0435",
            "eng": "On Monday I usually go to work by bus",
            "regEng": "/(?:On Monday I usually go to work by bus)|(?:I usually go to work by bus on Monday)/gm"
        },
        {
            "rus": "\u0412 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A \u044F \u043F\u043E\u0435\u0445\u0430\u043B \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0442\u0430\u043A\u0441\u0438",
            "eng": "Last Monday I went to work by taxi",
            "regEng": "/(?:Last Monday I went to work by taxi)|(?:I went to work by taxi last Monday)/gm"
        },
        {
            "rus": "\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A \u044F \u043F\u043E\u0435\u0434\u0443 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435",
            "eng": "Next Monday I will go to work by train",
            "regEng": "/(?:Next Monday (?:I will|I\u2019ll) go to work by train)|(?:(?:I will|I\u2019ll) go to work by train next Monday)/gm"
        },
        {
            "rus": "\u0412 \u043F\u044F\u0442\u043D\u0438\u0446\u0443 \u043E\u043D\u0438 \u0440\u0435\u0434\u043A\u043E \u0435\u0437\u0434\u044F\u0442 \u0432 \u0431\u043E\u043B\u044C\u043D\u0438\u0446\u0443 \u043D\u0430 \u0442\u0440\u0430\u043C\u0432\u0430\u0435",
            "eng": "On Friday they rarely go to hospital by tram",
            "regEng": "/(?:On Friday they (?:rarely|seldom) go to hospital by tram)|(?:They (?:rarely|seldom) go to hospital by tram on Friday)/gm"
        },
        {
            "rus": "\u0412 \u043F\u0440\u043E\u0448\u043B\u0443\u044E \u043F\u044F\u0442\u043D\u0438\u0446\u0443 \u043E\u043D\u0438 \u043F\u043E\u0435\u0445\u0430\u043B\u0438 \u0432 \u0431\u043E\u043B\u044C\u043D\u0438\u0446\u0443 \u043D\u0430 \u0432\u0435\u043B\u043E\u0441\u0438\u043F\u0435\u0434\u0435",
            "eng": "Last Friday they went to hospital by bicycle",
            "regEng": "/(?:Last Friday they went to hospital by bicycle)|(?:They went to hospital by bicycle last Friday)/gm"
        },
        {
            "rus": "\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u043F\u044F\u0442\u043D\u0438\u0446\u0443 \u043E\u043D\u0438 \u043F\u043E\u0435\u0434\u0443\u0442 \u0432 \u0431\u043E\u043B\u044C\u043D\u0438\u0446\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0435",
            "eng": "Next Friday they will go to hospital by bus",
            "regEng": "/(?:Next Friday (?:they will|They\u2019ll) go to hospital by bus)|(?:(?:They will|They\u2019ll) go to hospital by bus next Friday)/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u0441\u0435\u043D\u044C\u044E \u043E\u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u0435\u0437\u0434\u0438\u0442 \u0432 \u0448\u043A\u043E\u043B\u0443 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0435",
            "eng": "In autumn she often goes to school by car",
            "regEng": "/(?:In autumn she often goes to school by car)|(?:She often goes to school by car in autumn)/gm"
        },
        {
            "rus": "\u041F\u0440\u043E\u0448\u043B\u043E\u0439 \u043E\u0441\u0435\u043D\u044C\u044E \u043E\u043D\u0430 \u043F\u043E\u0435\u0445\u0430\u043B\u0430 \u0432 \u0448\u043A\u043E\u043B\u0443 \u043D\u0430 \u0432\u0435\u043B\u043E\u0441\u0438\u043F\u0435\u0434\u0435",
            "eng": "Last autumn she went to school by bicycle",
            "regEng": "/(?:Last autumn she went to school by bicycle)|(?:She went to school by bicycle last autumn)/gm"
        },
        {
            "rus": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u043E\u0441\u0435\u043D\u044C\u044E \u043E\u043D\u0430 \u043F\u043E\u0435\u0434\u0435\u0442 \u0432 \u0448\u043A\u043E\u043B\u0443 \u043D\u0430 \u0442\u0440\u0430\u043C\u0432\u0430\u0435",
            "eng": "Next autumn she will go to school by tram",
            "regEng": "/(?:Next autumn (?:she will|she\u2019ll) go to school by tram)|(?:(?:She will|She\u2019ll) go to school by tram next autumn)/gm"
        },
        {
            "rus": "\u0412\u0435\u0441\u043D\u043E\u0439 \u0432\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u0435\u0437\u0434\u0438\u0442\u0435 \u0432 \u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0438\u0442\u0435\u0442 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435",
            "eng": "In spring you always go to university by train",
            "regEng": "/(?:In spring you always go to university by train)|(?:You always go to university by train In spring)/gm"
        },
        {
            "rus": "\u041F\u0440\u043E\u0448\u043B\u043E\u0439 \u0432\u0435\u0441\u043D\u043E\u0439 \u0432\u044B \u043F\u043E\u0448\u043B\u0438 \u0432 \u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0438\u0442\u0435\u0442 \u043F\u0435\u0448\u043A\u043E\u043C",
            "eng": "Last spring you went to university on foot",
            "regEng": "/(?:Last spring you went to university on foot)|(?:You went to university on foot last spring)/gm"
        },
        {
            "rus": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u0432\u0435\u0441\u043D\u043E\u0439 \u0432\u044B \u043F\u043E\u0435\u0434\u0435\u0442\u0435 \u0432 \u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0438\u0442\u0435\u0442 \u043D\u0430 \u0442\u0430\u043A\u0441\u0438",
            "eng": "Next spring you will go to university by taxi",
            "regEng": "/(?:Next spring (?:you will|you\u2019ll) go to university by taxi)|(?:(?:You will|You\u2019ll) go to university by taxi next spring)/gm"
        }
    ],
    [
        {
            "rus": "\u0412 \u0438\u044E\u043B\u0435 \u043C\u044B \u0438\u043D\u043E\u0433\u0434\u0430 \u0435\u0437\u0434\u0438\u043C \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043B\u043E\u0434\u043A\u0435",
            "eng": "In July we sometimes go home by boat",
            "regEng": "/(?:In July we sometimes go home by boat)|(?:We sometimes go home by boat in July)/gm"
        },
        {
            "rus": "\u0412 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u0438\u044E\u043B\u0435 \u043C\u044B \u043F\u043E\u0435\u0445\u0430\u043B\u0438 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u0441\u0430\u043C\u043E\u043B\u0435\u0442\u0435",
            "eng": "Last July we went home by plane",
            "regEng": "/(?:Last July we went home by plane)|(?:We went home by plane last July)/gm"
        },
        {
            "rus": "\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0438\u044E\u043B\u0435 \u043C\u044B \u043F\u043E\u0439\u0434\u0451\u043C \u0434\u043E\u043C\u043E\u0439 \u043F\u0435\u0448\u043A\u043E\u043C",
            "eng": "Next July we will go home on foot",
            "regEng": "/(?:Next July we will go home on foot)|(?:We will go home on foot next July)/gm"
        },
        {
            "rus": "\u0412 \u0430\u0432\u0433\u0443\u0441\u0442\u0435 \u043E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0435\u0437\u0434\u0438\u0442 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0435",
            "eng": "In August she always goes home by bus",
            "regEng": "/(?:In August she always goes home by bus)|(?:She always goes home by bus in August)/gm"
        },
        {
            "rus": "\u0412 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u0430\u0432\u0433\u0443\u0441\u0442\u0435 \u043E\u043D\u0430 \u043F\u043E\u0435\u0445\u0430\u043B\u0430 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435",
            "eng": "Last August she went home by train",
            "regEng": "/(?:Last August she went home by train)|(?:She went home by train last August)/gm"
        },
        {
            "rus": "\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0430\u0432\u0433\u0443\u0441\u0442\u0435 \u043E\u043D\u0430 \u043F\u043E\u0435\u0434\u0435\u0442 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u0432\u0435\u043B\u043E\u0441\u0438\u043F\u0435\u0434\u0435",
            "eng": "Next August she will go home by bicycle",
            "regEng": "/(?:Next August (?:she will|she\u2019ll) go home by bicycle)|(?:(?:She will|She\u2019ll) go home by bicycle next August)/gm"
        }
    ],
    [
        {
            "rus": "\u0422\u044B \u043E\u0431\u044B\u0447\u043D\u043E \u0441\u043C\u043E\u0442\u0440\u0438\u0448\u044C \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u043E\u0440 \u043F\u043E\u0441\u043B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B",
            "eng": "You usually watch TV after work"
        },
        {
            "rus": "\u0422\u044B \u043D\u0435 \u0441\u043C\u043E\u0442\u0440\u0438\u0448\u044C \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u043E\u0440 \u043F\u043E\u0441\u043B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B",
            "eng": "You do not watch TV after work",
            "regEng": "/(?:You (?:do not|don\u2019t) watch TV after work)/gm"
        },
        {
            "rus": "\u0421\u043C\u043E\u0442\u0440\u0438\u0448\u044C \u043B\u0438 \u0442\u044B \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u043E\u0440 \u043F\u043E\u0441\u043B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B?",
            "eng": "Do you watch TV after work?"
        },
        {
            "rus": "\u0427\u0442\u043E \u0442\u044B \u0434\u0435\u043B\u0430\u0435\u0448\u044C \u043F\u043E\u0441\u043B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B?",
            "eng": "What do you do after work?"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0447\u0438\u0442\u0430\u0435\u0442 \u043A\u043D\u0438\u0433\u0443 \u043F\u043E\u0441\u043B\u0435 \u0448\u043A\u043E\u043B\u044B",
            "eng": "She always reads a book after school"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u0447\u0438\u0442\u0430\u0435\u0442 \u043A\u043D\u0438\u0433\u0443 \u043F\u043E\u0441\u043B\u0435 \u0448\u043A\u043E\u043B\u044B",
            "eng": "She does not read a book after school",
            "regEng": "/(?:She (?:does not|doesn\u2019t) read a book after school)/gm"
        },
        {
            "rus": "\u0427\u0438\u0442\u0430\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u043A\u043D\u0438\u0433\u0443 \u043F\u043E\u0441\u043B\u0435 \u0448\u043A\u043E\u043B\u044B?",
            "eng": "Does she read a book after school?"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D\u0430 \u0434\u0435\u043B\u0430\u0435\u0442 \u043F\u043E\u0441\u043B\u0435 \u0448\u043A\u043E\u043B\u044B?",
            "eng": "What does she do after school?"
        }
    ],
    [
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u0442\u044B \u043F\u0440\u0438\u0448\u0435\u043B \u0434\u043E\u043C\u043E\u0439 \u0440\u0430\u043D\u043E",
            "eng": "Yesterday you came home early",
            "regEng": "/(?:Yesterday you came home early)|(?:You came home early yesterday)/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u0442\u044B \u043D\u0435 \u043F\u0440\u0438\u0448\u0435\u043B \u0434\u043E\u043C\u043E\u0439 \u0440\u0430\u043D\u043E",
            "eng": "Yesterday you did not come home early",
            "regEng": "/(?:Yesterday you (?:did not|didn\u2019t) come home early)|(?:You (?:did not|didn\u2019t) come home early yesterday)/gm"
        },
        {
            "rus": "\u041F\u0440\u0438\u0448\u0435\u043B \u043B\u0438 \u0442\u044B \u0434\u043E\u043C\u043E\u0439 \u0440\u0430\u043D\u043E \u0432\u0447\u0435\u0440\u0430?",
            "eng": "Did you come home early yesterday?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u0442\u044B \u043F\u0440\u0438\u0448\u0435\u043B \u0434\u043E\u043C\u043E\u0439 \u0432\u0447\u0435\u0440\u0430?",
            "eng": "When did you come home yesterday?"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D \u0432\u044B\u043F\u0438\u043B \u0432\u0435\u0441\u044C \u043C\u043E\u0439 \u0447\u0430\u0439",
            "eng": "Yesterday he drank all my tea",
            "regEng": "/(?:Yesterday he drank all my tea)|(?:He drank all my tea yesterday)/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D \u043D\u0435 \u0432\u044B\u043F\u0438\u043B \u0432\u0435\u0441\u044C \u043C\u043E\u0439 \u0447\u0430\u0439",
            "eng": "Yesterday he did not drink all my tea",
            "regEng": "/(?:Yesterday he (?:did not|didn\u2019t) drink all my tea)|(?:He (?:did not|didn\u2019t) drink all my tea yesterday)/gm"
        },
        {
            "rus": "\u0412\u044B\u043F\u0438\u043B \u043B\u0438 \u043E\u043D \u0432\u0435\u0441\u044C \u043C\u043E\u0439 \u0447\u0430\u0439 \u0432\u0447\u0435\u0440\u0430?",
            "eng": "Did he drink all my tea yesterday?"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D \u0441\u0434\u0435\u043B\u0430\u043B \u0432\u0447\u0435\u0440\u0430?",
            "eng": "What did he do yesterday?"
        }
    ],
    [
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u0442\u044B \u043F\u043E\u0439\u0434\u0435\u0448\u044C \u0432 \u043A\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u043E",
            "eng": "Tomorrow you will go to bed late",
            "regEng": "/(?:Tomorrow (?:you will|you\u2019ll) go to bed late)|(?:(?:You will|You\u2019ll) go to bed late tomorrow)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u0442\u044B \u043D\u0435 \u043F\u043E\u0439\u0434\u0435\u0448\u044C \u0432 \u043A\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u043E",
            "eng": "Tomorrow you will not go to bed late",
            "regEng": "/(?:Tomorrow you (?:will not|won\u2019t) go to bed late)|(?:You (?:will not|won\u2019t) go to bed late tomorrow)/gm"
        },
        {
            "rus": "\u041F\u043E\u0439\u0434\u0435\u0448\u044C \u043B\u0438 \u0442\u044B \u0432 \u043A\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u043E \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "Will you go to bed late tomorrow?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u0442\u044B \u043F\u043E\u0439\u0434\u0435\u0448\u044C \u0432 \u043A\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "When will you go to bed tomorrow?"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043E\u043D \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442 \u0441\u0432\u043E\u0435\u043C\u0443 \u0434\u0440\u0443\u0433\u0443",
            "eng": "Tomorrow he will call his friend",
            "regEng": "/(?:Tomorrow (?:he will|he\u2019ll) call his friend)|(?:(?:He will|He\u2019ll) call his friend tomorrow)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043E\u043D \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442 \u0441\u0432\u043E\u0435\u043C\u0443 \u0434\u0440\u0443\u0433\u0443",
            "eng": "Tomorrow he will not call his friend",
            "regEng": "/(?:Tomorrow he (?:will not|won\u2019t) call his friend)|(?:He (?:will not|won\u2019t) call his friend tomorrow)/gm"
        },
        {
            "rus": "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442 \u043B\u0438 \u043E\u043D \u0441\u0432\u043E\u0435\u043C\u0443 \u0434\u0440\u0443\u0433\u0443 \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "Will he call his friend tomorrow?"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D \u0441\u0434\u0435\u043B\u0430\u0435\u0442 \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "What will he do tomorrow?"
        }
    ],
    [
        {
            "rus": "\u0412 \u0441\u0440\u0435\u0434\u0443 \u044F \u0447\u0430\u0441\u0442\u043E \u0438\u0434\u0443 \u0434\u043E\u043C\u043E\u0439 \u043F\u0435\u0448\u043A\u043E\u043C",
            "eng": "On Wednesday I often go home on foot",
            "regEng": "/(?:On Wednesday I often go home on foot)|(?:I often go home on foot on Wednesday)/gm"
        },
        {
            "rus": "\u0412 \u043F\u0440\u043E\u0448\u043B\u0443\u044E \u0441\u0440\u0435\u0434\u0443 \u044F \u043F\u043E\u0435\u0445\u0430\u043B \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0435",
            "eng": "Last Wednesday I went home by car",
            "regEng": "/(?:Last Wednesday I went home by car)|(?:I went home by car last Wednesday)/gm"
        },
        {
            "rus": "\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0441\u0440\u0435\u0434\u0443 \u044F \u043F\u043E\u0435\u0434\u0443 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u0442\u0440\u0430\u043C\u0432\u0430\u0435",
            "eng": "Next Wednesday I will go home by tram",
            "regEng": "/(?:Next Wednesday (?:I will|I\u2019ll) go home by tram)|(?:(?:I will|I\u2019ll) go home by tram next Wednesday)/gm"
        },
        {
            "rus": "\u0412 \u0434\u0435\u043A\u0430\u0431\u0440\u0435 \u043E\u043D\u0438 \u0440\u0435\u0434\u043A\u043E \u0435\u0437\u0434\u044F\u0442 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0432\u0435\u043B\u043E\u0441\u0438\u043F\u0435\u0434\u0435",
            "eng": "In December they rarely go to work by bicycle",
            "regEng": "/(?:In December they (?:rarely|seldom) go to work by bicycle)|(?:They (?:rarely|seldom) go to work by bicycle in December)/gm"
        },
        {
            "rus": "\u0412 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 \u0434\u0435\u043A\u0430\u0431\u0440\u044C \u043E\u043D\u0438 \u043F\u043E\u0435\u0445\u0430\u043B\u0438 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0441\u0430\u043C\u043E\u043B\u0435\u0442\u0435",
            "eng": "Last December they went to work by plane",
            "regEng": "/(?:Last December they went to work by (?:air)?plane)|(?:They went to work by (?:air)?plane Last December)/gm"
        },
        {
            "rus": "\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0434\u0435\u043A\u0430\u0431\u0440\u044C \u043E\u043D\u0438 \u043F\u043E\u0435\u0434\u0443\u0442 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043B\u043E\u0434\u043A\u0435",
            "eng": "Next December they will go to work by boat",
            "regEng": "/(?:Next December (?:they will|they\u2019ll) go to work by boat)|(?:(?:They will|They\u2019ll) go to work by boat Next December)/gm"
        },
        {
            "rus": "\u041B\u0435\u0442\u043E\u043C \u043E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0445\u043E\u0434\u0438\u0442 \u0432 \u043A\u043E\u043B\u043B\u0435\u0434\u0436 \u043F\u0435\u0448\u043A\u043E\u043C",
            "eng": "In summer she always goes to college on foot",
            "regEng": "/(?:In summer she always goes to college on foot)|(?:She always goes to college on foot in summer)/gm"
        },
        {
            "rus": "\u041F\u0440\u043E\u0448\u043B\u044B\u043C \u043B\u0435\u0442\u043E\u043C \u043E\u043D\u0430 \u043F\u043E\u0435\u0445\u0430\u043B\u0430 \u0432 \u043A\u043E\u043B\u043B\u0435\u0434\u0436 \u043D\u0430 \u0442\u0430\u043A\u0441\u0438",
            "eng": "Last summer she went to college by taxi",
            "regEng": "/(?:Last summer she went to college by taxi)|(?:She went to college by taxi last summer)/gm"
        },
        {
            "rus": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043B\u0435\u0442\u043E\u043C \u043E\u043D\u0430 \u043F\u043E\u0435\u0434\u0435\u0442 \u0432 \u043A\u043E\u043B\u043B\u0435\u0434\u0436 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435",
            "eng": "Next summer she will go to college by train",
            "regEng": "/(?:Next summer (?:she will|she\u2019ll) go to college by train)|(?:(?:She will|She\u2019ll) go to college by train next summer)/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u0442\u0440\u0435\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u0434 \u0440\u0430\u0431\u043E\u0442\u043E\u0439",
            "eng": "She often exercises before work"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u0442\u0440\u0435\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u0434 \u0440\u0430\u0431\u043E\u0442\u043E\u0439",
            "eng": "She does not exercise before work",
            "regEng": "/(?:She (?:does not|doesn\u2019t) exercise before work)/gm"
        },
        {
            "rus": "\u0422\u0440\u0435\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043B\u0438 \u043E\u043D\u0430 \u043F\u0435\u0440\u0435\u0434 \u0440\u0430\u0431\u043E\u0442\u043E\u0439?",
            "eng": "Does she exercise before work?"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D\u0430 \u0434\u0435\u043B\u0430\u0435\u0442 \u043F\u0435\u0440\u0435\u0434 \u0440\u0430\u0431\u043E\u0442\u043E\u0439?",
            "eng": "What does she do before work?"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0438 \u0441\u044A\u0435\u043B\u0438 \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u043F\u0438\u0440\u043E\u0436\u043D\u044B\u0435",
            "eng": "Yesterday they ate all your cakes",
            "regEng": "/(?:Yesterday they ate all your cakes)|(?:They ate all your cakes yesterday)/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0438 \u043D\u0435 \u0441\u044A\u0435\u043B\u0438 \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u043F\u0438\u0440\u043E\u0436\u043D\u044B\u0435",
            "eng": "Yesterday they did not eat all your cakes",
            "regEng": "/(?:Yesterday they (?:did not|didn\u2019t) eat all your cakes)|(?:They (?:did not|didn\u2019t) eat all your cakes yesterday)/gm"
        },
        {
            "rus": "\u0421\u044A\u0435\u043B\u0438 \u043B\u0438 \u043E\u043D\u0438 \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u043F\u0438\u0440\u043E\u0436\u043D\u044B\u0435 \u0432\u0447\u0435\u0440\u0430?",
            "eng": "Did they eat all your cakes yesterday?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u0441\u044A\u0435\u043B\u0438 \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u043F\u0438\u0440\u043E\u0436\u043D\u044B\u0435?",
            "eng": "When did they eat all your cakes?"
        }
    ],
    [
        {
            "rus": "\u0412\u044B \u043F\u0440\u0438\u043D\u0435\u0441\u0451\u0442\u0435 \u0435\u043C\u0443 \u044D\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0437\u0430\u0432\u0442\u0440\u0430",
            "eng": "You will bring him these documents tomorrow",
            "regEng": "/(?:(?:You will|You\u2019ll) bring him these documents tomorrow)|(?:Tomorrow (?:you will|you\u2019ll) bring him these documents)/gm"
        },
        {
            "rus": "\u0412\u044B \u043D\u0435 \u043F\u0440\u0438\u043D\u0435\u0441\u0451\u0442\u0435 \u0435\u043C\u0443 \u044D\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0437\u0430\u0432\u0442\u0440\u0430",
            "eng": "You will not bring him these documents tomorrow",
            "regEng": "/(?:You (?:will not|won\u2019t) bring him these documents tomorrow)|(?:Tomorrow you (?:will not|won\u2019t) bring him these documents)/gm"
        },
        {
            "rus": "\u041F\u0440\u0438\u043D\u0435\u0441\u0451\u0442\u0435 \u043B\u0438 \u0432\u044B \u0435\u043C\u0443 \u044D\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "Will you bring him these documents tomorrow?"
        },
        {
            "rus": "\u0427\u0442\u043E \u0432\u044B \u043F\u0440\u0438\u043D\u0435\u0441\u0451\u0442\u0435 \u0435\u043C\u0443 \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "What will you bring him tomorrow?"
        },
        {
            "rus": "\u0412\u044B \u0432\u0437\u044F\u043B\u0438 \u043C\u043E\u044E \u043C\u0430\u0448\u0438\u043D\u0443 \u0432\u0447\u0435\u0440\u0430",
            "eng": "You took my car yesterday",
            "regEng": "/(?:You took my car yesterday)|(?:Yesterday you took my car)/gm"
        },
        {
            "rus": "\u0412\u044B \u043D\u0435 \u0432\u0437\u044F\u043B\u0438 \u043C\u043E\u044E \u043C\u0430\u0448\u0438\u043D\u0443 \u0432\u0447\u0435\u0440\u0430",
            "eng": "You did not take my car yesterday",
            "regEng": "/(?:You (?:did not|didn\u2019t) take my car yesterday)|(?:Yesterday you (?:did not|didn\u2019t) take my car)/gm"
        },
        {
            "rus": "\u0412\u0437\u044F\u043B\u0438 \u043B\u0438 \u0432\u044B \u043C\u043E\u044E \u043C\u0430\u0448\u0438\u043D\u0443 \u0432\u0447\u0435\u0440\u0430?",
            "eng": "Did you take my car yesterday?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u0432\u044B \u0432\u0437\u044F\u043B\u0438 \u043C\u043E\u044E \u043C\u0430\u0448\u0438\u043D\u0443?",
            "eng": "When did you take my car?"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0430\u043B\u044C\u0447\u0438\u043A \u0442\u0440\u0435\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "This boy exercises every day",
            "regEng": "/(?:This boy exercises every day)|(?:Every day this boy exercises)/gm"
        },
        {
            "rus": "\u041C\u044B \u0441\u044A\u0435\u0437\u0434\u0438\u043B\u0438 \u0432 \u044D\u0442\u0443 \u0441\u0442\u0440\u0430\u043D\u0443 \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u0433\u043E\u0434\u0443",
            "eng": "We went to this country last year",
            "regEng": "/(?:We went to this country last year)|(?:Last year we went to this country)/gm"
        },
        {
            "rus": "\u0423 \u0435\u0451 \u0441\u0435\u0441\u0442\u0440\u044B \u0435\u0441\u0442\u044C \u043C\u0430\u043B\u0435\u043D\u044C\u043A\u0430\u044F \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
            "eng": "Her sister has a little problem",
            "regEng": "/(?:Her sister has a (?:little|small) problem)/gm"
        },
        {
            "rus": "\u041D\u0430\u0448\u0438 \u043B\u044E\u0434\u0438 \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0438 \u044D\u0442\u043E\u0442 \u043F\u0440\u043E\u0435\u043A\u0442 \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u043C\u0435\u0441\u044F\u0446\u0435",
            "eng": "Our people finished this project last month",
            "regEng": "/(?:Our people finished this project last month)|(?:Last month our people finished this project)/gm"
        },
        {
            "rus": "\u041C\u044B \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u043B\u0438 \u044D\u0442\u0438 \u0444\u0438\u043B\u044C\u043C\u044B \u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E \u043F\u044F\u0442\u043D\u0438\u0446\u0443",
            "eng": "We watched these films last Friday",
            "regEng": "/(?:We watched these films last Friday)|(?:Last Friday we watched these films)/gm"
        },
        {
            "rus": "\u0415\u0439 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0438 \u0437\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u043B\u0438 \u0434\u0435\u043D\u044C\u0433\u0438",
            "eng": "She needs them to earn money"
        },
        {
            "rus": "\u041C\u044B \u0432\u0438\u0434\u0435\u043B\u0438 \u0442\u0432\u043E\u044E \u0441\u0435\u0441\u0442\u0440\u0443 \u0437\u0434\u0435\u0441\u044C \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u043C\u0435\u0441\u044F\u0446\u0435",
            "eng": "We saw your sister here last month",
            "regEng": "/(?:We saw your sister here last month)|(?:Last month we saw your sister here)/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D \u0445\u043E\u0447\u0435\u0442 \u0438\u043C\u0435\u0442\u044C \u0445\u043E\u0440\u043E\u0448\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439 \u0438 \u0431\u043E\u043B\u044C\u0448\u0443\u044E \u0441\u0435\u043C\u044C\u044E",
            "eng": "He wants to have good friends and a big family",
            "regEng": "/(?:He wants to have good friends and a big family)|(?:He wants to have a big family and good friends)/gm"
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044C \u0438\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0433",
            "eng": "I need to read their messages on Thursday",
            "regEng": "/(?:I need to read their messages on Thursday)|(?:On Thursday I need to read their messages)/gm"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043C\u044B \u0440\u0435\u0448\u0438\u043B\u0438 \u043A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0434\u043E\u043C",
            "eng": "Yesterday we decided to buy a new house",
            "regEng": "/(?:Yesterday we decided to buy a new house)|(?:We decided to buy a new house yesterday)/gm"
        },
        {
            "rus": "\u0423 \u043C\u0435\u043D\u044F \u0435\u0441\u0442\u044C \u043E\u0442\u043B\u0438\u0447\u043D\u043E\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435",
            "eng": "I have an excellent solution"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442 \u0441 \u043D\u0438\u043C\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u043D\u0435\u0434\u0435\u043B\u0435",
            "eng": "She will talk to them next week",
            "regEng": "/(?:(?:She will|She\u2019ll) talk (?:to|with) them next week)|(?:Next week (?:she will|she\u2019ll) talk (?:to|with) them)/gm"
        },
        {
            "rus": "\u0423 \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0440\u0430\u0442\u0430 \u0443\u0440\u043E\u0434\u043B\u0438\u0432\u044B\u0435 \u0437\u0443\u0431\u044B",
            "eng": "Your brother has ugly teeth"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0445\u043E\u0442\u044F\u0442, \u0447\u0442\u043E\u0431\u044B \u044F \u0437\u043D\u0430\u043B \u044D\u0442\u0438\u0445 \u043B\u044E\u0434\u0435\u0439",
            "eng": "They want me to know these people"
        },
        {
            "rus": "\u0423 \u044D\u0442\u043E\u0433\u043E \u043C\u0430\u043B\u044B\u0448\u0430 \u0431\u044B\u043B\u0438 \u043E\u0433\u0440\u043E\u043C\u043D\u044B\u0435 \u0433\u043B\u0430\u0437\u0430",
            "eng": "This baby had huge eyes"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u0442 \u043F\u043E\u0437\u0434\u043D\u043E \u0432 \u0441\u0443\u0431\u0431\u043E\u0442\u0443",
            "eng": "She often has breakfast late on Saturday",
            "regEng": "/(?:She often has breakfast late on Saturday)|(?:On Saturday she often has breakfast late)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u0442 \u043F\u043E\u0437\u0434\u043D\u043E \u0432 \u0441\u0443\u0431\u0431\u043E\u0442\u0443",
            "eng": "She does not often have breakfast late on Saturday",
            "regEng": "/(?:She (?:does not|doesn\u2019t) often have breakfast late on Saturday)|(?:On Saturday she (?:does not|doesn\u2019t) often have breakfast late)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u043F\u043E\u0437\u0434\u043D\u043E \u0432 \u0441\u0443\u0431\u0431\u043E\u0442\u0443?",
            "eng": "Does she often have breakfast late on Saturday?"
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u043E\u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u0442 \u043F\u043E\u0437\u0434\u043D\u043E \u0432 \u0441\u0443\u0431\u0431\u043E\u0442\u0443?",
            "eng": "Why does she often have breakfast late on Saturday?"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u0443\u0436\u0438\u043D\u0430\u044E\u0442 \u0440\u0430\u043D\u043E \u0432 \u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
            "eng": "They always have dinner early on Sunday",
            "regEng": "/(?:They always have dinner early on Sunday)|(?:On Sunday they always have dinner early)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0443\u0436\u0438\u043D\u0430\u044E\u0442 \u0440\u0430\u043D\u043E \u0432 \u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
            "eng": "They do not always have dinner early on Sunday",
            "regEng": "/(?:They (?:do not|don\u2019t) always have dinner early on Sunday)|(?:On Sunday they (?:do not|don\u2019t) always have dinner early)/gm"
        },
        {
            "rus": "\u0423\u0436\u0438\u043D\u0430\u044E\u0442 \u043B\u0438 \u043E\u043D\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u043D\u043E \u0432 \u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435?",
            "eng": "Do they always have dinner early on Sunday?"
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u043E\u043D\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u0443\u0436\u0438\u043D\u0430\u044E\u0442 \u0440\u0430\u043D\u043E \u0432 \u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435?",
            "eng": "Why do they always have dinner early on Sunday?"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u043F\u043E\u043E\u0431\u0435\u0434\u0430\u043B\u0438 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434",
            "eng": "They had lunch an hour ago",
            "regEng": "/(?:They had lunch an hour ago)|(?:An hour ago they had lunch)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0435 \u043F\u043E\u043E\u0431\u0435\u0434\u0430\u043B\u0438 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434",
            "eng": "They did not have lunch an hour ago",
            "regEng": "/(?:They (?:did not|didn\u2019t) have lunch an hour ago)|(?:An hour ago they (?:did not|didn\u2019t) have lunch)/gm"
        },
        {
            "rus": "\u041F\u043E\u043E\u0431\u0435\u0434\u0430\u043B\u0438 \u043B\u0438 \u043E\u043D\u0438 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did they have lunch an hour ago?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u043F\u043E\u043E\u0431\u0435\u0434\u0430\u043B\u0438?",
            "eng": "When did they have lunch?"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043F\u043E\u0435\u0445\u0430\u043B\u0430 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0435 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434",
            "eng": "She went to work by car an hour ago",
            "regEng": "/(?:She went to work by car an hour ago)|(?:An hour ago she went to work by car)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u043F\u043E\u0435\u0445\u0430\u043B\u0430 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0435 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434",
            "eng": "She did not go to work by car an hour ago",
            "regEng": "/(?:She (?:did not|didn\u2019t) go to work by car an hour ago)|(?:An hour ago she (?:did not|didn\u2019t) go to work by car)/gm"
        },
        {
            "rus": "\u041F\u043E\u0435\u0445\u0430\u043B\u0430 \u043B\u0438 \u043E\u043D\u0430 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0435 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did she go to work by car an hour ago?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0430 \u043F\u043E\u0435\u0445\u0430\u043B\u0430 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0435?",
            "eng": "When did she go to work by car?"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u0443\u0436\u0438\u043D\u0430\u044E\u0442 \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0430\u043C\u0438 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0433",
            "eng": "They usually have dinner with their colleagues on Thursday",
            "regEng": "/(?:They usually have dinner with their colleagues on Thursday)|(?:On Thursday they usually have dinner with their colleagues)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u043D\u0435 \u0443\u0436\u0438\u043D\u0430\u044E\u0442 \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0430\u043C\u0438 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0433",
            "eng": "They do not usually have dinner with their colleagues on Thursday",
            "regEng": "/(?:They (?:do not|don\u2019t) usually have dinner with their colleagues on Thursday)|(?:On Thursday they (?:do not|don\u2019t) usually have dinner with their colleagues)/gm"
        },
        {
            "rus": "\u0423\u0436\u0438\u043D\u0430\u044E\u0442 \u043B\u0438 \u043E\u043D\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0430\u043C\u0438 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0433?",
            "eng": "Do they usually have dinner with their colleagues on Thursday?"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u0443\u0436\u0438\u043D\u0430\u044E\u0442 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0433?",
            "eng": "Who do they usually have dinner with on Thursday?",
            "regEng": "/(?:(?:Whom|Who|With whom) do they usually have dinner with on Thursday\\?)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u044D\u0442\u0438 \u043F\u0435\u0441\u043D\u0438 \u0432 \u0441\u0440\u0435\u0434\u0443",
            "eng": "She always listens to these songs on Wednesday",
            "regEng": "/(?:She always listens to these songs on Wednesday)|(?:On Wednesday she always listens to these songs)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u044D\u0442\u0438 \u043F\u0435\u0441\u043D\u0438 \u0432 \u0441\u0440\u0435\u0434\u0443",
            "eng": "She does not always listen to these songs on Wednesday",
            "regEng": "/(?:She (?:does not|doesn\u2019t) always listen to these songs on Wednesday)|(?:On Wednesday she (?:does not|doesn\u2019t) always listen to these songs)/gm"
        },
        {
            "rus": "\u0421\u043B\u0443\u0448\u0430\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u044D\u0442\u0438 \u043F\u0435\u0441\u043D\u0438 \u0432 \u0441\u0440\u0435\u0434\u0443?",
            "eng": "Does she always listen to these songs on Wednesday?"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u0432 \u0441\u0440\u0435\u0434\u0443?",
            "eng": "What does she always listen to on Wednesday?"
        }
    ],
    [
        {
            "rus": "\u041E\u043D \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442 \u0441\u043E \u0441\u0432\u043E\u0438\u043C \u0434\u0440\u0443\u0433\u043E\u043C \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E",
            "eng": "He will talk to his friend in a week",
            "regEng": "/(?:(?:He will|He\u2019ll) (?:talk|speak) (?:to|with) his friend in a week)|(?:In a week (?:he will|he\u2019ll) (?:talk|speak) (?:to|with) his friend)/gm"
        },
        {
            "rus": "\u041E\u043D \u043D\u0435 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442 \u0441\u043E \u0441\u0432\u043E\u0438\u043C \u0434\u0440\u0443\u0433\u043E\u043C \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E",
            "eng": "He will not talk to his friend in a week",
            "regEng": "/(?:He(?: will not|\u2019ll not| won\u2019t) (?:talk|speak) (?:to|with) his friend in a week)|(?:In a week he(?: will not|\u2019ll not| won\u2019t) (?:talk|speak) (?:to|with) his friend)/gm"
        },
        {
            "rus": "\u041F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442 \u043B\u0438 \u043E\u043D \u0441\u043E \u0441\u0432\u043E\u0438\u043C \u0434\u0440\u0443\u0433\u043E\u043C \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "Will he talk to his friend in a week?",
            "regEng": "/(?:Will he (?:talk|speak) (?:to|with) his friend in a week\\?)/gm"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "Who will he talk to in a week?",
            "regEng": "/(?:Whom? will he (?:talk|speak) (?:to|with) in a week\\?)/gm"
        },
        {
            "rus": "\u041C\u044B \u043F\u043E\u0434\u0443\u043C\u0430\u0435\u043C \u043E\u0431 \u044D\u0442\u043E\u0439 \u0438\u0434\u0435\u0435 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E",
            "eng": "We will think about this idea in a week",
            "regEng": "/(?:(?:We will|We\u2019ll) think about this idea in a week)|(?:In a week (?:we will|we\u2019ll) think about this idea)/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u043F\u043E\u0434\u0443\u043C\u0430\u0435\u043C \u043E\u0431 \u044D\u0442\u043E\u0439 \u0438\u0434\u0435\u0435 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E",
            "eng": "We will not think about this idea in a week",
            "regEng": "/(?:We(?: will not|\u2019ll not| won\u2019t) think about this idea in a week)|(?:In a week we(?: will not|\u2019ll not| won\u2019t) think about this idea)/gm"
        },
        {
            "rus": "\u041F\u043E\u0434\u0443\u043C\u0430\u0435\u043C \u043B\u0438 \u043C\u044B \u043E\u0431 \u044D\u0442\u043E\u0439 \u0438\u0434\u0435\u0435 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "Will we think about this idea in a week?"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u043C\u044B \u043F\u043E\u0434\u0443\u043C\u0430\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "What will we think about in a week?"
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u0447\u0430\u0441\u0442\u043E \u0438\u0449\u0435\u043C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043A\u043D\u0438\u0433\u0438 \u0437\u0434\u0435\u0441\u044C",
            "eng": "We often look for interesting books here",
            "regEng": "/(?:We often (?:look|search) for interesting books here)/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u0438\u0449\u0435\u043C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043A\u043D\u0438\u0433\u0438 \u0437\u0434\u0435\u0441\u044C",
            "eng": "We do not often look for interesting books here",
            "regEng": "/(?:We (?:do not|don\u2019t) often (?:look|search) for interesting books here)/gm"
        },
        {
            "rus": "\u0418\u0449\u0435\u043C \u043B\u0438 \u043C\u044B \u0447\u0430\u0441\u0442\u043E \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043A\u043D\u0438\u0433\u0438 \u0437\u0434\u0435\u0441\u044C?",
            "eng": "Do we often look for interesting books here?",
            "regEng": "/(?:Do we often (?:look|search) for interesting books here\\?)/gm"
        },
        {
            "rus": "\u0427\u0442\u043E \u043C\u044B \u0447\u0430\u0441\u0442\u043E \u0438\u0449\u0435\u043C \u0437\u0434\u0435\u0441\u044C?",
            "eng": "What do we often look for here?",
            "regEng": "/(?:What do we often (?:look|search) for here\\?)/gm"
        },
        {
            "rus": "\u041E\u043D \u043E\u0431\u044B\u0447\u043D\u043E \u0445\u043E\u0434\u0438\u0442 \u0442\u0443\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u0440\u043E\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438",
            "eng": "He usually goes there with his parents."
        },
        {
            "rus": "\u041E\u043D \u043E\u0431\u044B\u0447\u043D\u043E \u043D\u0435 \u0445\u043E\u0434\u0438\u0442 \u0442\u0443\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u0440\u043E\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438",
            "eng": "He does not usually go there with his parents",
            "regEng": "/(?:He (?:does not|doesn\u2019t) usually go there with his parents)/gm"
        },
        {
            "rus": "\u0425\u043E\u0434\u0438\u0442 \u043B\u0438 \u043E\u043D \u043E\u0431\u044B\u0447\u043D\u043E \u0442\u0443\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u0440\u043E\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438?",
            "eng": "Does he usually go there with his parents?"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D \u043E\u0431\u044B\u0447\u043D\u043E \u0445\u043E\u0434\u0438\u0442 \u0442\u0443\u0434\u0430?",
            "eng": "Who does he usually go there with?"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u0438\u043D\u043E\u0433\u0434\u0430 \u043E\u0431\u0435\u0434\u0430\u044E\u0442 \u0437\u0434\u0435\u0441\u044C \u0432\u043E \u0432\u0442\u043E\u0440\u043D\u0438\u043A",
            "eng": "They sometimes have lunch here on Tuesday",
            "regEng": "/(?:They sometimes have lunch here on Tuesday)|(?:On Tuesday they sometimes have lunch here)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0435 \u043E\u0431\u0435\u0434\u0430\u044E\u0442 \u0437\u0434\u0435\u0441\u044C \u0432\u043E \u0432\u0442\u043E\u0440\u043D\u0438\u043A",
            "eng": "They do not have lunch here on Tuesday",
            "regEng": "/(?:They (?:do not|don\u2019t) have lunch here on Tuesday)|(?:On Tuesday they (?:do not|don\u2019t) have lunch here)/gm"
        },
        {
            "rus": "\u041E\u0431\u0435\u0434\u0430\u044E\u0442 \u043B\u0438 \u043E\u043D\u0438 \u0438\u043D\u043E\u0433\u0434\u0430 \u0437\u0434\u0435\u0441\u044C \u0432\u043E \u0432\u0442\u043E\u0440\u043D\u0438\u043A?",
            "eng": "Do they sometimes have lunch here on Tuesday?"
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u043E\u043D\u0438 \u0438\u043D\u043E\u0433\u0434\u0430 \u043E\u0431\u0435\u0434\u0430\u044E\u0442 \u0437\u0434\u0435\u0441\u044C \u0432\u043E \u0432\u0442\u043E\u0440\u043D\u0438\u043A?",
            "eng": "Why do they sometimes have lunch here on Tuesday?"
        },
        {
            "rus": "\u041E\u043D \u0447\u0430\u0441\u0442\u043E \u0443\u0436\u0438\u043D\u0430\u0435\u0442 \u0442\u0430\u043C \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "He often has dinner there on Monday"
        },
        {
            "rus": "\u041E\u043D \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u0443\u0436\u0438\u043D\u0430\u0435\u0442 \u0442\u0430\u043C \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "He does not often have dinner there on Monday",
            "regEng": "/(?:He (?:does not|doesn\u2019t) often have dinner there on Monday)|(?:On Monday he (?:does not|doesn\u2019t) often have dinner there)/gm"
        },
        {
            "rus": "\u0423\u0436\u0438\u043D\u0430\u0435\u0442 \u043B\u0438 \u043E\u043D \u0442\u0430\u043C \u0447\u0430\u0441\u0442\u043E \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A?",
            "eng": "Does he often have dinner there on Monday?"
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u043E\u043D \u0447\u0430\u0441\u0442\u043E \u0443\u0436\u0438\u043D\u0430\u0435\u0442 \u0442\u0430\u043C \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A?",
            "eng": "Why does he often have dinner there on Monday?"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u043F\u043E\u0435\u0445\u0430\u043B\u0438 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435 \u043C\u0435\u0441\u044F\u0446 \u043D\u0430\u0437\u0430\u0434",
            "eng": "They went home by train a month ago",
            "regEng": "/(?:They went home by train a month ago)|(?:A month ago they went home by train)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0435 \u043F\u043E\u0435\u0445\u0430\u043B\u0438 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435 \u043C\u0435\u0441\u044F\u0446 \u043D\u0430\u0437\u0430\u0434",
            "eng": "They did not go home by train a month ago",
            "regEng": "/(?:They (?:did not|didn\u2019t) go home by train a month ago)|(?:A month ago they (?:did not|didn\u2019t) go home by train)/gm"
        },
        {
            "rus": "\u041F\u043E\u0435\u0445\u0430\u043B\u0438 \u043B\u0438 \u043E\u043D\u0438 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435 \u043C\u0435\u0441\u044F\u0446 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did they go home by train a month ago?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u043F\u043E\u0435\u0445\u0430\u043B\u0438 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435?",
            "eng": "When did they go home by train?"
        },
        {
            "rus": "\u041C\u044B \u043F\u043E\u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u043C \u0441 \u0432\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u0447\u0430\u0441",
            "eng": "We will have breakfast with you in an hour",
            "regEng": "/(?:(?:We will|We\u2019ll) have breakfast with you in an hour)|(?:In an hour (?:we will|we\u2019ll) have breakfast with you)/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u043F\u043E\u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u043C \u0441 \u0432\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u0447\u0430\u0441",
            "eng": "We will not have breakfast with you in an hour",
            "regEng": "/(?:We (?:will not|won\u2019t) have breakfast with you in an hour)|(?:In an hour we (?:will not|won\u2019t) have breakfast with you)/gm"
        },
        {
            "rus": "\u041F\u043E\u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u043C \u043B\u0438 \u043C\u044B \u0441 \u0432\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u0447\u0430\u0441?",
            "eng": "Will we have breakfast with you in an hour?"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043C\u044B \u043F\u043E\u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0447\u0430\u0441?",
            "eng": "Who will we have breakfast with in an hour?",
            "regEng": "/(?:Whom? will we have breakfast with in an hour\\?)|(?:With whom will we have breakfast in an hour\\?)/gm"
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u0447\u0430\u0441\u0442\u043E \u0433\u043E\u0432\u043E\u0440\u0438\u043C \u043E\u0431 \u044D\u0442\u043E\u043C \u0431\u0438\u0437\u043D\u0435\u0441\u0435",
            "eng": "We often talk about this business",
            "regEng": "/(?:We often (?:talk|speak) about this business)/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u0433\u043E\u0432\u043E\u0440\u0438\u043C \u043E\u0431 \u044D\u0442\u043E\u043C \u0431\u0438\u0437\u043D\u0435\u0441\u0435",
            "eng": "We do not often talk about this business",
            "regEng": "/(?:We (?:do not|don\u2019t) often (?:talk|speak) about this business)/gm"
        },
        {
            "rus": "\u0413\u043E\u0432\u043E\u0440\u0438\u043C \u043B\u0438 \u043C\u044B \u0447\u0430\u0441\u0442\u043E \u043E\u0431 \u044D\u0442\u043E\u043C \u0431\u0438\u0437\u043D\u0435\u0441\u0435?",
            "eng": "Do we often talk about this business?",
            "regEng": "/(?:Do we often (?:talk|speak) about this business\\?)/gm"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u043C\u044B \u0447\u0430\u0441\u0442\u043E \u0433\u043E\u0432\u043E\u0440\u0438\u043C?",
            "eng": "What do we often talk about?",
            "regEng": "/(?:What do we often (?:talk|speak) about\\?)/gm"
        },
        {
            "rus": "\u0412\u044B \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u043B\u0438 \u044D\u0442\u0443 \u043F\u0435\u0441\u043D\u044E \u043D\u0435\u0434\u0435\u043B\u044E \u043D\u0430\u0437\u0430\u0434",
            "eng": "You listened to this song a week ago",
            "regEng": "/(?:You listened to this song a week ago)|(?:A week ago You listened to this song)/gm"
        },
        {
            "rus": "\u0412\u044B \u043D\u0435 \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u043B\u0438 \u044D\u0442\u0443 \u043F\u0435\u0441\u043D\u044E \u043D\u0435\u0434\u0435\u043B\u044E \u043D\u0430\u0437\u0430\u0434",
            "eng": "You did not listen to this song a week ago",
            "regEng": "/(?:You (?:did not|didn\u2019t) listen to this song a week ago)|(?:A week ago you (?:did not|didn\u2019t) listen to this song)/gm"
        },
        {
            "rus": "\u041F\u043E\u0441\u043B\u0443\u0448\u0430\u043B\u0438 \u043B\u0438 \u0432\u044B \u044D\u0442\u0443 \u043F\u0435\u0441\u043D\u044E \u043D\u0435\u0434\u0435\u043B\u044E \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did you listen to this song a week ago?"
        },
        {
            "rus": "\u0427\u0442\u043E \u0432\u044B \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u043B\u0438 \u043D\u0435\u0434\u0435\u043B\u044E \u043D\u0430\u0437\u0430\u0434?",
            "eng": "What did you listen to a week ago?"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0430 \u043F\u043E\u0435\u0434\u0435\u0442 \u0442\u0443\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u043E\u0439 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446",
            "eng": "She will go there with her sister in a month",
            "regEng": "/(?:(?:She will|She\u2019ll) go there with her sister in a month)|(?:In a month (?:she will|she\u2019ll) go there with her sister)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u043F\u043E\u0435\u0434\u0435\u0442 \u0442\u0443\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u043E\u0439 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446",
            "eng": "She will not go there with her sister in a month",
            "regEng": "/(?:She (?:will not|won\u2019t) go there with her sister in a month)|(?:In a month she (?:will not|won\u2019t) go there with her sister)/gm"
        },
        {
            "rus": "\u041F\u043E\u0435\u0434\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u0442\u0443\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u043E\u0439 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446?",
            "eng": "Will she go there with her sister in a month?"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D\u0430 \u043F\u043E\u0435\u0434\u0435\u0442 \u0442\u0443\u0434\u0430 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446?",
            "eng": "Who will she go there with in a month?",
            "regEng": "/(?:Whom? will she go there with in a month\\?)|(?:With whom will she go there in a month\\?)/gm"
        },
        {
            "rus": "\u041E\u043D \u0432\u0441\u0435\u0433\u0434\u0430 \u0436\u0434\u0451\u0442 \u044D\u0442\u0438\u0445 \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043E\u043A",
            "eng": "He always waits for these parties"
        },
        {
            "rus": "\u041E\u043D \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0436\u0434\u0451\u0442 \u044D\u0442\u0438\u0445 \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043E\u043A",
            "eng": "He does not always wait for these parties",
            "regEng": "/(?:He (?:does not|doesn\u2019t) always wait for these parties)/gm"
        },
        {
            "rus": "\u0416\u0434\u0451\u0442 \u043B\u0438 \u043E\u043D \u0432\u0441\u0435\u0433\u0434\u0430 \u044D\u0442\u0438\u0445 \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043E\u043A?",
            "eng": "Does he always wait for these parties?"
        },
        {
            "rus": "\u0427\u0435\u0433\u043E \u043E\u043D \u0432\u0441\u0435\u0433\u0434\u0430 \u0436\u0434\u0451\u0442?",
            "eng": "What does he always wait for?"
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u043F\u0440\u0438\u0435\u0445\u0430\u043B\u0438 \u0441\u044E\u0434\u0430 \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u043C\u0435\u0441\u044F\u0446\u0435",
            "eng": "We came here last month",
            "regEng": "/(?:We came here last month)|(?:Last month we came here)/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u044F \u043F\u043E\u043F\u044B\u0442\u0430\u044E\u0441\u044C \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u0442\u044C \u044D\u0442\u043E \u0443\u043F\u0440\u0430\u0436\u043D\u0435\u043D\u0438\u0435",
            "eng": "Tomorrow I will try to finish this exercise",
            "regEng": "/(?:Tomorrow (?:I will|I\u2019ll) try to finish this exercise)|(?:(?:I will|I\u2019ll) try to finish this exercise tomorrow)/gm"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D \u043F\u0440\u0438\u043D\u0451\u0441 \u044D\u0442\u0438 \u0446\u0432\u0435\u0442\u044B?",
            "eng": "When did he bring these flowers?"
        },
        {
            "rus": "\u0412\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0433\u043E\u0432\u043E\u0440\u0438\u0442\u0435 \u043E\u0431 \u044D\u0442\u043E\u043C",
            "eng": "You never talk about it",
            "regEng": "/(?:You never (?:talk|speak) about (?:it|this|that))|(?:You do not ever (?:talk|speak) about (?:it|this|that))|(?:You do not (?:talk|speak) about (?:it|this|that) ever)/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u043A\u0443\u0448\u0430\u044E\u0442 \u0442\u0430\u043A\u0438\u0435 \u0432\u043A\u0443\u0441\u043D\u044B\u0435 \u043F\u0438\u0440\u043E\u0436\u043D\u044B\u0435 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F",
            "eng": "These women eat such tasty cakes all the time",
            "regEng": "/(?:These women eat such tasty cakes all the time)|(?:All the time these women eat such tasty cakes)/gm"
        },
        {
            "rus": "\u041C\u044B \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0438 \u044D\u0442\u0443 \u0433\u0430\u0437\u0435\u0442\u0443 \u0432\u0447\u0435\u0440\u0430",
            "eng": "We read this newspaper yesterday",
            "regEng": "/(?:We read this newspaper yesterday)|(?:Yesterday we read this newspaper)/gm"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D\u0430 \u0434\u0443\u043C\u0430\u0435\u0442 \u043E\u0431 \u044D\u0442\u043E\u0439 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0435?",
            "eng": "What does she think about this problem?"
        }
    ],
    [
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u043E\u043A\u0430\u0437\u0430\u043B\u0438 \u043C\u043D\u0435 \u044D\u0442\u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u044B",
            "eng": "I need you to show me these magazines"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043F\u044C\u0451\u0442 \u044D\u0442\u043E\u0442 \u0432\u043A\u0443\u0441\u043D\u044B\u0439 \u043A\u043E\u0444\u0435 \u043A\u0430\u0436\u0434\u043E\u0435 \u0443\u0442\u0440\u043E",
            "eng": "She drinks this tasty coffee every morning",
            "regEng": "/(?:She drinks this tasty coffee every morning)|(?:Every morning she drinks this tasty coffee)/gm"
        },
        {
            "rus": "\u0415\u0439 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0448\u043E\u043A\u043E\u043B\u0430\u0434?",
            "eng": "Does she like chocolate?"
        },
        {
            "rus": "\u041C\u044B \u043F\u043E\u0441\u0435\u0442\u0438\u043C \u0442\u0430\u043A\u043E\u0435 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0433\u043E\u0434\u0443",
            "eng": "We will visit such an interesting place next year",
            "regEng": "/(?:(?:We will|We\u2019ll) visit such an interesting place next year)|(?:Next year (?:we will|we\u2019ll) visit such an interesting place)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043F\u043E\u0434\u0430\u0440\u0438\u043B\u0438 \u043C\u043D\u0435 \u0443\u0434\u0438\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u043E\u0434\u0430\u0440\u043E\u043A \u043D\u0430 \u043F\u0440\u043E\u0448\u043B\u043E\u0439 \u043D\u0435\u0434\u0435\u043B\u0435",
            "eng": "They gave me an amazing present last week",
            "regEng": "/(?:They gave me an amazing (?:present|gift) last week)|(?:Last week they gave me an amazing (?:present|gift))/gm"
        },
        {
            "rus": "\u042F \u0441\u043B\u044B\u0448\u0430\u043B \u0442\u0443 \u043F\u0435\u0441\u043D\u044E \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u0433\u043E\u0434\u0443",
            "eng": "I heard that song last year",
            "regEng": "/(?:I heard that song last year)|(?:Last year I heard that song)/gm"
        },
        {
            "rus": "\u0422\u044B \u0437\u043D\u0430\u0435\u0448\u044C \u0442\u0435\u0445 \u043B\u044E\u0434\u0435\u0439?",
            "eng": "Do you know those people?"
        },
        {
            "rus": "\u0412\u044B \u0440\u0430\u0437\u0433\u043E\u0432\u0430\u0440\u0438\u0432\u0430\u0435\u0442\u0435 \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0430\u043C\u0438 \u043A\u0430\u0436\u0434\u044B\u0439 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "You talk to your colleagues every Monday",
            "regEng": "/(?:You (?:talk|speak) (?:to|with) your colleagues every Monday)|(?:Every Monday you (?:talk|speak) (?:to|with) your colleagues)/gm"
        }
    ],
    [
        {
            "rus": "\u0423 \u043D\u0435\u0451 \u043A\u0440\u0430\u0441\u0438\u0432\u0430\u044F \u0434\u043E\u0447\u043A\u0430",
            "eng": "She has a beautiful daughter"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0438\u0433\u0440\u0430\u044E\u0442 \u0432 \u0442\u0435\u043D\u043D\u0438\u0441 \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "They play tennis every day",
            "regEng": "/(?:They play tennis every day)|(?:Every day they play tennis)/gm"
        },
        {
            "rus": "\u041E\u043D \u0445\u043E\u0447\u0435\u0442 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044C \u044D\u0442\u0443 \u043A\u043D\u0438\u0433\u0443",
            "eng": "He wants to read this book"
        },
        {
            "rus": "\u041E\u043D \u0432\u0441\u0435\u0433\u0434\u0430 \u043D\u043E\u0441\u0438\u0442 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0435 \u0431\u0440\u044E\u043A\u0438",
            "eng": "He always wears short trousers"
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u043B\u0438 \u044D\u0442\u0438 \u0444\u0438\u043B\u044C\u043C\u044B",
            "eng": "We need you to watch these films"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0430 \u043A\u0443\u043F\u0438\u043B\u0430 \u043D\u043E\u0432\u043E\u0435 \u043F\u043B\u0430\u0442\u044C\u0435",
            "eng": "Yesterday she bought a new dress",
            "regEng": "/(?:Yesterday she bought a new dress)|(?:She bought a new dress yesterday)/gm"
        },
        {
            "rus": "\u0423 \u043D\u0430\u0441 \u0445\u043E\u0440\u043E\u0448\u0438\u0435 \u0434\u0440\u0443\u0437\u044C\u044F",
            "eng": "We have good friends"
        },
        {
            "rus": "\u042F \u043F\u043E\u0437\u0432\u043E\u043D\u044E \u0442\u0435\u0431\u0435 \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "I will call you on Monday",
            "regEng": "/(?:(?:I will|I\u2019ll) call you on Monday)|(?:On Monday (?:I will|I\u2019ll) call you)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0445\u043E\u0442\u044F\u0442, \u0447\u0442\u043E\u0431\u044B \u044F \u043F\u043E\u043C\u043E\u0433 \u0438\u043C",
            "eng": "They want me to help them"
        },
        {
            "rus": "\u041C\u044B \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0438 \u044D\u0442\u043E\u0442 \u043F\u0440\u043E\u0435\u043A\u0442 \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u043C\u0435\u0441\u044F\u0446\u0435",
            "eng": "We finished this project last month",
            "regEng": "/(?:We finished this project last month)|(?:Last month we finished this project)/gm"
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043D\u0430\u043F\u0438\u0441\u0430\u043B\u0438 \u043C\u043D\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
            "eng": "I need you to write me a message"
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0430 \u043F\u043E\u0435\u0445\u0430\u043B\u0430 \u0432 \u0448\u043A\u043E\u043B\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0435",
            "eng": "Yesterday she went to school by bus",
            "regEng": "/(?:Yesterday she went to school by bus)|(?:She went to school by bus yesterday)/gm"
        },
        {
            "rus": "\u041C\u044B \u043E\u0431\u044B\u0447\u043D\u043E \u0435\u0437\u0434\u0438\u043C \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0435",
            "eng": "We usually go to work by car"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0432\u0438\u0434\u0435\u043B\u0438 \u0435\u0433\u043E \u0437\u0434\u0435\u0441\u044C \u0432 \u0441\u0440\u0435\u0434\u0443",
            "eng": "They saw him here on Wednesday",
            "regEng": "/(?:They saw him here on Wednesday)|(?:On Wednesday they saw him here)/gm"
        },
        {
            "rus": "\u042F \u043B\u044E\u0431\u043B\u044E \u0441\u0432\u043E\u044E \u0447\u0443\u0434\u0435\u0441\u043D\u0443\u044E \u0436\u0438\u0437\u043D\u044C!",
            "eng": "I love my wonderful life!"
        }
    ],
    [
        {
            "rus": "\u0427\u0430\u0441 \u043D\u0430\u0437\u0430\u0434 \u043C\u044B \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u043E \u043F\u043E\u0433\u043E\u0434\u0435",
            "eng": "An hour ago we talked about weather",
            "regEng": "/(?:An hour ago we (?:talked|spoke) about weather)|(?:We (?:talked|spoke) about weather an hour ago)/gm"
        },
        {
            "rus": "\u0427\u0430\u0441 \u043D\u0430\u0437\u0430\u0434 \u043C\u044B \u043D\u0435 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u043E \u043F\u043E\u0433\u043E\u0434\u0435",
            "eng": "An hour ago we did not talk about weather",
            "regEng": "/(?:An hour ago we (?:did not|didn\u2019t) (?:talk|speak) about weather)|(?:We (?:did not|didn\u2019t) (?:talk|speak) about weather an hour ago)/gm"
        },
        {
            "rus": "\u041F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u043B\u0438 \u043C\u044B \u043E \u043F\u043E\u0433\u043E\u0434\u0435 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did we talk about weather an hour ago?",
            "regEng": "/(?:Did we (?:talk|speak) about weather an hour ago\\?)/gm"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u043C\u044B \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "What did we talk about an hour ago?",
            "regEng": "/(?:What did we (?:talk|speak) about an hour ago\\?)/gm"
        },
        {
            "rus": "\u041D\u0435\u0434\u0435\u043B\u044E \u043D\u0430\u0437\u0430\u0434 \u0432\u044B \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u0441\u043E \u0441\u0432\u043E\u0438\u043C \u0431\u0440\u0430\u0442\u043E\u043C",
            "eng": "A week ago you talked to your brother",
            "regEng": "/(?:A week ago you (?:talked|spoke) (?:to|with) your brother)|(?:You (?:talked|spoke) (?:to|with) your brother a week ago)/gm"
        },
        {
            "rus": "\u041D\u0435\u0434\u0435\u043B\u044E \u043D\u0430\u0437\u0430\u0434 \u0432\u044B \u043D\u0435 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u0441\u043E \u0441\u0432\u043E\u0438\u043C \u0431\u0440\u0430\u0442\u043E\u043C",
            "eng": "A week ago you did not talk to your brother",
            "regEng": "/(?:A week ago you (?:did not|didn\u2019t) (?:talk|speak) (?:to|with) your brother)|(?:You (?:did not|didn\u2019t) (?:talk|speak) (?:to|with) your brother a week ago)/gm"
        },
        {
            "rus": "\u041F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u043B\u0438 \u0432\u044B \u0441\u043E \u0441\u0432\u043E\u0438\u043C \u0431\u0440\u0430\u0442\u043E\u043C \u043D\u0435\u0434\u0435\u043B\u044E \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did you talk to your brother a week ago?",
            "regEng": "/(?:Did you (?:talk|speak) (?:to|with) your brother a week ago\\?)/gm"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u0432\u044B \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u043D\u0435\u0434\u0435\u043B\u044E \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Who did you talk to a week ago?",
            "regEng": "/(?:Who did you (?:talk|speak) (?:to|with) a week ago\\?)/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u0447\u0430\u0441\u0442\u043E \u0441\u043B\u0443\u0448\u0430\u044E\u0442 \u044D\u0442\u0438\u0445 \u043B\u044E\u0434\u0435\u0439",
            "eng": "They often listen to these people"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u0441\u043B\u0443\u0448\u0430\u044E\u0442 \u044D\u0442\u0438\u0445 \u043B\u044E\u0434\u0435\u0439",
            "eng": "They do not often listen to these people",
            "regEng": "/(?:They (?:do not|don\u2019t) often listen to these people)/gm"
        },
        {
            "rus": "\u0421\u043B\u0443\u0448\u0430\u044E\u0442 \u043B\u0438 \u043E\u043D\u0438 \u0447\u0430\u0441\u0442\u043E \u044D\u0442\u0438\u0445 \u043B\u044E\u0434\u0435\u0439?",
            "eng": "Do they often listen to these people?"
        },
        {
            "rus": "\u041A\u043E\u0433\u043E \u043E\u043D\u0438 \u0447\u0430\u0441\u0442\u043E \u0441\u043B\u0443\u0448\u0430\u044E\u0442?",
            "eng": "Who do they often listen to?",
            "regEng": "/(?:(?:Who|whom|to whom) do they often listen to\\?)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u0442\u0430\u043A\u0443\u044E \u043C\u0443\u0437\u044B\u043A\u0443",
            "eng": "She always listens to such music"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u0442\u0430\u043A\u0443\u044E \u043C\u0443\u0437\u044B\u043A\u0443",
            "eng": "She does not always listen to such music",
            "regEng": "/(?:She (?:does not|doesn\u2019t) always listen to such music)/gm"
        },
        {
            "rus": "\u0421\u043B\u0443\u0448\u0430\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0442\u0430\u043A\u0443\u044E \u043C\u0443\u0437\u044B\u043A\u0443?",
            "eng": "Does she always listen to such music?"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442?",
            "eng": "What does she always listen to?"
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u043F\u043E\u0435\u0434\u0435\u043C \u0442\u0443\u0434\u0430 \u0441 \u043D\u0430\u0448\u0438\u043C\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446",
            "eng": "We will go there with our colleagues in a month",
            "regEng": "/(?:(?:We will|We\u2019ll) go there with our colleagues in a month)|(?:In a month (?:we will|we\u2019ll) go there with our colleagues)/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u043F\u043E\u0435\u0434\u0435\u043C \u0442\u0443\u0434\u0430 \u0441 \u043D\u0430\u0448\u0438\u043C\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446",
            "eng": "We will not go there with our colleagues in a month",
            "regEng": "/(?:We (?:will not|won\u2019t) go there with our colleagues in a month)|(?:In a month we (?:will not|won\u2019t) go there with our colleagues in a month)/gm"
        },
        {
            "rus": "\u041F\u043E\u0435\u0434\u0435\u043C \u043B\u0438 \u043C\u044B \u0442\u0443\u0434\u0430 \u0441 \u043D\u0430\u0448\u0438\u043C\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446?",
            "eng": "Will we go there with our colleagues in a month?"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043C\u044B \u043F\u043E\u0435\u0434\u0435\u043C \u0442\u0443\u0434\u0430 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446?",
            "eng": "Who will we go there with in a month?",
            "regEng": "/(?:(?:Who|Whom) will we go there with in a month\\?)|(?:With whom will we go there in a month\\?)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043F\u0440\u0438\u0435\u0434\u0435\u0442 \u0441\u044E\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u043F\u043E\u0434\u0440\u0443\u0433\u043E\u0439 \u0447\u0435\u0440\u0435\u0437 \u0433\u043E\u0434",
            "eng": "She will come here with her friend in a year",
            "regEng": "/(?:(?:She|She\u2019ll) will come here with her friend in a year)|(?:In a year (?:she|she\u2019ll) will come here with her friend)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u043F\u0440\u0438\u0435\u0434\u0435\u0442 \u0441\u044E\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u043F\u043E\u0434\u0440\u0443\u0433\u043E\u0439 \u0447\u0435\u0440\u0435\u0437 \u0433\u043E\u0434",
            "eng": "She will not come here with her friend in a year",
            "regEng": "/(?:(?:She will not|She won\u2019t|She\u2019ll not) come here with her friend in a year)|(?:In a year (?:she will not|she won\u2019t|she\u2019ll not) come here with her friend)/gm"
        },
        {
            "rus": "\u041F\u0440\u0438\u0435\u0434\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u0441\u044E\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u043F\u043E\u0434\u0440\u0443\u0433\u043E\u0439 \u0447\u0435\u0440\u0435\u0437 \u0433\u043E\u0434?",
            "eng": "Will she come here with her friend in a year?"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D\u0430 \u043F\u0440\u0438\u0435\u0434\u0435\u0442 \u0441\u044E\u0434\u0430 \u0447\u0435\u0440\u0435\u0437 \u0433\u043E\u0434?",
            "eng": "Who will she come here with in a year?",
            "regEng": "/(?:(?:Who|Whom) will she come here with in a year\\?)|(?:With whom will she come here in a year\\?)/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D \u0445\u043E\u0440\u043E\u0448\u0438\u0439 \u0434\u043E\u043A\u0442\u043E\u0440",
            "eng": "He is a good doctor",
            "regEng": "/(?:(?:He is|He\u2019s) a good doctor)/gm"
        },
        {
            "rus": "\u041E\u043D \u043D\u0435 \u0445\u043E\u0440\u043E\u0448\u0438\u0439 \u0434\u043E\u043A\u0442\u043E\u0440",
            "eng": "He is not a good doctor",
            "regEng": "/(?:(?:He is|He\u2019s) not a good doctor)|(?:He isn\u2019t a good doctor)/gm"
        },
        {
            "rus": "\u041E\u043D \u0445\u043E\u0440\u043E\u0448\u0438\u0439 \u0434\u043E\u043A\u0442\u043E\u0440?",
            "eng": "Is he a good doctor?"
        },
        {
            "rus": "\u041A\u0442\u043E \u043E\u043D?",
            "eng": "Who is he?"
        },
        {
            "rus": "\u0412\u044B \u0437\u0430\u043C\u0435\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0443\u0447\u0438\u0442\u0435\u043B\u044C",
            "eng": "You are a great teacher",
            "regEng": "/(?:(?:You are|You\u2019re) a great teacher)/gm"
        },
        {
            "rus": "\u0412\u044B \u043D\u0435 \u0437\u0430\u043C\u0435\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0443\u0447\u0438\u0442\u0435\u043B\u044C",
            "eng": "You are not a great teacher",
            "regEng": "/(?:(?:You are|You\u2019re) not a great teacher)|(?:You aren\u2019t a great teacher)/gm"
        },
        {
            "rus": "\u0412\u044B \u0437\u0430\u043C\u0435\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0443\u0447\u0438\u0442\u0435\u043B\u044C?",
            "eng": "Are you a great teacher?"
        },
        {
            "rus": "\u041A\u0442\u043E \u0432\u044B?",
            "eng": "Who are you?"
        }
    ],
    [
        {
            "rus": "\u042F \u0431\u044B\u043B \u0437\u0434\u0435\u0441\u044C \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            "eng": "I was here a minute ago",
            "regEng": "/(?:I was here a minute ago)|(?:A minute ago I was here)/gm"
        },
        {
            "rus": "\u042F \u043D\u0435 \u0431\u044B\u043B \u0437\u0434\u0435\u0441\u044C \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            "eng": "I was not here a minute ago",
            "regEng": "/(?:I (?:was not|wasn\u2019t) here a minute ago)|(?:A minute ago I (?:was not|wasn\u2019t) here)/gm"
        },
        {
            "rus": "\u0411\u044B\u043B \u043B\u0438 \u044F \u0437\u0434\u0435\u0441\u044C \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Was I here a minute ago?"
        },
        {
            "rus": "\u0413\u0434\u0435 \u044F \u0431\u044B\u043B \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Where was I a minute ago?"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0431\u044B\u043B\u0438 \u0442\u0430\u043C \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434",
            "eng": "They were there an hour ago",
            "regEng": "/(?:They were there an hour ago)|(?:An hour ago they were there)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0435 \u0431\u044B\u043B\u0438 \u0442\u0430\u043C \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434",
            "eng": "They were not there an hour ago",
            "regEng": "/(?:They (?:were not|weren\u2019t) there an hour ago)|(?:An hour ago they (?:were not|weren\u2019t) there)/gm"
        },
        {
            "rus": "\u0411\u044B\u043B\u0438 \u043B\u0438 \u043E\u043D\u0438 \u0442\u0430\u043C \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Were they there an hour ago?"
        },
        {
            "rus": "\u0413\u0434\u0435 \u043E\u043D\u0438 \u0431\u044B\u043B\u0438 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Where were they an hour ago?"
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u0431\u0443\u0434\u0435\u043C \u0433\u043E\u0442\u043E\u0432\u044B \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u043D\u0435\u0434\u0435\u043B\u0435",
            "eng": "We will be ready next week",
            "regEng": "/(?:(?:We will|We\u2019ll) be ready next week)|(?:Next week (?:we will|we\u2019ll) be ready)/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u0431\u0443\u0434\u0435\u043C \u0433\u043E\u0442\u043E\u0432\u044B \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u043D\u0435\u0434\u0435\u043B\u0435",
            "eng": "We will not be ready next week",
            "regEng": "/(?:(?:We will|We\u2019ll) not be ready next week)|(?:We won\u2019t be ready next week)|(?:Next week (?:we will|we\u2019ll) not be ready)|(?:Next week we won\u2019t be ready)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u043C \u043B\u0438 \u043C\u044B \u0433\u043E\u0442\u043E\u0432\u044B \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u043D\u0435\u0434\u0435\u043B\u0435?",
            "eng": "Will we be ready next week?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043C\u044B \u0431\u0443\u0434\u0435\u043C \u0433\u043E\u0442\u043E\u0432\u044B?",
            "eng": "When will we be ready?"
        },
        {
            "rus": "\u041E\u043D \u0431\u0443\u0434\u0435\u0442 \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u043C \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0433\u043E\u0434\u0443",
            "eng": "He will be very successful next year",
            "regEng": "/(?:(?:He will|He\u2019ll) be very successful next year)|(?:Next year (?:he will|he\u2019ll) be very successful)/gm"
        },
        {
            "rus": "\u041E\u043D \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u043C \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0433\u043E\u0434\u0443",
            "eng": "He will not be very successful next year",
            "regEng": "/(?:(?:He will|He\u2019ll) not be very successful next year)|(?:He won\u2019t be very successful next year)|(?:Next year (?:he will|he\u2019ll) not be very successful)|(?:Next year he won\u2019t be very successful)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u043E\u043D \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u043C \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0433\u043E\u0434\u0443?",
            "eng": "Will he be very successful next year?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u043C?",
            "eng": "When will he be very successful?"
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u043C \u043F\u0438\u0441\u044C\u043C\u043E \u043E\u0442 \u043D\u0430\u0448\u0438\u0445 \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E",
            "eng": "We will get a letter from our relatives in a week",
            "regEng": "/(?:(?:We will|We\u2019ll) (?:get|receive) a letter from our relatives in a week)|(?:In a week (?:we will|we\u2019ll) (?:get|receive) a letter from our relatives)/gm"
        },
        {
            "rus": "\u041E\u0442 \u043A\u043E\u0433\u043E \u043C\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u043C \u043F\u0438\u0441\u044C\u043C\u043E \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "Who will we get a letter from in a week?",
            "regEng": "/(?:Whom? will we (?:get|receive) a letter from in a week\\?)|(?:From whom will we (?:get|receive) a letter in a week\\?)/gm"
        },
        {
            "rus": "\u041F\u043E\u043B\u0443\u0447\u0438\u043C \u043B\u0438 \u043C\u044B \u043F\u0438\u0441\u044C\u043C\u043E \u043E\u0442 \u043D\u0430\u0448\u0438\u0445 \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "Will we get a letter from our relatives in a week?",
            "regEng": "/(?:Will we (?:get|receive) a letter from our relatives in a week\\?)/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043C \u043F\u0438\u0441\u044C\u043C\u043E \u043E\u0442 \u043D\u0430\u0448\u0438\u0445 \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E",
            "eng": "We will not get a letter from our relatives in a week",
            "regEng": "/(?:(?:We will|We\u2019ll) not (?:get|receive) a letter from our relatives in a week)|(?:We won\u2019t (?:get|receive) a letter from our relatives in a week)|(?:In a week (?:we will|we\u2019ll) not (?:get|receive) a letter from our relatives)|(?:In a week we won\u2019t (?:get|receive) a letter from our relatives)/gm"
        },
        {
            "rus": "\u0427\u0442\u043E \u0435\u043C\u0443 \u043D\u0443\u0436\u043D\u043E \u0438\u0441\u043A\u0430\u0442\u044C?",
            "eng": "What does he need to look for?",
            "regEng": "/(?:What does he need to (?:look|search) for\\?)/gm"
        },
        {
            "rus": "\u0415\u043C\u0443 \u043D\u0443\u0436\u043D\u043E \u0438\u0441\u043A\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443",
            "eng": "He needs to look for a new job",
            "regEng": "/(?:He needs to (?:look|search) for a new job)/gm"
        },
        {
            "rus": "\u041D\u0443\u0436\u043D\u043E \u043B\u0438 \u0435\u043C\u0443 \u0438\u0441\u043A\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443?",
            "eng": "Does he need to look for a new job?",
            "regEng": "/(?:Does he need to (?:look|search) for a new job\\?)/gm"
        },
        {
            "rus": "\u0415\u043C\u0443 \u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u0438\u0441\u043A\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443",
            "eng": "He does not need to look for a new job",
            "regEng": "/(?:He (?:does not|doesn\u2019t) need to (?:look|search) for a new job)/gm"
        }
    ],
    [
        {
            "rus": "\u042F \u0445\u043E\u0440\u043E\u0448\u0438\u0439 \u0447\u0435\u043B\u043E\u0432\u0435\u043A",
            "eng": "I am a good person",
            "regEng": "/(?:(?:I am|I\u2019m) a (?:good|nice) person)/gm"
        },
        {
            "rus": "\u042F \u043D\u0435 \u043F\u043B\u043E\u0445\u043E\u0439 \u0447\u0435\u043B\u043E\u0432\u0435\u043A",
            "eng": "I am not a bad person",
            "regEng": "/(?:(?:I am|I\u2019m) not a bad person)/gm"
        },
        {
            "rus": "\u0425\u043E\u0440\u043E\u0448\u0438\u0439 \u043B\u0438 \u044F \u0447\u0435\u043B\u043E\u0432\u0435\u043A?",
            "eng": "Am I a good person?",
            "regEng": "/(?:Am I a (?:good|nice) person\\?)/gm"
        },
        {
            "rus": "\u041A\u0442\u043E \u044F?",
            "eng": "Who am I?"
        },
        {
            "rus": "\u0412\u044B \u043E\u043F\u043E\u0437\u0434\u0430\u043B\u0438 \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "You were late on Monday",
            "regEng": "/(?:You were late on Monday)|(?:On Monday you were late)/gm"
        },
        {
            "rus": "\u0412\u044B \u043D\u0435 \u043E\u043F\u043E\u0437\u0434\u0430\u043B\u0438 \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "You were not late on Monday",
            "regEng": "/(?:You (?:were not|weren\u2019t) late on Monday)|(?:On Monday You (?:were not|weren\u2019t) late)/gm"
        },
        {
            "rus": "\u041E\u043F\u043E\u0437\u0434\u0430\u043B\u0438 \u043B\u0438 \u0432\u044B \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A?",
            "eng": "Were you late on Monday?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u0432\u044B \u043E\u043F\u043E\u0437\u0434\u0430\u043B\u0438?",
            "eng": "When were you late?"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u0441 \u043D\u0438\u043C\u0438 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u043C\u0435\u0441\u044F\u0446\u0435",
            "eng": "She will be with them next month",
            "regEng": "/(?:(?:She will|She\u2019ll) be with them next month)|(?:Next month (?:she will|she\u2019ll) be with them)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u0441 \u043D\u0438\u043C\u0438 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u043C\u0435\u0441\u044F\u0446\u0435",
            "eng": "She will not be with them next month",
            "regEng": "/(?:(?:She will|She\u2019ll) not be with them next month)|(?:She won\u2019t be with them next month)|(?:Next month (?:she will|she\u2019ll) not be with them)|(?:Next month she won\u2019t be with them)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u0441 \u043D\u0438\u043C\u0438 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u043C\u0435\u0441\u044F\u0446\u0435?",
            "eng": "Will she be with them next month?"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u043C\u0435\u0441\u044F\u0446\u0435?",
            "eng": "Who will she be with next month?",
            "regEng": "/(?:Whom? will she be with next month\\?)|(?:With whom will she be next month\\?)/gm"
        },
        {
            "rus": "\u041E\u043D \u0441\u043F\u0435\u0448\u0438\u0442",
            "eng": "He is in a hurry",
            "regEng": "/(?:(?:He is|He\u2019s) in a hurry)/gm"
        },
        {
            "rus": "\u041E\u043D \u043D\u0435 \u0441\u043F\u0435\u0448\u0438\u0442",
            "eng": "He is not in a hurry",
            "regEng": "/(?:(?:He is|He\u2019s) not in a hurry)|(?:He isn\u2019t in a hurry)/gm"
        },
        {
            "rus": "\u0421\u043F\u0435\u0448\u0438\u0442 \u043B\u0438 \u043E\u043D?",
            "eng": "Is he in a hurry?"
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u043E\u043D \u0441\u043F\u0435\u0448\u0438\u0442?",
            "eng": "Why is he in a hurry?"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u0433\u043E\u0442\u043E\u0432\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            "eng": "They are ready to start in a minute",
            "regEng": "/(?:In a minute (?:they are ready to|they\u2019re ready so) (?:start|begin)|(?:They are ready to|They\u2019re ready so) (?:start|begin) in a minute)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            "eng": "They are not ready to start in a minute",
            "regEng": "/(?:In a minute (?:they are|they\u2019re) not ready to (?:start|begin)|(?:They are|They\u2019re) not ready to (?:start|begin) in a minute)/gm"
        },
        {
            "rus": "\u0413\u043E\u0442\u043E\u0432\u044B \u043B\u0438 \u043E\u043D\u0438 \u043D\u0430\u0447\u0430\u0442\u044C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443?",
            "eng": "Are they ready to start in a minute?",
            "regEng": "/(?:Are they ready to (?:start|begin) in a minute\\?)/gm"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D\u0438 \u0433\u043E\u0442\u043E\u0432\u044B \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443?",
            "eng": "What are they ready to do in a minute?"
        },
        {
            "rus": "\u0422\u044B \u0431\u0443\u0434\u0435\u0448\u044C \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u043C \u0437\u0430\u0432\u0442\u0440\u0430",
            "eng": "You will be very tired tomorrow",
            "regEng": "/(?:You(?: will|\u2019ll) be very tired tomorrow)|(?:Tomorrow you(?: will|\u2019ll) be very tired)/gm"
        },
        {
            "rus": "\u0422\u044B \u043D\u0435 \u0431\u0443\u0434\u0435\u0448\u044C \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u043C \u0437\u0430\u0432\u0442\u0440\u0430",
            "eng": "You will not be very tired tomorrow",
            "regEng": "/(?:You(?:(?: will|\u2019ll) not| won\u2019t) be very tired tomorrow)|(?:Tomorrow you(?:(?: will|\u2019ll) not| won\u2019t) be very tired)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u0448\u044C \u043B\u0438 \u0442\u044B \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u043C \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "Will you be very tired tomorrow?"
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u044B \u0431\u0443\u0434\u0435\u0448\u044C \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u043C \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "Why will you be very tired tomorrow?"
        }
    ],
    [
        {
            "rus": "\u0412\u0438\u0434\u0435\u043B\u0438 \u043B\u0438 \u0432\u044B \u0441\u0432\u043E\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439 \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u043C\u0435\u0441\u044F\u0446\u0435?",
            "eng": "Did you see your friends last month?"
        },
        {
            "rus": "\u0417\u043D\u0430\u0435\u0448\u044C \u043B\u0438 \u0442\u044B \u0435\u0451 \u0438\u043C\u044F?",
            "eng": "Do you know her name?"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u043F\u0440\u0438\u043D\u0435\u0441\u0443\u0442 \u044D\u0442\u0438 \u0432\u0435\u0449\u0438 \u0441\u044E\u0434\u0430?",
            "eng": "When will they bring these things here?"
        },
        {
            "rus": "\u042F \u0445\u043E\u0447\u0443, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u043F\u043E\u0448\u043B\u0438 \u0432 \u044D\u0442\u043E \u043C\u0435\u0441\u0442\u043E \u0432\u043C\u0435\u0441\u0442\u0435 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0433",
            "eng": "I want us to go to this place together on Thursday",
            "regEng": "/(?:I want us to go to this place together on Thursday)|(?:On Thursday I want is to go to this place together)/gm"
        },
        {
            "rus": "\u0423 \u044D\u0442\u043E\u0433\u043E \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0442\u0430\u043A\u043E\u0439 \u043E\u0433\u0440\u043E\u043C\u043D\u044B\u0439 \u043D\u043E\u0441",
            "eng": "This man has such a huge nose"
        },
        {
            "rus": "\u041E\u043D \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0430 \u043F\u043E\u0443\u0436\u0438\u043D\u0430\u043B\u0430 \u0441 \u043D\u0438\u043C",
            "eng": "He wants her to have dinner with him"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043D\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442\u044C?",
            "eng": "Who do we need to talk to?",
            "regEng": "/(?:Whom? do we need to (?:talk|speak) (?:to|with)\\?)|(?:(?:To|With) whom do we need to (?:talk|speak)\\?)/gm"
        }
    ],
    [
        {
            "rus": "\u0423 \u043C\u0435\u043D\u044F \u0435\u0441\u0442\u044C \u043E\u0442\u043B\u0438\u0447\u043D\u043E\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435",
            "eng": "I have an excellent solution",
            "regEng": ""
        },
        {
            "rus": "\u0425\u043E\u0447\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u043F\u043E\u0439\u0442\u0438 \u043D\u0430 \u044D\u0442\u0443 \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0443?",
            "eng": "Does she want to go to this party?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A \u043C\u044B \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u043B\u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0439 \u0444\u0438\u043B\u044C\u043C",
            "eng": "On Monday we watched an interesting film",
            "regEng": "/(?:On Monday we watched an interesting film)|(?:We watched an interesting film on Monday)/gm"
        },
        {
            "rus": "\u0412 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 \u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435 \u043C\u044B \u043F\u043E\u043E\u0431\u0435\u0434\u0430\u043B\u0438 \u0432\u043C\u0435\u0441\u0442\u0435",
            "eng": "Last Sunday we had lunch together",
            "regEng": "/(?:Last Sunday we had lunch together)|(?:We had lunch together last Sunday)/gm"
        },
        {
            "rus": "\u0427\u0442\u043E \u0442\u044B \u0445\u043E\u0447\u0435\u0448\u044C, \u0447\u0442\u043E\u0431\u044B \u044F \u0441\u0434\u0435\u043B\u0430\u043B?",
            "eng": "What do you want me to do?",
            "regEng": ""
        },
        {
            "rus": "\u041B\u0435\u0442\u043E\u043C \u044F \u043E\u0431\u044B\u0447\u043D\u043E \u0435\u0437\u0436\u0443 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0432\u0435\u043B\u043E\u0441\u0438\u043F\u0435\u0434\u0435",
            "eng": "In summer I usually go to work by bicycle",
            "regEng": "/(?:In summer I usually go to work by bicycle)|(?:I usually go to work by bicycle in summer)/gm"
        },
        {
            "rus": "\u041F\u043E\u0435\u0445\u0430\u043B\u0438 \u043B\u0438 \u043E\u043D\u0438 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u043C \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0435 \u0432\u0447\u0435\u0440\u0430?",
            "eng": "Did they go to work by public transport yesterday?",
            "regEng": ""
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u043E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442\u044C?",
            "eng": "What does she want to talk about?",
            "regEng": "/(?:What does she want to talk about\\?)|(?:What does she want to speak about\\?)/gm"
        }
    ],
    [
        {
            "rus": "\u042F \u043E\u0447\u0435\u043D\u044C \u0445\u043E\u0447\u0443 \u043F\u0438\u0442\u044C",
            "eng": "I am very thirsty",
            "regEng": "/(?:(?:I am|I\u2019m) very thirsty)/gm"
        },
        {
            "rus": "\u042F \u043D\u0435 \u043E\u0447\u0435\u043D\u044C \u0445\u043E\u0447\u0443 \u043F\u0438\u0442\u044C",
            "eng": "I am not very thirsty",
            "regEng": "/(?:(?:I am|I\u2019m) not very thirsty)/gm"
        },
        {
            "rus": "\u041E\u0447\u0435\u043D\u044C \u043B\u0438 \u044F \u0445\u043E\u0447\u0443 \u043F\u0438\u0442\u044C",
            "eng": "Am I very thirsty?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u044F \u0442\u0430\u043A \u0445\u043E\u0447\u0443 \u043F\u0438\u0442\u044C ?",
            "eng": "Why am I so thirsty?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0438 \u043E\u0447\u0435\u043D\u044C \u0441\u043E\u0436\u0430\u043B\u0435\u044E\u0442",
            "eng": "They are very sorry",
            "regEng": "/(?:(?:They are|They\u2019re) very sorry)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0435 \u043E\u0447\u0435\u043D\u044C \u0441\u043E\u0436\u0430\u043B\u0435\u044E\u0442",
            "eng": "They are not very sorry",
            "regEng": "/(?:(?:They are|They\u2019re) not very sorry)|(?:They aren\u2019t very sorry)/gm"
        },
        {
            "rus": "\u041E\u0447\u0435\u043D\u044C \u043B\u0438 \u043E\u043D\u0438 \u0441\u043E\u0436\u0430\u043B\u0435\u044E\u0442?",
            "eng": "Are they very sorry?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u043E\u043D\u0438 \u0442\u0430\u043A \u0441\u043E\u0436\u0430\u043B\u0435\u044E\u0442?",
            "eng": "Why are they so sorry?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0433\u043E\u0442\u043E\u0432\u0430 \u043F\u043E\u043C\u043E\u0447\u044C",
            "eng": "This woman is always ready to help",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0433\u043E\u0442\u043E\u0432\u0430 \u043F\u043E\u043C\u043E\u0447\u044C.",
            "eng": "This woman is not always ready to help",
            "regEng": "/(?:This woman (?:is not|isn\u2019t) always ready to help)/gm"
        },
        {
            "rus": "\u0413\u043E\u0442\u043E\u0432\u0430 \u043B\u0438 \u044D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u043F\u043E\u043C\u043E\u0447\u044C?",
            "eng": "Is this woman always ready to help?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0442\u043E \u044D\u0442\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0433\u043E\u0442\u043E\u0432\u0430 \u0441\u0434\u0435\u043B\u0430\u0442\u044C?",
            "eng": "What is this woman always ready to do?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0447\u0430\u0441\u0442\u043E \u043E\u043F\u0430\u0437\u0434\u044B\u0432\u0430\u044E\u0442",
            "eng": "These men are often late",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u043E\u043F\u0430\u0437\u0434\u044B\u0432\u0430\u044E\u0442",
            "eng": "These men are not often late",
            "regEng": "/(?:These men (?:are not|aren\u2019t) often late)/gm"
        },
        {
            "rus": "\u041E\u043F\u0430\u0437\u0434\u044B\u0432\u0430\u044E\u0442 \u043B\u0438 \u044D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0447\u0430\u0441\u0442\u043E?",
            "eng": "Are these men often late?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u044D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0447\u0430\u0441\u0442\u043E \u043E\u043F\u0430\u0437\u0434\u044B\u0432\u0430\u044E\u0442?",
            "eng": "Why are these men often late?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0422\u043E\u0442 \u0444\u0438\u043B\u044C\u043C \u0431\u044B\u043B \u043E \u043B\u044E\u0431\u0432\u0438",
            "eng": "That film was about love",
            "regEng": "/That (?:film|movie) was about love/gm"
        },
        {
            "rus": "\u0422\u043E\u0442 \u0444\u0438\u043B\u044C\u043C \u043D\u0435 \u0431\u044B\u043B \u043E \u043B\u044E\u0431\u0432\u0438",
            "eng": "That film was not about love",
            "regEng": "/That (?:film|movie) (?:was not|wasn\u2019t) about love/gm"
        },
        {
            "rus": "\u0411\u044B\u043B \u043B\u0438 \u0442\u043E\u0442 \u0444\u0438\u043B\u044C\u043C \u043E \u043B\u044E\u0431\u0432\u0438?",
            "eng": "Was that film about love?",
            "regEng": "/Was that (?:film|movie) about love\\?/gm"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u0431\u044B\u043B \u0442\u043E\u0442 \u0444\u0438\u043B\u044C\u043C?",
            "eng": "What was that film about?",
            "regEng": "/What was that (?:film|movie) about\\?/gm"
        },
        {
            "rus": "\u0422\u0435 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u0431\u044B\u043B\u0438 \u0438\u0437 \u0420\u043E\u0441\u0441\u0438\u0438",
            "eng": "Those women were from Russia",
            "regEng": ""
        },
        {
            "rus": "\u0422\u0435 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u043D\u0435 \u0431\u044B\u043B\u0438 \u0438\u0437 \u0420\u043E\u0441\u0441\u0438\u0438",
            "eng": "Those women were not from Russia",
            "regEng": "/Those women (?:were not|weren\u2019t) from Russia/gm"
        },
        {
            "rus": "\u0411\u044B\u043B\u0438 \u043B\u0438 \u0442\u0435 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u0438\u0437 \u0420\u043E\u0441\u0441\u0438\u0438?",
            "eng": "Were those women from Russia?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u0442\u043A\u0443\u0434\u0430 \u0431\u044B\u043B\u0438 \u0442\u0435 \u0436\u0435\u043D\u0449\u0438\u043D\u044B?",
            "eng": "Where were those women from?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u0433\u043E\u0440\u0434\u0438\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0435\u0439 \u0434\u043E\u0447\u0435\u0440\u044C\u044E",
            "eng": "This man will always be proud of his daughter",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u0433\u043E\u0440\u0434\u0438\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0435\u0439 \u0434\u043E\u0447\u0435\u0440\u044C\u044E",
            "eng": "This man will not always be proud of his daughter",
            "regEng": "/This man (?:will not|won\u2019t) always be proud of his daughter/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u044D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0433\u043E\u0440\u0434\u0438\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0435\u0439 \u0434\u043E\u0447\u0435\u0440\u044C\u044E?",
            "eng": "Will this man always be proud of his daughter?",
            "regEng": ""
        },
        {
            "rus": "\u041A\u0435\u043C \u044D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u0432\u0441\u0435\u0433\u0434\u0430 \u0433\u043E\u0440\u0434\u0438\u0442\u044C\u0441\u044F?",
            "eng": "Who will this man always be proud of?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0431\u0443\u0434\u0443\u0442 \u0447\u0430\u0441\u0442\u043E \u0431\u0435\u0441\u043F\u043E\u043A\u043E\u0438\u0442\u044C\u0441\u044F \u043E \u0434\u0435\u043D\u044C\u0433\u0430\u0445",
            "eng": "These people will often be worried about money",
            "regEng": "/These people will often (?:be worried|worry) about money/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0431\u0443\u0434\u0443\u0442 \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u0431\u0435\u0441\u043F\u043E\u043A\u043E\u0438\u0442\u044C\u0441\u044F \u043E \u0434\u0435\u043D\u044C\u0433\u0430\u0445",
            "eng": "These people will not often be worried about money",
            "regEng": "/These people (?:will not|won\u2019t) often (?:be worried|worry) about money/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0443\u0442 \u043B\u0438 \u044D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0447\u0430\u0441\u0442\u043E \u0431\u0435\u0441\u043F\u043E\u043A\u043E\u0438\u0442\u044C\u0441\u044F \u043E \u0434\u0435\u043D\u044C\u0433\u0430\u0445?",
            "eng": "Will these people often be worried about money?",
            "regEng": "/Will these people often (?:be worried|worry) about money\\?/gm"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u044D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0431\u0443\u0434\u0443\u0442 \u0447\u0430\u0441\u0442\u043E \u0431\u0435\u0441\u043F\u043E\u043A\u043E\u0438\u0442\u044C\u0441\u044F?",
            "eng": "What will these people often be worried about?",
            "regEng": "/What will these people often (?:be worried|worry) about?/gm"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E \u043C\u0430\u0448\u0438\u043D\u0430 \u0442\u0432\u043E\u0435\u0433\u043E \u0434\u0440\u0443\u0433\u0430",
            "eng": "This is your friend`s car",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u043D\u0435 \u043C\u0430\u0448\u0438\u043D\u0430 \u0442\u0432\u043E\u0435\u0433\u043E \u0434\u0440\u0443\u0433\u0430",
            "eng": "This is not your friend`s car",
            "regEng": "/This (?:is not|isn\u2019t) your friend\u2019s car/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u043C\u0430\u0448\u0438\u043D\u0430 \u0442\u0432\u043E\u0435\u0433\u043E \u0434\u0440\u0443\u0433\u0430?",
            "eng": "Is this your friend`s car?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u043C\u0430\u0448\u0438\u043D\u0430?",
            "eng": "Whose car is this?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0442\u0443\u0444\u043B\u0438 \u043C\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u044B",
            "eng": "These are my sister`s shoes",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u043D\u0435 \u0442\u0443\u0444\u043B\u0438 \u043C\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u044B",
            "eng": "These are not my sister`s shoes",
            "regEng": "/These (?:are not|aren\u2019t) my sister\u2019s shoes/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u0442\u0443\u0444\u043B\u0438 \u043C\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u044B?",
            "eng": "Are these my sister`s shoes?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u0442\u0443\u0444\u043B\u0438?",
            "eng": "Whose shoes are these?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0435\u0451 \u043E\u0442\u0446\u0430",
            "eng": "Those were her father`s documents",
            "regEng": "/Those were her (?:father`s|dad`s) documents/gm"
        },
        {
            "rus": "\u0422\u043E \u043D\u0435 \u0431\u044B\u043B\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0435\u0451 \u043E\u0442\u0446\u0430",
            "eng": "Those were not her father`s documents",
            "regEng": "/Those (?:were not|weren\u2019t) her (?:father`s|dad`s) documents/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0435\u0451 \u043E\u0442\u0446\u0430?",
            "eng": "Were those her father`s documents?",
            "regEng": "/Were those her (?:father`s|dad`s) documents\\?/gm"
        },
        {
            "rus": "\u0427\u044C\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0442\u043E \u0431\u044B\u043B\u0438?",
            "eng": "Whose documents were those?",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u043E \u043F\u043B\u0430\u0442\u044C\u0435 \u0435\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438",
            "eng": "That was his mother`s dress",
            "regEng": "/That was his (?:mother`s|mom`s|mum`s) dress/gm"
        },
        {
            "rus": "\u0422\u043E \u043D\u0435 \u0431\u044B\u043B\u043E \u043F\u043B\u0430\u0442\u044C\u0435 \u0435\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438",
            "eng": "That was not his mother`s dress",
            "regEng": "/That (?:was not|wasn\u2019t) his (?:mother`s|mom`s|mum`s) dress/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u043E \u043F\u043B\u0430\u0442\u044C\u0435 \u0435\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438?",
            "eng": "Was that his mother`s dress?",
            "regEng": "/Was that his (?:mother`s|mom`s|mum`s) dress\\?/gm"
        },
        {
            "rus": "\u0427\u044C\u0451 \u043F\u043B\u0430\u0442\u044C\u0435 \u0442\u043E \u0431\u044B\u043B\u043E?",
            "eng": "Whose dress was that?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0422\u0435\u0431\u0435 \u043E\u0447\u0435\u043D\u044C \u0445\u043E\u043B\u043E\u0434\u043D\u043E",
            "eng": "You are very cold",
            "regEng": "/(?:You are|You\u2019re) very cold/gm"
        },
        {
            "rus": "\u0422\u0435\u0431\u0435 \u043D\u0435 \u043E\u0447\u0435\u043D\u044C \u0445\u043E\u043B\u043E\u0434\u043D\u043E",
            "eng": "You are not very cold",
            "regEng": "/(?:You are|You\u2019re) not very cold/gm"
        },
        {
            "rus": "\u041E\u0447\u0435\u043D\u044C \u043B\u0438 \u0442\u0435\u0431\u0435 \u0445\u043E\u043B\u043E\u0434\u043D\u043E?",
            "eng": "Are you very cold?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u0435\u0431\u0435 \u0442\u0430\u043A \u0445\u043E\u043B\u043E\u0434\u043D\u043E?",
            "eng": "Why are you so cold?",
            "regEng": ""
        },
        {
            "rus": "\u041C\u043D\u0435 \u043E\u0447\u0435\u043D\u044C \u0436\u0430\u0440\u043A\u043E",
            "eng": "I am very hot",
            "regEng": "/(?:I am|I\u2019m) very hot/gm"
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0435 \u043E\u0447\u0435\u043D\u044C \u0436\u0430\u0440\u043A\u043E",
            "eng": "I am not very hot",
            "regEng": "/(?:I am|I\u2019m) not very hot/gm"
        },
        {
            "rus": "\u041E\u0447\u0435\u043D\u044C \u043B\u0438 \u043C\u043D\u0435 \u0436\u0430\u0440\u043A\u043E?",
            "eng": "Am I very hot?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u043C\u043D\u0435 \u0442\u0430\u043A \u0436\u0430\u0440\u043A\u043E?",
            "eng": "Why am I so hot?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u0434 \u0432\u0438\u0434\u0435\u0442\u044C \u0435\u0451",
            "eng": "This man is always glad to see her",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u0434 \u0432\u0438\u0434\u0435\u0442\u044C \u0435\u0451",
            "eng": "This man is not always glad to see her",
            "regEng": "/This man (?:is not|isn\u2019t) always glad to see her/gm"
        },
        {
            "rus": "\u0420\u0430\u0434 \u043B\u0438 \u044D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0432\u0438\u0434\u0435\u0442\u044C \u0435\u0451?",
            "eng": "Is this man always glad to see her?",
            "regEng": ""
        },
        {
            "rus": "\u041A\u043E\u0433\u043E \u044D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u0434 \u0432\u0438\u0434\u0435\u0442\u044C?",
            "eng": "Who is this man always glad to see?",
            "regEng": "/Whom? is this man always glad to see\\?/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u0440\u0438\u0445\u043E\u0434\u044F\u0442 \u0432\u043E\u0432\u0440\u0435\u043C\u044F",
            "eng": "These people are usually on time",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u043D\u0435 \u043F\u0440\u0438\u0445\u043E\u0434\u044F\u0442 \u0432\u043E\u0432\u0440\u0435\u043C\u044F",
            "eng": "These people are not usually on time",
            "regEng": "/These people (?:are not|aren\u2019t) usually on time/gm"
        },
        {
            "rus": "\u041F\u0440\u0438\u0445\u043E\u0434\u044F\u0442 \u043B\u0438 \u044D\u0442\u0438 \u043B\u044E\u0434\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u0432\u043E\u0432\u0440\u0435\u043C\u044F?",
            "eng": "Are these people usually on time?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u044D\u0442\u0438 \u043B\u044E\u0434\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u0440\u0438\u0445\u043E\u0434\u044F\u0442 \u0432\u043E\u0432\u0440\u0435\u043C\u044F?",
            "eng": "Why are these people usually on time?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0422\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u043B\u0441\u044F \u043C\u0443\u0437\u044B\u043A\u043E\u0439",
            "eng": "That person was interested in music",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u043D\u0435 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u043B\u0441\u044F \u043C\u0443\u0437\u044B\u043A\u043E\u0439",
            "eng": "That person was not interested in music",
            "regEng": "/That person (?:was not|wasn\u2019t) interested in music/gm"
        },
        {
            "rus": "\u0418\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u043B\u0441\u044F \u043B\u0438 \u0442\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u043C\u0443\u0437\u044B\u043A\u043E\u0439?",
            "eng": "Was that person interested in music?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0435\u043C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u043B\u0441\u044F \u0442\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A?",
            "eng": "What was that person interested in?",
            "regEng": ""
        },
        {
            "rus": "\u0422\u0435 \u0434\u0435\u0442\u0438 \u0431\u043E\u044F\u043B\u0438\u0441\u044C \u0441\u043E\u0431\u0430\u043A",
            "eng": "Those children were afraid of dogs",
            "regEng": "/Those (?:children|kids) were (?:afraid|scared) of dogs/gm"
        },
        {
            "rus": "\u0422\u0435 \u0434\u0435\u0442\u0438 \u043D\u0435 \u0431\u043E\u044F\u043B\u0438\u0441\u044C \u0441\u043E\u0431\u0430\u043A",
            "eng": "Those children were not afraid of dogs",
            "regEng": "/Those (?:children|kids) (?:were not|weren\u2019t) (?:afraid|scared) of dogs/gm"
        },
        {
            "rus": "\u0411\u043E\u044F\u043B\u0438\u0441\u044C \u043B\u0438 \u0442\u0435 \u0434\u0435\u0442\u0438 \u0441\u043E\u0431\u0430\u043A?",
            "eng": "Were those children afraid of dogs?",
            "regEng": "/Were those (?:children|kids) (?:afraid|scared) of dogs\\?/gm"
        },
        {
            "rus": "\u0427\u0435\u0433\u043E \u0431\u043E\u044F\u043B\u0438\u0441\u044C \u0442\u0435 \u0434\u0435\u0442\u0438?",
            "eng": "What were those children afraid of?",
            "regEng": "/What were those (?:children|kids) (?:afraid|scared) of?/gm"
        }
    ],
    [
        {
            "rus": "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0443\u0434\u0443\u0442 \u0431\u0435\u0437 \u0443\u043C\u0430 \u043E\u0442 \u0442\u0430\u043A\u0438\u0445 \u0436\u0435\u043D\u0449\u0438\u043D",
            "eng": "Men will always be crazy about such women",
            "regEng": ""
        },
        {
            "rus": "\u041C\u0443\u0436\u0447\u0438\u043D\u044B \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0443\u0434\u0443\u0442 \u0431\u0435\u0437 \u0443\u043C\u0430 \u043E\u0442 \u0442\u0430\u043A\u0438\u0445 \u0436\u0435\u043D\u0449\u0438\u043D",
            "eng": "Men will not always be crazy about such women",
            "regEng": "/Men (?:will not|won\u2019t) always be crazy about such women/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0443\u0442 \u043B\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0435\u0437 \u0443\u043C\u0430 \u043E\u0442 \u0442\u0430\u043A\u0438\u0445 \u0436\u0435\u043D\u0449\u0438\u043D?",
            "eng": "Will men always be crazy about such women?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u0442 \u043A\u043E\u0433\u043E \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0443\u0434\u0443\u0442 \u0431\u0435\u0437 \u0443\u043C\u0430?",
            "eng": "Who will men always be crazy about?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0431\u0443\u0434\u0443\u0442 \u0447\u0430\u0441\u0442\u043E \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u043C\u0438 \u043E\u0442 \u0440\u0430\u0431\u043E\u0442\u044B",
            "eng": "These people will often be tired of work",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0447\u0430\u0441\u0442\u043E \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u043C\u0438 \u043E\u0442 \u0440\u0430\u0431\u043E\u0442\u044B",
            "eng": "These people will not often be tired of work",
            "regEng": "/These people (?:will not|won\u2019t) often be tired of work/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0443\u0442 \u043B\u0438 \u044D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0447\u0430\u0441\u0442\u043E \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u043C\u0438 \u043E\u0442 \u0440\u0430\u0431\u043E\u0442\u044B?",
            "eng": "Will these people often be tired of work?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u0442 \u0447\u0435\u0433\u043E \u044D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0431\u0443\u0434\u0443\u0442 \u0447\u0430\u0441\u0442\u043E \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u043C\u0438?",
            "eng": "What will these people often be tired of?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E \u0441\u0443\u043C\u043A\u0430 \u0432\u0430\u0448\u0435\u0439 \u0442\u0451\u0442\u0438",
            "eng": "This is your aunt`s bag",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0441\u0443\u043C\u043A\u0430 \u043D\u0435 \u0432\u0430\u0448\u0435\u0439 \u0442\u0451\u0442\u0438",
            "eng": "This is not your aunt`s bag",
            "regEng": "/This (?:is not|isn\u2019t) your aunt\u2019s bag/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u0441\u0443\u043C\u043A\u0430 \u0432\u0430\u0448\u0435\u0439 \u0442\u0451\u0442\u0438?",
            "eng": "Is this your aunt`s bag?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u0441\u0443\u043C\u043A\u0430?",
            "eng": "Whose bag is this?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u043E\u0434\u0435\u0436\u0434\u0430 \u043D\u0430\u0448\u0435\u0433\u043E \u0431\u0440\u0430\u0442\u0430",
            "eng": "These are our brother`s clothes",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u043E\u0434\u0435\u0436\u0434\u0430 \u043D\u0435 \u043D\u0430\u0448\u0435\u0433\u043E \u0431\u0440\u0430\u0442\u0430",
            "eng": "These are not our brother`s clothes",
            "regEng": "/These (?:are not|aren\u2019t) our brother`s clothes/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u043E\u0434\u0435\u0436\u0434\u0430 \u043D\u0430\u0448\u0435\u0433\u043E \u0431\u0440\u0430\u0442\u0430?",
            "eng": "Are these our brother`s clothes?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u043E\u0434\u0435\u0436\u0434\u0430?",
            "eng": "Whose clothes are these?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0447\u0430\u0441\u044B \u0435\u0433\u043E \u0434\u0435\u0434\u0443\u0448\u043A\u0438",
            "eng": "That was his grandfather`s watch",
            "regEng": "/That was his (?:grandfather\u2019s|grandpa\u2019s) watch/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0447\u0430\u0441\u044B \u043D\u0435 \u0435\u0433\u043E \u0434\u0435\u0434\u0443\u0448\u043A\u0438",
            "eng": "That was not his grandfather`s watch",
            "regEng": "/That (?:was not|wasn\u2019t) his (?:grandfather\u2019s|grandpa\u2019s) watch/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0447\u0430\u0441\u044B \u0435\u0433\u043E \u0434\u0435\u0434\u0443\u0448\u043A\u0438?",
            "eng": "Was that his grandfather`s watch?",
            "regEng": "/Was that his (?:grandfather\u2019s|grandpa\u2019s) watch\\?/gm"
        },
        {
            "rus": "\u0427\u044C\u0438 \u0442\u043E \u0431\u044B\u043B\u0438 \u0447\u0430\u0441\u044B?",
            "eng": "Whose watch was that?",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u043A\u043D\u0438\u0433\u0438 \u043C\u043E\u0435\u0433\u043E \u0434\u044F\u0434\u0438",
            "eng": "Those were my uncle`s books",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u043A\u043D\u0438\u0433\u0438 \u043D\u0435 \u043C\u043E\u0435\u0433\u043E \u0434\u044F\u0434\u0438",
            "eng": "Those were not my uncle`s books",
            "regEng": "/Those (?:were not|weren\u2019t) my uncle\u2019s books/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u043A\u043D\u0438\u0433\u0438 \u043C\u043E\u0435\u0433\u043E \u0434\u044F\u0434\u0438?",
            "eng": "Were those my uncle`s books?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u0438 \u043A\u043D\u0438\u0433\u0438 \u0442\u043E \u0431\u044B\u043B\u0438?",
            "eng": "Whose books were those?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041C\u043E\u044F \u0441\u0435\u0441\u0442\u0440\u0430 \u043E\u0442\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u043A\u0442\u043E\u0440",
            "eng": "My sister is an excellent doctor",
            "regEng": ""
        },
        {
            "rus": "\u0422\u0435\u0431\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0438\u0433\u0440\u0430\u0442\u044C \u0432 \u0438\u0433\u0440\u044B? \u0414\u0430, \u043C\u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0438\u0433\u0440\u0430\u0442\u044C \u0432 \u043A\u0430\u0440\u0442\u044B",
            "eng": "Do you like to play games? Yes, I like to play cards",
            "regEng": "/Do you like to (?:play|playing) games\\? Yes, I like to play cards/gm"
        },
        {
            "rus": "\u041D\u0430 \u043F\u0440\u043E\u0448\u043B\u043E\u0439 \u043D\u0435\u0434\u0435\u043B\u0435 \u043E\u043D\u0438 \u043F\u043E\u0443\u0436\u0438\u043D\u0430\u043B\u0438 \u0432\u043C\u0435\u0441\u0442\u0435",
            "eng": "Last week they had dinner together",
            "regEng": "/(?:Last week they had dinner together)|(?:They had dinner together last week)/gm"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u0432\u044B \u043E\u0442\u043A\u0440\u044B\u043B\u0438 \u0441\u0432\u043E\u0439 \u043C\u0430\u0433\u0430\u0437\u0438\u043D? \u041C\u044B \u043E\u0442\u043A\u0440\u044B\u043B\u0438 \u0441\u0432\u043E\u0439 \u043C\u0430\u0433\u0430\u0437\u0438\u043D \u043C\u0435\u0441\u044F\u0446 \u043D\u0430\u0437\u0430\u0434",
            "eng": "When did you open your shop? We opened our shop a month ago",
            "regEng": ""
        },
        {
            "rus": "\u0413\u0434\u0435 \u0436\u0438\u0432\u0451\u0442 \u0442\u0432\u043E\u044F \u043F\u043E\u0434\u0440\u0443\u0433\u0430?",
            "eng": "Where does your friend live?",
            "regEng": ""
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u044F \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B?",
            "eng": "Who do you want me to talk to?",
            "regEng": "/(?:Whom? do you want me to (?:talk|speak) (?:to|with)\\?)|(?:(?:To|With) whom do you want me to (?:talk|speak)\\?)/gm"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u0435\u0451 \u043C\u0443\u0436 \u043F\u0440\u0438\u0448\u0451\u043B \u0434\u043E\u043C\u043E\u0439?",
            "eng": "When did her husband come home?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041C\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u043C \u0440\u0430\u043D\u043E",
            "eng": "We always have breakfast early",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442 \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u0442\u044C? \u042F \u043D\u0435 \u0437\u043D\u0430\u044E",
            "eng": "What does she want to listen to? I do not know",
            "regEng": "/What does she want to listen to\\? I (?:do not|don\u2019t) know/gm"
        },
        {
            "rus": "\u041E\u043D \u0432\u0441\u0442\u0440\u0435\u0442\u0438\u043B \u0441\u0432\u043E\u044E \u0436\u0435\u043D\u0443 \u0433\u043E\u0434 \u043D\u0430\u0437\u0430\u0434",
            "eng": "He met his wife a year ago",
            "regEng": "/(?:He met his wife a year ago)|(?:A year ago he met his wife)/gm"
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u0435\u0431\u0435 \u043D\u0443\u0436\u043D\u043E \u043F\u043E\u0439\u0442\u0438 \u0442\u0443\u0434\u0430?",
            "eng": "Why do you need to go there?",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0451 \u0431\u0440\u0430\u0442 \u0442\u0430\u043A\u043E\u0439 \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0439",
            "eng": "Her brother is so successful",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043C\u044B \u043F\u043E\u0435\u0445\u0430\u043B\u0438 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0442\u0430\u043A\u0441\u0438",
            "eng": "Yesterday we went to work by taxi",
            "regEng": "/(?:Yesterday we went to work by taxi)|(?:We went to work by taxi yesterday)/gm"
        },
        {
            "rus": "\u0427\u0442\u043E \u043E\u043D\u0430 \u043F\u044C\u0451\u0442 \u043A\u0430\u0436\u0434\u043E\u0435 \u0443\u0442\u0440\u043E? \u041A\u0430\u0436\u0434\u043E\u0435 \u0443\u0442\u0440\u043E \u043E\u043D\u0430 \u043F\u044C\u0451\u0442 \u043A\u043E\u0444\u0435",
            "eng": "What does she drink every morning? Every morning she drinks coffee",
            "regEng": "/What does she drink every morning\\? (?:Every morning she drinks coffee|She drinks coffee every morning)/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0442\u0430\u043A\u0438\u0435 \u0434\u043E\u0431\u0440\u044B\u0435 \u0438 \u0434\u0440\u0443\u0436\u0435\u043B\u044E\u0431\u043D\u044B\u0435",
            "eng": "These people are so kind and friendly",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u044F \u043F\u043E\u043C\u043E\u0433 \u0435\u0451 \u0434\u0435\u0442\u044F\u043C",
            "eng": "She wants me to help her children",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u0442\u044B \u043F\u0440\u0438\u0448\u0435\u043B \u0434\u043E\u043C\u043E\u0439 \u0440\u0430\u043D\u043E",
            "eng": "Yesterday you came home early",
            "regEng": "/(?:Yesterday you came home early)|(?:You came home early yesterday)/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0441\u043C\u043E\u0442\u0440\u044F\u0442 \u0442\u0430\u043A\u0438\u0435 \u0448\u043E\u0443",
            "eng": "These women never watch such shows",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0442\u043E \u043C\u044B \u0447\u0430\u0441\u0442\u043E \u0438\u0449\u0435\u043C \u0437\u0434\u0435\u0441\u044C?",
            "eng": "What do we often look for here?",
            "regEng": "/What do we often (?:look|search) for here\\?/gm"
        },
        {
            "rus": "\u042F \u0432\u0438\u0434\u0435\u043B \u0432\u0430\u0448\u0443 \u0434\u043E\u0447\u044C \u0432\u0447\u0435\u0440\u0430",
            "eng": "I saw your daughter yesterday",
            "regEng": "/(?:I saw your daughter yesterday)|(?:Yesterday I saw your daughter)/gm"
        },
        {
            "rus": "\u0415\u043C\u0443 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u043F\u043E\u0441\u0435\u0449\u0430\u0442\u044C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043C\u0435\u0441\u0442\u0430 \u043A\u0430\u0436\u0434\u044B\u0439 \u0433\u043E\u0434",
            "eng": "He likes to visit interesting places every year",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0442\u0430\u043A\u0438\u0435 \u0434\u043E\u0431\u0440\u044B\u0435 \u0438 \u0434\u0440\u0443\u0436\u0435\u043B\u044E\u0431\u043D\u044B\u0435",
            "eng": "These people are so kind and friendly",
            "regEng": ""
        },
        {
            "rus": "\u0420\u043E\u0434\u0438\u0442\u0435\u043B\u044F\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0438\u0445 \u0434\u0435\u0442\u0438 \u0447\u0438\u0441\u0442\u0438\u043B\u0438 \u0441\u0432\u043E\u0438 \u0437\u0443\u0431\u044B",
            "eng": "Parents need their children to brush their teeth",
            "regEng": ""
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u043F\u043E\u043E\u0431\u0435\u0434\u0430\u043B\u0438?",
            "eng": "When did they have lunch?",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u043D\u0430\u0439\u0442\u0438 \u043D\u043E\u0432\u0443\u044E \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443",
            "eng": "We need to find a new flat",
            "regEng": "/We need to find a new (?:flat|apartment)/gm"
        }
    ],
    [
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0438 \u043F\u043E\u0438\u0433\u0440\u0430\u043B\u0438 \u0432 \u0438\u0433\u0440\u044B",
            "eng": "Yesterday they played games",
            "regEng": ""
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u043E\u043D \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442 \u0441\u0432\u043E\u0435\u043C\u0443 \u0434\u0440\u0443\u0433\u0443",
            "eng": "Tomorrow he will not call his friend",
            "regEng": "/(?:Tomorrow he (?:will not|won\u2019t) call his friend)|(?:He (?:will not|won\u2019t) call his friend tomorrow)/gm"
        },
        {
            "rus": "\u0427\u0442\u043E\u0431\u044B \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u044D\u0442\u043E, \u0442\u0435\u0431\u0435 \u043D\u0443\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0441\u0438\u043B\u044C\u043D\u044B\u043C",
            "eng": "To do this you need to be strong",
            "regEng": "/(?:To do (?:this|it|that) you need to be strong)|(?:You need to be strong to do (?:this|it|that))/gm"
        },
        {
            "rus": "\u041F\u043E\u0435\u0445\u0430\u043B\u0438 \u043B\u0438 \u043E\u043D\u0438 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435 \u043C\u0435\u0441\u044F\u0446 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did they go home by train a month ago?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0430 \u0445\u043E\u0447\u0435\u0442 \u0438\u043C\u0435\u0442\u044C \u043E\u0442\u043B\u0438\u0447\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443",
            "eng": "She wants to have an excellent job",
            "regEng": ""
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u044F \u0443\u0432\u0438\u0436\u0443 \u044D\u0442\u043E\u0433\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430 \u0437\u0434\u0435\u0441\u044C",
            "eng": "Tomorrow I will see this person here",
            "regEng": "/(?:Tomorrow (?:I will|I\u2019ll) see this person here)|(?:(?:I will|I\u2019ll) see this person here tomorrow)/gm"
        },
        {
            "rus": "\u041C\u044B \u0441\u044A\u0435\u0437\u0434\u0438\u043B\u0438 \u0432 \u044D\u0442\u043E \u043C\u0435\u0441\u0442\u043E \u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u0444\u0435\u0432\u0440\u0430\u043B\u0435",
            "eng": "We went to this place last February",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430\u0448 \u0440\u0435\u0431\u0451\u043D\u043E\u043A \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0435\u0441\u0442 \u0433\u0430\u043C\u0431\u0443\u0440\u0433\u0435\u0440\u044B",
            "eng": "Our child never eats hamburgers",
            "regEng": ""
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u043C \u043B\u0438 \u043C\u044B \u0433\u043E\u0442\u043E\u0432\u044B \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u043D\u0435\u0434\u0435\u043B\u0435?",
            "eng": "Will we be ready next week?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u0435\u0431\u0435 \u0442\u0430\u043A \u0445\u043E\u043B\u043E\u0434\u043D\u043E?",
            "eng": "Why are you so cold?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041A\u0442\u043E \u0445\u043E\u0447\u0435\u0442 \u0443\u0441\u043B\u044B\u0448\u0430\u0442\u044C \u043E\u0442\u043B\u0438\u0447\u043D\u0443\u044E \u0438\u0441\u0442\u043E\u0440\u0438\u044E?",
            "eng": "Who wants to hear an excellent story?",
            "regEng": ""
        },
        {
            "rus": "\u042F \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u0440\u0438\u0445\u043E\u0436\u0443 \u0441\u044E\u0434\u0430 \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0441\u0435\u0445 \u0441\u0432\u043E\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439",
            "eng": "I usually come here on Monday to see all my friends",
            "regEng": ""
        },
        {
            "rus": "\u041F\u0440\u0438\u0445\u043E\u0434\u044F\u0442 \u043B\u0438 \u044D\u0442\u0438 \u043B\u044E\u0434\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u0432\u043E\u0432\u0440\u0435\u043C\u044F?",
            "eng": "Are these people usually on time?",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0437\u044F\u043B\u0438 \u043B\u0438 \u0432\u044B \u043C\u043E\u044E \u043C\u0430\u0448\u0438\u043D\u0443 \u0432\u0447\u0435\u0440\u0430?",
            "eng": "Did you take my car yesterday?",
            "regEng": ""
        },
        {
            "rus": "\u0423 \u043C\u0435\u043D\u044F \u0435\u0441\u0442\u044C \u0445\u043E\u0440\u043E\u0448\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
            "eng": "I have a good question",
            "regEng": ""
        },
        {
            "rus": "\u0423 \u044D\u0442\u043E\u0433\u043E \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0442\u0430\u043A\u043E\u0439 \u043E\u0433\u0440\u043E\u043C\u043D\u044B\u0439 \u043D\u043E\u0441",
            "eng": "This man has such a huge nose",
            "regEng": ""
        },
        {
            "rus": "\u0422\u0440\u0435\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043B\u0438 \u043E\u043D\u0430 \u043F\u0435\u0440\u0435\u0434 \u0440\u0430\u0431\u043E\u0442\u043E\u0439?",
            "eng": "Does she exercise before work?",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u043E\u043A\u0443\u043F\u0430\u0435\u0442 \u0434\u043E\u0440\u043E\u0433\u0438\u0435 \u043A\u043E\u0441\u0442\u044E\u043C\u044B",
            "eng": "That man usually buys expensive suits",
            "regEng": ""
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u044F \u043F\u0440\u0438\u0434\u0443 \u0441\u044E\u0434\u0430",
            "eng": "Tomorrow I will come here",
            "regEng": "/(?:Tomorrow (?:I will|I\u2019ll) come here)|(?:(?:I will|I\u2019ll) come here tomorrow)/gm"
        },
        {
            "rus": "\u0412\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0433\u043E\u0432\u043E\u0440\u0438\u0442\u0435 \u043E\u0431 \u044D\u0442\u043E\u043C",
            "eng": "You never talk about it",
            "regEng": "/You never (?:talk|speak) about (?:it|this|that)/gm"
        }
    ],
    [
        {
            "rus": "\u0423 \u0442\u0435\u0431\u044F \u0442\u0430\u043A\u0438\u0435 \u0431\u0435\u043B\u044B\u0435 \u0437\u0443\u0431\u044B!",
            "eng": "You have such white teeth!",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0435\u0445\u0430\u043B\u0430 \u043B\u0438 \u043E\u043D\u0430 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0435 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did she go to work by car an hour ago?",
            "regEng": ""
        },
        {
            "rus": "\u0413\u0434\u0435 \u043E\u043D\u0438 \u0431\u044B\u043B\u0438 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Where were they an hour ago?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0442\u043E\u0431\u044B \u0431\u044B\u0442\u044C \u0437\u0434\u043E\u0440\u043E\u0432\u044B\u043C, \u0442\u0435\u0431\u0435 \u043D\u0443\u0436\u043D\u043E \u0435\u0441\u0442\u044C \u0445\u043E\u0440\u043E\u0448\u0443\u044E \u0435\u0434\u0443",
            "eng": "To be healthy you need to eat good food",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0442\u043E \u0432\u044B \u043F\u0440\u0438\u043D\u0435\u0441\u0451\u0442\u0435 \u0435\u043C\u0443 \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "What will you bring him tomorrow?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0438 \u0435\u0451 \u0432\u0430\u0436\u043D\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0432\u0447\u0435\u0440\u0430",
            "eng": "They read her important message yesterday",
            "regEng": "/(?:They read her important message yesterday)|(?:Yesterday they read her important message)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0433\u043E\u0442\u043E\u0432\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            "eng": "They are ready to start in a minute",
            "regEng": "/(?:They are|They\u2019re) ready to start in a minute/gm"
        },
        {
            "rus": "\u0423 \u044D\u0442\u043E\u0439 \u0441\u0435\u043C\u044C\u0438 \u043E\u0433\u0440\u043E\u043C\u043D\u044B\u0439 \u0434\u043E\u043C",
            "eng": "This family has a huge house",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u0443\u0436\u0438\u043D\u0430\u0435\u0442 \u0442\u0430\u043C \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "He does not often have dinner there on Monday",
            "regEng": "/He (?:does not|doesn\u2019t) often have dinner there on Monday/gm"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u0431\u044B\u043B \u0442\u043E\u0442 \u0444\u0438\u043B\u044C\u043C?",
            "eng": "What was that film about?",
            "regEng": "/What was that (?:film|movie) about\\?/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u043D\u0430\u0447\u0430\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442 \u043F\u0440\u043E\u0448\u043B\u043E\u0439 \u0432\u0435\u0441\u043D\u043E\u0439",
            "eng": "They started a new project last spring",
            "regEng": ""
        },
        {
            "rus": "\u041C\u044B \u043F\u043E\u0437\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u043C \u0441 \u0432\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u0447\u0430\u0441",
            "eng": "We will have breakfast with you in an hour",
            "regEng": "/(?:We will|We\u2019ll) have breakfast with you in an hour/gm"
        },
        {
            "rus": "\u041A\u0442\u043E \u0432\u044B?",
            "eng": "Who are you?",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0451 \u0434\u0435\u0442\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u044E\u0442 \u0435\u0451",
            "eng": "Her children always listen to her",
            "regEng": ""
        },
        {
            "rus": "\u0416\u0435\u043D\u0449\u0438\u043D\u044B \u0445\u043E\u0442\u044F\u0442, \u0447\u0442\u043E\u0431\u044B \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u043B\u044E\u0431\u0438\u043B\u0438 \u0438\u0445",
            "eng": "Women want men to love them",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0442\u043E \u0442\u044B \u0434\u0435\u043B\u0430\u0435\u0448\u044C \u043F\u043E\u0441\u043B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B?",
            "eng": "What do you do after work?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0442\u043E\u0431\u044B \u0431\u044B\u0442\u044C \u0441\u0438\u043B\u044C\u043D\u044B\u043C \u0438 \u0437\u0434\u043E\u0440\u043E\u0432\u044B\u043C, \u0435\u043C\u0443 \u043D\u0443\u0436\u043D\u043E \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
            "eng": "To be strong and healthy he needs to exercise",
            "regEng": "/(?:To be strong and healthy he needs to exercise)|(?:He needs to exercise to be strong and healthy)/gm"
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442 \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "Who will he talk to in a week?",
            "regEng": "/Who will he (?:talk|speak) (?:to|with) in a week\\?/gm"
        },
        {
            "rus": "\u0422\u043E\u0442 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u043B\u0441\u044F \u043C\u0443\u0437\u044B\u043A\u043E\u0439",
            "eng": "That person was interested in music",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438\u043C \u0436\u0435\u043D\u0449\u0438\u043D\u0430\u043C \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u043B\u0438 \u0438\u0445",
            "eng": "These women need you to listen to them",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0423 \u043A\u043E\u0433\u043E \u0435\u0441\u0442\u044C \u0441\u043B\u043E\u0436\u043D\u044B\u0439 \u0432\u043E\u043F\u0440\u043E\u0441?",
            "eng": "Who has a difficult question?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u044D\u0442\u0438 \u043F\u0435\u0441\u043D\u0438 \u0432 \u0441\u0440\u0435\u0434\u0443",
            "eng": "She does not always listen to these songs on Wednesday",
            "regEng": "/She (?:does not|doesn\u2019t) always listen to these songs on Wednesday/gm"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u044D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0431\u0443\u0434\u0443\u0442 \u0447\u0430\u0441\u0442\u043E \u0431\u0435\u0441\u043F\u043E\u043A\u043E\u0438\u0442\u044C\u0441\u044F?",
            "eng": "What will these people often be worried about?",
            "regEng": ""
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u0443 \u043D\u0430\u0441 \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043B\u0438\u0447\u043D\u0430\u044F \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0430",
            "eng": "Tomorrow we will have an excellent party",
            "regEng": "/(?:Tomorrow (?:we will|we\u2019ll) have an excellent party)|(?:(?:We will|We\u2019ll) have an excellent party tomorrow)/gm"
        },
        {
            "rus": "\u0423\u0436\u0438\u043D\u0430\u044E\u0442 \u043B\u0438 \u043E\u043D\u0438 \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u043D\u043E \u0432 \u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435?",
            "eng": "Do they always have dinner early on Sunday?",
            "regEng": ""
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430\u043A\u0430\u0435\u0442 \u043B\u0438 \u043E\u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u043F\u043E\u0437\u0434\u043D\u043E \u0432 \u0441\u0443\u0431\u0431\u043E\u0442\u0443?",
            "eng": "Does she often have breakfast late on Saturday?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u0447\u0430\u0441\u0442\u043E \u0447\u0438\u0442\u0430\u044E\u0442 \u0433\u0430\u0437\u0435\u0442\u044B \u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u044B",
            "eng": "These people often read newspapers and magazines",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u044F \u043D\u0430\u043F\u0438\u0441\u0430\u043B \u0432\u0430\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
            "eng": "Yesterday I wrote you a message",
            "regEng": "/(?:Yesterday I wrote you a message)|(?:I wrote you a message yesterday)/gm"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u0442\u044B \u043F\u043E\u0439\u0434\u0435\u0448\u044C \u0432 \u043A\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0432\u0442\u0440\u0430?",
            "eng": "When will you go to bed tomorrow?",
            "regEng": "/When will you go to (?:bed|sleep) tomorrow?/gm"
        },
        {
            "rus": "\u041C\u044B \u043F\u0440\u0438\u043D\u0435\u0441\u0451\u043C \u0442\u0435\u0431\u0435 \u044D\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0432\u0442\u043E\u0440\u043D\u0438\u043A",
            "eng": "We will bring you these documents next Tuesday",
            "regEng": "/(?:We will|We\u2019ll) bring you these documents next Tuesday/gm"
        }
    ],
    [
        {
            "rus": "\u041A\u0442\u043E \u043F\u043E\u043C\u043D\u0438\u0442 \u0442\u0443 \u043A\u0440\u0430\u0441\u0438\u0432\u0443\u044E \u0434\u0435\u0432\u0443\u0448\u043A\u0443?",
            "eng": "Who remembers that beautiful girl?",
            "regEng": ""
        },
        {
            "rus": "\u041A\u043E\u0433\u043E \u044D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u0434 \u0432\u0438\u0434\u0435\u0442\u044C?",
            "eng": "Who is this man always glad to see?",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0439 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0448\u043E\u043A\u043E\u043B\u0430\u0434?",
            "eng": "Does she like chocolate?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043C\u0443\u0436\u0447\u0438\u043D\u044B \u0447\u0430\u0441\u0442\u043E \u043E\u043F\u0430\u0437\u0434\u044B\u0432\u0430\u044E\u0442",
            "eng": "These men are often late",
            "regEng": ""
        },
        {
            "rus": "\u042F \u043D\u0435 \u0431\u044B\u043B \u0437\u0434\u0435\u0441\u044C \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            "eng": "I was not here a minute ago",
            "regEng": "/I (?:was not|wasn\u2019t) here a minute ago/gm"
        },
        {
            "rus": "\u041E\u043D \u0445\u043E\u0440\u043E\u0448\u0438\u0439 \u0434\u043E\u043A\u0442\u043E\u0440",
            "eng": "He is a good doctor",
            "regEng": "/(?:He is|He\u2019s) a good doctor/gm"
        },
        {
            "rus": "\u0427\u0435\u0433\u043E \u043E\u043D \u0432\u0441\u0435\u0433\u0434\u0430 \u0436\u0434\u0451\u0442?",
            "eng": "What does he always wait for?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A \u044F \u043F\u043E\u0435\u0445\u0430\u043B \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0442\u0430\u043A\u0441\u0438",
            "eng": "Last Monday I went to work by taxi",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0439 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u044F \u043D\u0430\u0448\u0451\u043B \u043D\u043E\u0432\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443",
            "eng": "She needs me to find a new job",
            "regEng": ""
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u043C\u044B \u043F\u043E\u0434\u0443\u043C\u0430\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "What will we think about in a week?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D \u043E\u0431\u044B\u0447\u043D\u043E \u0445\u043E\u0434\u0438\u0442 \u0442\u0443\u0434\u0430?",
            "eng": "Who does he usually go there with?",
            "regEng": ""
        },
        {
            "rus": "\u042F \u043E\u0447\u0435\u043D\u044C \u0445\u043E\u0447\u0443 \u043F\u0438\u0442\u044C (\u0438\u0441\u043F\u044B\u0442\u044B\u0432\u0430\u044E \u0436\u0430\u0436\u0434\u0443)",
            "eng": "I am very thirsty",
            "regEng": "/(?:(?:I am|I\u2019m) very thirsty)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u043F\u043E\u0435\u0434\u0435\u0442 \u0442\u0443\u0434\u0430 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u043E\u0439 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446",
            "eng": "She will not go there with her sister in a month",
            "regEng": "/(?:She (?:will not|won\u2019t) go there with her sister in a month)/gm"
        },
        {
            "rus": "\u0423 \u043A\u043E\u0433\u043E \u0435\u0441\u0442\u044C \u0437\u0435\u043B\u0451\u043D\u0430\u044F \u0440\u0443\u0447\u043A\u0430?",
            "eng": "Who has a green pen?",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0430\u0448\u0438 \u0434\u0435\u0442\u0438 \u0445\u043E\u0442\u044F\u0442, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043F\u043E\u0438\u0433\u0440\u0430\u043B\u0438 \u0441 \u043D\u0438\u043C\u0438",
            "eng": "Your children want you to play with them",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u0441\u0443\u043C\u043A\u0430? \u042D\u0442\u043E \u0441\u0443\u043C\u043A\u0430 \u043C\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u044B",
            "eng": "Whose bag is this? This is my sister`s bag",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0434\u0440\u0443\u0437\u044C\u044F \u0438\u0445 \u0431\u0440\u0430\u0442\u0430? \u041D\u0435\u0442, \u044D\u0442\u043E \u043D\u0435 \u0434\u0440\u0443\u0437\u044C\u044F \u0438\u0445 \u0431\u0440\u0430\u0442\u0430",
            "eng": "Are these their brother`s friends? No, these are not their brother`s friends",
            "regEng": "/(?:Are these their brother\u2019s friends\\? No, these (?:are not|aren\u2019t) their brother\u2019s friends)/gm"
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u043E\u0434\u0435\u0436\u0434\u0430? \u042D\u0442\u043E \u043E\u0434\u0435\u0436\u0434\u0430 \u0435\u0451 \u043C\u0430\u0442\u0435\u0440\u0438",
            "eng": "Whose clothes are these? These are her mother`s clothes",
            "regEng": "/(?:Whose clothes are these\\? These are her (?:mother\u2019s|mom\u2019s|mum\u2019s) clothes)/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0447\u0430\u0441\u044B \u0442\u0432\u043E\u0435\u0433\u043E \u043E\u0442\u0446\u0430? \u041D\u0435\u0442, \u0442\u043E \u0431\u044B\u043B\u0438 \u0447\u0430\u0441\u044B \u043D\u0435 \u043C\u043E\u0435\u0433\u043E \u043E\u0442\u0446\u0430",
            "eng": "Was that your father`s watch? No, that was not my father`s watch",
            "regEng": "/(?:Was that your (?:father\u2019s|dad\u2019s|daddy\u2019s) watch\\? No, that (?:was not|wasn\u2019t) my father\u2019s watch)/gm"
        }
    ],
    [
        {
            "rus": "\u0427\u0435\u0439 \u044D\u0442\u043E \u0434\u043E\u043C? \u042D\u0442\u043E \u0434\u043E\u043C \u043C\u043E\u0435\u0433\u043E \u0441\u043E\u0441\u0435\u0434\u0430",
            "eng": "Whose house is this? This is my neighbour`s house",
            "regEng": "/(?:Whose house is this\\? This is my neighbou?r\u2019s house)/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0435\u0433\u043E \u043A\u043E\u043B\u043B\u0435\u0433\u0438? \u041D\u0435\u0442, \u0442\u043E \u0431\u044B\u043B\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043D\u0435 \u0435\u0433\u043E \u043A\u043E\u043B\u043B\u0435\u0433\u0438",
            "eng": "Were those his colleague`s documents? No, those were not his colleague`s documents",
            "regEng": "/(?:Were those his colleague\u2019s documents\\? No, those (?:were not|weren\u2019t) his colleague\u2019s documents)/gm"
        },
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u0442\u0443\u0444\u043B\u0438? \u042D\u0442\u043E \u0442\u0443\u0444\u043B\u0438 \u043D\u0430\u0448\u0435\u0439 \u0431\u0430\u0431\u0443\u0448\u043A\u0438",
            "eng": "Whose shoes are these? These are our grandmother`s shoes",
            "regEng": "/(?:Whose shoes are these\\? These are our (?:grandmother\\\u2019s|granny\\\u2019s) (?:shoes|boots))/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u0440\u0443\u0447\u043A\u0430 \u0442\u0432\u043E\u0435\u0439 \u043F\u043E\u0434\u0440\u0443\u0433\u0438? \u041D\u0435\u0442, \u044D\u0442\u043E \u0440\u0443\u0447\u043A\u0430 \u043D\u0435 \u043C\u043E\u0435\u0439 \u043F\u043E\u0434\u0440\u0443\u0433\u0438",
            "eng": "Is this your friend`s pen? No, this is not my friend`s pen",
            "regEng": "/(?:Is this your friend\u2019s pen\\? No, this (?:is not|isn\u2019t) my friend\u2019s pen)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u043C\u043E\u0451 \u043F\u0430\u043B\u044C\u0442\u043E. \u042D\u0442\u043E \u043F\u0430\u043B\u044C\u0442\u043E \u043C\u043E\u0451",
            "eng": "This is my coat. This coat is mine",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0442\u0432\u043E\u0438 \u0431\u0440\u044E\u043A\u0438? \u042D\u0442\u0438 \u0431\u0440\u044E\u043A\u0438 \u0442\u0432\u043E\u0438?",
            "eng": "Are these your trousers? Are these trousers yours?",
            "regEng": "/(?:Are these your (?:trousers|pants)\\? Are these (?:trousers|pants) yours\\?)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u043D\u0430\u0448\u0438 \u043D\u043E\u0432\u044B\u0435 \u0440\u0443\u0431\u0430\u0448\u043A\u0438. \u042D\u0442\u0438 \u043D\u043E\u0432\u044B\u0435 \u0440\u0443\u0431\u0430\u0448\u043A\u0438 \u043D\u0430\u0448\u0438",
            "eng": "These are our new shirts. These new shirts are ours",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u043E \u043C\u043E\u0451 \u0437\u043E\u043B\u043E\u0442\u043E\u0435 \u043A\u043E\u043B\u044C\u0446\u043E? \u0422\u043E \u0437\u043E\u043B\u043E\u0442\u043E\u0435 \u043A\u043E\u043B\u044C\u0446\u043E \u0431\u044B\u043B\u043E \u043C\u043E\u0451?",
            "eng": "Was that my golden ring? Was that golden ring mine?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u043D\u0430\u0448\u0430 \u043E\u0434\u0435\u0436\u0434\u0430. \u042D\u0442\u0430 \u043E\u0434\u0435\u0436\u0434\u0430 \u043D\u0430\u0448\u0430",
            "eng": "These are our clothes. These clothes are ours",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0438\u0445 \u0441\u0435\u0440\u0435\u0431\u0440\u044F\u043D\u044B\u0435 \u0441\u0435\u0440\u0451\u0436\u043A\u0438? \u0422\u0435 \u0441\u0435\u0440\u0435\u0431\u0440\u044F\u043D\u044B\u0435 \u0441\u0435\u0440\u0451\u0436\u043A\u0438 \u0431\u044B\u043B\u0438 \u0438\u0445?",
            "eng": "Were those their silver earrings? Were those silver earrings theirs?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0435\u0433\u043E \u0441\u0442\u0430\u0440\u044B\u0435 \u0447\u0430\u0441\u044B. \u042D\u0442\u0438 \u0441\u0442\u0430\u0440\u044B\u0435 \u0447\u0430\u0441\u044B \u0435\u0433\u043E",
            "eng": "This is his old watch. This old watch is his",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0435\u0451 \u044E\u0431\u043A\u0430? \u042D\u0442\u0430 \u044E\u0431\u043A\u0430 \u0435\u0451?",
            "eng": "Is this her skirt? Is this skirt hers?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u043F\u043B\u0430\u0442\u044C\u044F? \u041E\u043D\u0438 \u0442\u0432\u043E\u0438",
            "eng": "Whose dresses are these? They are yours",
            "regEng": "/(?:Whose dresses are these\\? (?:They are|They\u2019re) yours)/gm"
        },
        {
            "rus": "\u0422\u043E \u0442\u0432\u043E\u0438 \u043A\u043D\u0438\u0433\u0438? \u041D\u0435\u0442, \u043C\u043E\u0438 \u0437\u0434\u0435\u0441\u044C",
            "eng": "Are those your books? No, mine are here",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u043A\u0430\u0440\u0430\u043D\u0434\u0430\u0448\u0438 \u0435\u0451, \u043D\u0435 \u0442\u0432\u043E\u0438",
            "eng": "These pencils are hers, not yours",
            "regEng": "/(?:These pencils are hers,(?:(?:(?: they are| they\u2019re)? not)|(?: these (?:are not|aren\u2019t))) yours)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u0438\u0445 \u0434\u043E\u043C? \u041D\u0435\u0442, \u0438\u0445 \u0442\u0430\u043C",
            "eng": "Is this their house? No, theirs is there",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u0441\u0443\u043C\u043A\u0430? \u041E\u043D\u0430 \u043C\u043E\u044F",
            "eng": "Whose bag is this? It is mine",
            "regEng": "/(?:Whose bag is this\\? (?:It is|It\u2019s) mine)/gm"
        },
        {
            "rus": "\u042D\u0442\u0430 \u0435\u0434\u0430 \u0432\u0430\u0448\u0430, \u043D\u0435 \u043D\u0430\u0448\u0430",
            "eng": "This food is yours, not ours",
            "regEng": "/(?:This food is yours,(?: it is| it\u2019s)? not ours)/gm"
        },
        {
            "rus": "\u0427\u044C\u0438 \u0442\u043E \u0441\u0435\u0440\u0451\u0436\u043A\u0438? \u041E\u043D\u0438 \u0435\u0451",
            "eng": "Whose earrings are those? They are hers",
            "regEng": "/(?:Whose earrings are those\\? (?:They(?: are|\u2019re) hers|These are hers))/gm"
        },
        {
            "rus": "\u042D\u0442\u0430 \u043E\u0434\u0435\u0436\u0434\u0430 \u0438\u0445, \u043D\u0435 \u043D\u0430\u0448\u0430",
            "eng": "These clothes are theirs, not ours",
            "regEng": "/(?:These clothes are theirs,(?: not| (?:they(?: are|\u2019re)? not|these (?:are not|aren\u2019t))) ours)/gm"
        }
    ],
    [
        {
            "rus": "\u041C\u043E\u0438 \u0448\u0443\u0442\u043A\u0438 \u0441\u043C\u0435\u0448\u043D\u0435\u0435, \u0447\u0435\u043C \u0435\u0451",
            "eng": "My jokes are funnier than hers",
            "regEng": ""
        },
        {
            "rus": "\u0418\u0445 \u0434\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u043D\u0430\u0448",
            "eng": "Their house is bigger than ours",
            "regEng": "/(?:Their house is (?:bigger|larger) than ours)/gm"
        },
        {
            "rus": "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043C\u043E\u0435\u0433\u043E \u0431\u0440\u0430\u0442\u0430 \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u043C\u043E\u0438",
            "eng": "My brother`s results are better than mine",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0433\u043E \u043C\u0430\u0448\u0438\u043D\u0430 \u0431\u043E\u043B\u0435\u0435 \u0443\u0434\u043E\u0431\u043D\u0430\u044F, \u0447\u0435\u043C \u0432\u0430\u0448\u0430",
            "eng": "His car is more comfortable than yours",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0430\u0448\u0430 \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044F \u0445\u0443\u0436\u0435, \u0447\u0435\u043C \u0438\u0445",
            "eng": "Your situation is worse than theirs",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430\u0448\u0438 \u0441\u0443\u043C\u043A\u0438 \u0442\u044F\u0436\u0435\u043B\u0435\u0435, \u0447\u0435\u043C \u0435\u0433\u043E",
            "eng": "Our bags are heavier than his",
            "regEng": ""
        },
        {
            "rus": "\u0412\u043E\u043B\u043E\u0441\u044B \u043C\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u044B \u0442\u0435\u043C\u043D\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u0438",
            "eng": "My sister`s hair is darker than mine",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0451 \u0442\u0435\u043B\u043E \u0442\u043E\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0442\u0432\u043E\u0451",
            "eng": "Her body is thinner than yours",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0412\u0430\u0448\u0430 \u043A\u043E\u0436\u0430 \u0441\u0432\u0435\u0442\u043B\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u044F",
            "eng": "Your skin is lighter than mine",
            "regEng": ""
        },
        {
            "rus": "\u041C\u043E\u0438 \u0440\u0443\u043A\u0438 \u0441\u0438\u043B\u044C\u043D\u0435\u0435, \u0447\u0435\u043C \u0435\u0433\u043E",
            "eng": "My arms are stronger than his",
            "regEng": ""
        },
        {
            "rus": "\u0418\u0445 \u0435\u0434\u0430 \u0436\u0438\u0440\u043D\u0435\u0435, \u0447\u0435\u043C \u043D\u0430\u0448\u0430",
            "eng": "Their food is fatter than ours",
            "regEng": ""
        },
        {
            "rus": "\u041B\u0438\u0446\u043E \u0435\u0451 \u043C\u0430\u0442\u0435\u0440\u0438 \u043A\u0440\u0430\u0441\u0438\u0432\u0435\u0435, \u0447\u0435\u043C \u0435\u0451",
            "eng": "Her mother`s face is more beautiful than hers",
            "regEng": "/(?:Her (?:mother\u2019s|mom\u2019s|mum\u2019s) face is (?:more beautiful|prettier) than hers)/gm"
        },
        {
            "rus": "\u0412\u0430\u0448 \u0432\u043E\u043F\u0440\u043E\u0441 \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u043D\u0430\u0448",
            "eng": "Your question is better than ours",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0431\u043E\u043B\u0435\u0435 \u0432\u0430\u0436\u043D\u044B\u0435, \u0447\u0435\u043C \u0438\u0445",
            "eng": "His messages are more important than theirs",
            "regEng": ""
        },
        {
            "rus": "\u041C\u043E\u0438 \u0440\u0443\u043A\u0438 \u0433\u043E\u0440\u044F\u0447\u0435\u0435, \u0447\u0435\u043C \u0442\u0432\u043E\u0438",
            "eng": "My hands are hotter than yours",
            "regEng": ""
        },
        {
            "rus": "\u0418\u0445 \u0431\u0443\u0442\u0435\u0440\u0431\u0440\u043E\u0434\u044B \u0432\u043A\u0443\u0441\u043D\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u0438",
            "eng": "Their sandwiches are tastier than mine",
            "regEng": "/(?:Their sandwiches are (?:tastier|more delicious) than mine)/gm"
        }
    ],
    [
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u043C\u0430\u043B\u044B\u0448\u0438? \u042D\u0442\u043E \u043C\u0430\u043B\u044B\u0448\u0438 \u043C\u043E\u0435\u0433\u043E \u0441\u043E\u0441\u0435\u0434\u0430",
            "eng": "Whose babies are these? These are my neighbour`s babies",
            "regEng": "/(?:Whose babies are these\\? These are my neighbou?r\u2019s babies)/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0430 \u0441\u0443\u043C\u043A\u0430 \u0432\u0430\u0448\u0435\u0439 \u0434\u043E\u0447\u0435\u0440\u0438? \u041D\u0435\u0442, \u0442\u043E \u043D\u0435 \u0431\u044B\u043B\u0430 \u0441\u0443\u043C\u043A\u0430 \u043D\u0430\u0448\u0435\u0439 \u0434\u043E\u0447\u0435\u0440\u0438",
            "eng": "Was that your daughter`s bag? No, that was not our daughter`s bag",
            "regEng": "/(?:Was that your daughter`s bag\\? No, that was not our daughter`s bag)/gm"
        },
        {
            "rus": "\u0427\u0435\u0439 \u0442\u043E \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A? \u0422\u043E \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A \u0435\u0433\u043E \u0436\u0435\u043D\u044B",
            "eng": "Whose relative is that? That is his wife`s relative",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0430 \u043E\u0434\u0435\u0436\u0434\u0430 \u0435\u0451 \u043C\u0443\u0436\u0430? \u041D\u0435\u0442, \u0442\u043E \u043D\u0435 \u0431\u044B\u043B\u0430 \u043E\u0434\u0435\u0436\u0434\u0430 \u0435\u0451 \u043C\u0443\u0436\u0430",
            "eng": "Were those her husband`s clothes? No, those were not her husband`s clothes",
            "regEng": "/(?:Were those her husband\u2019s clothes\\? No, those were not her husband\u2019s clothes)/gm"
        },
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u043A\u043E\u0442\u044B? \u042D\u0442\u043E \u043A\u043E\u0442\u044B \u043D\u0430\u0448\u0435\u0439 \u0431\u0430\u0431\u0443\u0448\u043A\u0438",
            "eng": "Whose cats are these? These are our grandmother`s cats",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0447\u0430\u0441\u044B \u0438\u0445 \u0434\u0435\u0434\u0443\u0448\u043A\u0438? \u041D\u0435\u0442, \u044D\u0442\u043E \u0447\u0430\u0441\u044B \u043D\u0435 \u0438\u0445 \u0434\u0435\u0434\u0443\u0448\u043A\u0438",
            "eng": "Is this their grandfather`s watch? No, this is not their grandfather`s watch",
            "regEng": "/(?:Is this their grandfather\u2019s watch\\? No, this is not their grandfather\u2019s watch)/gm"
        },
        {
            "rus": "\u0427\u0435\u0439 \u0442\u043E \u0431\u044B\u043B \u043C\u0430\u0433\u0430\u0437\u0438\u043D? \u0422\u043E \u0431\u044B\u043B \u043C\u0430\u0433\u0430\u0437\u0438\u043D \u043C\u043E\u0435\u0439 \u0441\u0435\u043C\u044C\u0438",
            "eng": "Whose shop was that? That was my family`s shop",
            "regEng": "/(?:Whose shop was that\\? That was my family\u2019s shop)/gm"
        },
        {
            "rus": "\u0422\u043E \u0442\u0443\u0444\u043B\u0438 \u0435\u0451 \u0434\u0440\u0443\u0433\u0430? \u041D\u0435\u0442, \u0442\u043E \u0442\u0443\u0444\u043B\u0438 \u043D\u0435 \u0435\u0451 \u0434\u0440\u0443\u0433\u0430",
            "eng": "Are those her friend`s shoes? No, those are not her friend`s shoes",
            "regEng": "/(?:Are those her friend\u2019s shoes\\? No, those are not her friend\u2019s shoes)/gm"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E \u0435\u0451 \u0441\u0435\u0440\u0435\u0431\u0440\u044F\u043D\u043E\u0435 \u043A\u043E\u043B\u044C\u0446\u043E. \u042D\u0442\u043E \u0441\u0435\u0440\u0435\u0431\u0440\u044F\u043D\u043E\u0435 \u043A\u043E\u043B\u044C\u0446\u043E \u0435\u0451",
            "eng": "This is her silver ring. This silver ring is hers",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0432\u0430\u0448\u0438 \u0434\u0435\u043D\u044C\u0433\u0438. \u0422\u0435 \u0434\u0435\u043D\u044C\u0433\u0438 \u0431\u044B\u043B\u0438 \u0432\u0430\u0448\u0438",
            "eng": "That was your money. That money was yours",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u043C\u043E\u0438 \u0437\u043E\u043B\u043E\u0442\u044B\u0435 \u0441\u0435\u0440\u0451\u0436\u043A\u0438. \u042D\u0442\u0438 \u0437\u043E\u043B\u043E\u0442\u044B\u0435 \u0441\u0435\u0440\u0451\u0436\u043A\u0438 \u043C\u043E\u0438",
            "eng": "These are my golden earrings. These golden earrings are mine",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0435\u0433\u043E \u0431\u0443\u0442\u0435\u0440\u0431\u0440\u043E\u0434. \u042D\u0442\u043E\u0442 \u0431\u0443\u0442\u0435\u0440\u0431\u0440\u043E\u0434 \u0435\u0433\u043E",
            "eng": "This is his sandwich. This sandwich is his",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0438\u0445 \u043D\u043E\u0432\u0430\u044F \u043E\u0434\u0435\u0436\u0434\u0430. \u0422\u0430 \u043D\u043E\u0432\u0430\u044F \u043E\u0434\u0435\u0436\u0434\u0430 \u0438\u0445",
            "eng": "Those are their new clothes. Those new clothes are theirs",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u043D\u0430\u0448\u0438 \u0436\u0451\u043B\u0442\u044B\u0435 \u043F\u043B\u0430\u0442\u044C\u044F. \u042D\u0442\u0438 \u0436\u0451\u043B\u0442\u044B\u0435 \u043F\u043B\u0430\u0442\u044C\u044F \u043D\u0430\u0448\u0438",
            "eng": "These are our yellow dresses. These yellow dresses are ours",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u043C\u043E\u0438 \u0441\u0442\u0430\u0440\u044B\u0435 \u0431\u043E\u0442\u0438\u043D\u043A\u0438. \u0422\u0435 \u0441\u0442\u0430\u0440\u044B\u0435 \u0431\u043E\u0442\u0438\u043D\u043A\u0438 \u0431\u044B\u043B\u0438 \u043C\u043E\u0438",
            "eng": "Those were my old shoes. Those old shoes were mine",
            "regEng": "/(?:Those were my old (?:shoes|boots)\\. Those old (?:shoes|boots) were mine)/gm"
        },
        {
            "rus": "\u0422\u043E \u0435\u0451 \u0441\u0438\u043D\u044F\u044F \u043C\u0430\u0448\u0438\u043D\u0430. \u0422\u0430 \u0441\u0438\u043D\u044F\u044F \u043C\u0430\u0448\u0438\u043D\u0430 \u0435\u0451",
            "eng": "That is her blue car. That blue car is hers",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0427\u0435\u0439 \u044D\u0442\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D? \u041E\u043D \u043C\u043E\u0439",
            "eng": "Whose phone is this? It is mine",
            "regEng": "/(?:Whose (?:phone|telephone) is this\\? It(?: is|\u2019s) mine)/gm"
        },
        {
            "rus": "\u0422\u0435 \u0441\u0443\u043C\u043A\u0438 \u0438\u0445, \u043D\u0435 \u043D\u0430\u0448\u0438",
            "eng": "Those bags are theirs, not ours",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0435\u0451 \u043E\u0434\u0435\u0436\u0434\u0430? \u041D\u0435\u0442, \u0435\u0451 \u0437\u0434\u0435\u0441\u044C",
            "eng": "Are those her clothes? No, hers are here",
            "regEng": "/(?:Are those (?:her clothes|clothes hers)\\? No, hers are here)/gm"
        },
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u0440\u0443\u0431\u0430\u0448\u043A\u0438? \u041E\u043D\u0438 \u0432\u0430\u0448\u0438",
            "eng": "Whose shirts are these? They are yours",
            "regEng": "/(?:Whose shirts are these\\? (?:They are|They\u2019re) yours)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u0435\u0433\u043E \u043C\u0430\u0448\u0438\u043D\u0430? \u041D\u0435\u0442, \u0435\u0433\u043E \u0447\u0451\u0440\u043D\u0430\u044F",
            "eng": "Is this his car? No, his is black",
            "regEng": "/(?:Is this (?:his car|car his)\\? No, his is black)/gm"
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u0447\u0430\u0448\u043A\u0430? \u041E\u043D\u0430 \u043C\u043E\u044F",
            "eng": "Whose cup is this? It is mine",
            "regEng": "/(?:Whose cup is this\\? It(?: is|\u2019s) mine)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u0437\u0435\u043B\u0451\u043D\u044B\u0439 \u0437\u043E\u043D\u0442\u0438\u043A \u043D\u0430\u0448, \u043D\u0435 \u0438\u0445",
            "eng": "This green umbrella is ours, not theirs",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0435\u0451 \u0434\u043E\u043C? \u041D\u0435\u0442, \u0435\u0451 \u0442\u0430\u043C",
            "eng": "Is this her house? No, hers is there",
            "regEng": "/(?:Is this (?:her house|house hers)\\? No, hers is there)/gm"
        }
    ],
    [
        {
            "rus": "\u0415\u0451 \u043B\u0438\u0446\u043E \u0433\u0440\u0443\u0441\u0442\u043D\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u0451",
            "eng": "Her face is sadder than mine",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430\u0448\u0430 \u043E\u0434\u0435\u0436\u0434\u0430 \u0431\u043E\u043B\u0435\u0435 \u0434\u043E\u0440\u043E\u0433\u0430\u044F, \u0447\u0435\u043C \u0438\u0445",
            "eng": "Our clothes are more expensive than theirs",
            "regEng": ""
        },
        {
            "rus": "\u0418\u0445 \u0440\u0430\u0431\u043E\u0442\u0430 \u0445\u0443\u0436\u0435, \u0447\u0435\u043C \u0432\u0430\u0448\u0430",
            "eng": "Their job is worse than yours",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0430\u0448\u0438 \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0435\u0435 \u043D\u0430\u0448\u0438\u0445",
            "eng": "Your stories are more interesting than ours",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0433\u043E \u0432\u043E\u043B\u043E\u0441\u044B \u043A\u043E\u0440\u043E\u0447\u0435, \u0447\u0435\u043C \u0435\u0451",
            "eng": "His hair is shorter than hers",
            "regEng": ""
        },
        {
            "rus": "\u0422\u0432\u043E\u0438 \u0440\u0443\u043A\u0438 \u0434\u043B\u0438\u043D\u043D\u0435\u0435 \u043C\u043E\u0438\u0445",
            "eng": "Your arms are longer than mine",
            "regEng": ""
        },
        {
            "rus": "\u041C\u043E\u044F \u0438\u0434\u0435\u044F \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u0435\u0433\u043E",
            "eng": "My idea is better than his",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0451 \u0440\u0443\u043A\u0438 \u0433\u0440\u044F\u0437\u043D\u0435\u0435, \u0447\u0435\u043C \u0442\u0432\u043E\u0438",
            "eng": "Her hands are dirtier than yours",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041C\u043E\u0439 \u043E\u0442\u0432\u0435\u0442 \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u0438\u0445",
            "eng": "My answer is better than theirs",
            "regEng": "/(?:My (?:answer|reply) is better than theirs)/gm"
        },
        {
            "rus": "\u041D\u0430\u0448\u0438 \u044F\u0449\u0438\u043A\u0438 \u0431\u043E\u043B\u044C\u0448\u0435 \u0432\u0430\u0448\u0438\u0445",
            "eng": "Our boxes are bigger than yours",
            "regEng": "/(?:Our boxes are (?:bigger|larger) than yours)/gm"
        },
        {
            "rus": "\u0415\u0433\u043E \u0442\u0435\u043B\u043E \u0431\u043E\u043B\u0435\u0435 \u0437\u0434\u043E\u0440\u043E\u0432\u043E\u0435, \u0447\u0435\u043C \u0435\u0451",
            "eng": "His body is healthier than hers",
            "regEng": ""
        },
        {
            "rus": "\u0418\u0445 \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0438 \u0431\u043E\u043B\u0435\u0435 \u0434\u0440\u0443\u0436\u0435\u043B\u044E\u0431\u043D\u044B\u0435, \u0447\u0435\u043C \u043C\u043E\u0438",
            "eng": "Their relatives are friendlier than mine",
            "regEng": ""
        },
        {
            "rus": "\u041C\u043E\u0439 \u0433\u043E\u043B\u043E\u0441 \u043A\u0440\u0430\u0441\u0438\u0432\u0435\u0435, \u0447\u0435\u043C \u0435\u0433\u043E",
            "eng": "My voice is more beautiful than his",
            "regEng": ""
        },
        {
            "rus": "\u0418\u0445 \u043D\u0430\u0432\u044B\u043A\u0438 \u0445\u0443\u0436\u0435, \u0447\u0435\u043C \u043D\u0430\u0448\u0438",
            "eng": "Their skills are worse than ours",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430\u0448\u0430 \u0436\u0438\u0437\u043D\u044C \u0431\u043E\u043B\u0435\u0435 \u0441\u0447\u0430\u0441\u0442\u043B\u0438\u0432\u0430\u044F, \u0447\u0435\u043C \u0438\u0445",
            "eng": "Our life is happier than theirs",
            "regEng": ""
        },
        {
            "rus": "\u0422\u0432\u043E\u0439 \u043B\u043E\u0431 \u0433\u043E\u0440\u044F\u0447\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u0439",
            "eng": "Your forehead is hotter than mine",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u042F \u0432\u0441\u0435\u0433\u0434\u0430 \u0445\u043E\u0436\u0443 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043F\u0435\u0448\u043A\u043E\u043C. \u041C\u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0441\u0432\u0435\u0436\u0438\u0439 \u0432\u043E\u0437\u0434\u0443\u0445",
            "eng": "I always go to work on foot. I like fresh air",
            "regEng": ""
        },
        {
            "rus": "\u0422\u044B \u0433\u043E\u043B\u043E\u0434\u0435\u043D? \u041D\u0435\u0442, \u043D\u043E \u044F \u043E\u0447\u0435\u043D\u044C \u0445\u043E\u0447\u0443 \u043F\u0438\u0442\u044C",
            "eng": "Are you hungry? No, but I am very thirsty",
            "regEng": "/(?:Are you hungry\\? No, but (?:I am|I\u2019m) very thirsty)/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u043F\u043E\u0435\u0434\u0435\u043C \u0432 \u044D\u0442\u0443 \u0441\u0442\u0440\u0430\u043D\u0443 \u0447\u0435\u0440\u0435\u0437 \u043C\u0435\u0441\u044F\u0446, \u043C\u044B \u043F\u043E\u0435\u0434\u0435\u043C \u0442\u0443\u0434\u0430 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0433\u043E\u0434\u0443",
            "eng": "We will not go to this country in a month, we will go there next year",
            "regEng": "/(?:We (?:will not|won\u2019t) go to this country in a month, (?:we will|we\u2019ll) go there next year)/gm"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u044D\u0442\u0430 \u043A\u043D\u0438\u0433\u0430? \u041E\u043D\u0430 \u043E \u0440\u0430\u0437\u043D\u044B\u0445 \u043F\u0440\u0438\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F\u0445",
            "eng": "What is this book about? It is about different adventures",
            "regEng": "/(?:What is this book about\\? (?:It is|It\u2019s) about different adventures)/gm"
        },
        {
            "rus": "\u042F \u0432\u0438\u0434\u0435\u043B \u0442\u0432\u043E\u044E \u0441\u0435\u0441\u0442\u0440\u0443 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434. \u041E\u043D\u0430 \u0441\u043F\u0435\u0448\u0438\u043B\u0430",
            "eng": "I saw your sister an hour ago. She was in a hurry",
            "regEng": ""
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0430 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0430 \u0441 \u0442\u0435\u043C\u0438 \u043B\u044E\u0434\u044C\u043C\u0438? \u041E\u043D\u0430 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0430 \u0441 \u043D\u0438\u043C\u0438 \u0432 \u0441\u0440\u0435\u0434\u0443",
            "eng": "When did she talk to those people? She talked to them on Wednesday",
            "regEng": "/(?:When did she (?:talk|speak) (?:to|with) those people\\? She (?:talked|spoke) (?:to|with) them on Wednesday)/gm"
        },
        {
            "rus": "\u0418\u0445 \u0441\u044B\u043D \u043E\u0431\u044B\u0447\u043D\u043E \u0435\u0437\u0434\u0438\u0442 \u0432 \u0448\u043A\u043E\u043B\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0435 \u0438\u043B\u0438 \u043D\u0430 \u0442\u0440\u0430\u043C\u0432\u0430\u0435",
            "eng": "Their son usually goes to school by bus or by tram",
            "regEng": "/(?:Their son usually goes to school by bus or (?:by)? tram)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0431\u0435\u0437 \u0443\u043C\u0430 \u043E\u0442 \u0441\u0432\u043E\u0435\u0433\u043E \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u043D\u044F",
            "eng": "She is crazy about her new boyfriend",
            "regEng": "/(?:(?:She is|She\u2019s) crazy about her new boyfriend)/gm"
        }
    ],
    [
        {
            "rus": "\u0427\u0435\u043C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0443\u0435\u0442\u0441\u044F \u0432\u0430\u0448 \u043C\u0443\u0436? \u041E\u043D \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0443\u0435\u0442\u0441\u044F \u043B\u0438\u0442\u0435\u0440\u0430\u0442\u0443\u0440\u043E\u0439 \u0438 \u043C\u0443\u0437\u044B\u043A\u043E\u0439",
            "eng": "What is your husband interested in? He is interested in literature and music",
            "regEng": "/(?:What is your husband interested in\\? (?:He is|He\u2019s) interested in literature and music)/gm"
        },
        {
            "rus": "\u0412\u0430\u0448\u0435\u043C\u0443 \u043C\u0430\u043B\u044B\u0448\u0443 \u0445\u043E\u043B\u043E\u0434\u043D\u043E? \u041D\u0435\u0442, \u0435\u043C\u0443 \u0436\u0430\u0440\u043A\u043E",
            "eng": "Is your baby cold? No, he is hot",
            "regEng": "/(?:Is your baby cold\\? No, (?:he is|he\u2019s) hot)/gm"
        },
        {
            "rus": "\u041E\u043D \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u043F\u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u043B\u0438\u0441\u044C \u0441 \u0435\u0433\u043E \u043D\u043E\u0432\u043E\u0439 \u0434\u0435\u0432\u0443\u0448\u043A\u043E\u0439",
            "eng": "He wants us to meet his new girlfriend",
            "regEng": ""
        },
        {
            "rus": "\u041A\u0442\u043E \u0433\u043E\u0442\u043E\u0432 \u043F\u043E\u043C\u043E\u0447\u044C \u043D\u0430\u043C \u0441\u0435\u0433\u043E\u0434\u043D\u044F?",
            "eng": "Who is ready to help us today?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u0442\u044B \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F \u043E\u043F\u0430\u0437\u0434\u044B\u0432\u0430\u0435\u0448\u044C? \u042F \u043D\u0435 \u0437\u043D\u0430\u044E",
            "eng": "Why are you late all the time? I do not know",
            "regEng": "/(?:Why are you late all the time\\? I (?:do not|don\u2019t) know)/gm"
        },
        {
            "rus": "\u041A\u043E\u0433\u043E \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u044F \u0441\u043B\u0443\u0448\u0430\u043B?",
            "eng": "Who do you want me to listen to?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D \u0442\u0430\u043A\u043E\u0439 \u0441\u0435\u0440\u044C\u0451\u0437\u043D\u044B\u0439 \u0447\u0435\u043B\u043E\u0432\u0435\u043A. \u041E\u043D \u0432\u0441\u0435\u0433\u0434\u0430 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442 \u0432\u043E\u0432\u0440\u0435\u043C\u044F",
            "eng": "He is such a serious person. He is always on time",
            "regEng": "/(?:(?:He is|He\u2019s) such a serious person. (?:He is|He\u2019s) always on time)/gm"
        }
    ],
    [
        {
            "rus": "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u0430 \u043C\u043E\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439 \u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u043C\u043E\u044F",
            "eng": "My friends` flat is bigger than mine",
            "regEng": "/(?:My friends` (?:flat|apartment) is (?:bigger|larger) than mine)/gm"
        },
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u043F\u0438\u0441\u044C\u043C\u0430? \u041E\u043D\u0438 \u0435\u0433\u043E",
            "eng": "Whose letters are these? They are his",
            "regEng": "/(?:Whose letters are these\\? (?:They are|They\u2019re) his)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u043E\u0434\u0435\u0436\u0434\u0430 \u043D\u0430\u0448\u0438\u0445 \u0434\u0435\u0442\u0435\u0439, \u043D\u0435 \u0432\u0430\u0448\u0430",
            "eng": "These are our children`s clothes, not yours",
            "regEng": ""
        },
        {
            "rus": "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043D\u0430\u0448\u0438\u0445 \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0435\u0435, \u0447\u0435\u043C \u0435\u0451",
            "eng": "Our relatives` story is more interesting than hers",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u0434\u0435\u043D\u044C\u0433\u0438? \u041E\u043D\u0438 \u0438\u0445",
            "eng": "Whose money is this? It is theirs",
            "regEng": "/(?:Whose money is this\\? (?:It is|It\u2019s) theirs)/gm"
        },
        {
            "rus": "\u0418\u0434\u0435\u0438 \u0442\u0435\u0445 \u043C\u0443\u0436\u0447\u0438\u043D \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u043D\u0430\u0448\u0438",
            "eng": "Those men`s ideas are better than ours",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0451 \u0431\u0440\u043E\u0432\u0438 \u0442\u043E\u043D\u044C\u0448\u0435 \u0432\u0430\u0448\u0438\u0445",
            "eng": "Her eyebrows are thinner than yours",
            "regEng": ""
        },
        {
            "rus": "\u0421\u0443\u043C\u043A\u0438 \u043C\u043E\u0438\u0445 \u0440\u043E\u0434\u0438\u0442\u0435\u043B\u0435\u0439 \u0442\u044F\u0436\u0435\u043B\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u0438",
            "eng": "My parents` bags are heavier than mine",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0412\u044B \u0431\u043E\u043B\u0435\u0435 \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u044B, \u0447\u0435\u043C \u043E\u043D\u0430",
            "eng": "You are more attractive than she is",
            "regEng": "/(?:(?:You are|You\u2019re) more attractive than (?:she(?: is)?|her))/gm"
        },
        {
            "rus": "\u042F \u0441\u0447\u0430\u0441\u0442\u043B\u0438\u0432\u0435\u0435, \u0447\u0435\u043C \u0432\u044B",
            "eng": "I am happier than you are",
            "regEng": "/(?:(?:I am|I\u2019m) happier than you(?: are)?)/gm"
        },
        {
            "rus": "\u041E\u043D \u0432\u044B\u0448\u0435 \u043C\u0435\u043D\u044F",
            "eng": "He is taller than I am",
            "regEng": "/(?:(?:He is|He\u2019s) taller than (?:I(?: am)?|me))/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0431\u043E\u043B\u0435\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435, \u0447\u0435\u043C \u043C\u044B",
            "eng": "They are more active than we are",
            "regEng": "/(?:(?:They are|They\u2019re) more active than (?:we(?: are)?|us))/gm"
        },
        {
            "rus": "\u042F \u0431\u043E\u043B\u0435\u0435 \u0442\u0430\u043B\u0430\u043D\u0442\u043B\u0438\u0432\u044B\u0439, \u0447\u0435\u043C \u043E\u043D\u0430",
            "eng": "I am more talented than she is",
            "regEng": "/(?:(?:I am|I\u2019m) more talented than (?:she(?: is)?|her))/gm"
        },
        {
            "rus": "\u041E\u043D \u0441\u043C\u0435\u043B\u0435\u0435, \u0447\u0435\u043C \u044F",
            "eng": "He is braver than I am",
            "regEng": "/(?:(?:He is|He\u2019s) braver than (?:I(?: am)?|me))/gm"
        },
        {
            "rus": "\u0422\u044B \u0431\u043E\u043B\u0435\u0435 \u0441\u043C\u0435\u0448\u043D\u0430\u044F, \u0447\u0435\u043C \u043E\u043D\u0438",
            "eng": "You are funnier than they are",
            "regEng": "/(?:(?:You are|You\u2019re) funnier than (?:they(?: are)?|them))/gm"
        },
        {
            "rus": "\u0422\u044B \u0431\u043E\u043B\u0435\u0435 \u043A\u0440\u0430\u0441\u0438\u0432\u044B\u0439, \u0447\u0435\u043C \u043E\u043D",
            "eng": "You are more handsome than he is",
            "regEng": "/(?:(?:You are|You\u2019re) more handsome than (?:he(?: is)?|him))/gm"
        }
    ],
    [
        {
            "rus": "\u0422\u0432\u043E\u0438 \u0440\u0435\u0441\u043D\u0438\u0446\u044B \u0434\u043B\u0438\u043D\u043D\u0435\u0435 \u043C\u043E\u0438\u0445",
            "eng": "Your eyelashes are longer than mine",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D \u0441\u043B\u0430\u0431\u0435\u0435, \u0447\u0435\u043C \u0442\u044B",
            "eng": "He is weaker than you are",
            "regEng": "/(?:(?:He is|He\u2019s) weaker than you(?: are)?)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0431\u043E\u043B\u0435\u0435 \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u0435, \u0447\u0435\u043C \u044F",
            "eng": "They are more tired than I am",
            "regEng": "/(?:(?:They are|They\u2019re) more tired than (?:I(?: am)?|me))/gm"
        },
        {
            "rus": "\u0427\u044C\u044F \u0442\u043E \u043C\u0430\u0448\u0438\u043D\u0430? \u041E\u043D\u0430 \u043D\u0430\u0448\u0430",
            "eng": "Whose car is that? It is ours",
            "regEng": "/(?:Whose car is that\\? (?:It is|It\u2019s) ours)/gm"
        },
        {
            "rus": "\u041C\u044B \u0431\u043E\u043B\u0435\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u044B, \u0447\u0435\u043C \u043E\u043D\u0438",
            "eng": "We are more successful than they are",
            "regEng": "/(?:(?:We are|We\u2019re) more successful than (?:they(?: are)?|them))/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u0435\u0451 \u0432\u043E\u043B\u043E\u0441\u044B? \u041D\u0435\u0442, \u0435\u0451 \u0441\u0432\u0435\u0442\u043B\u0435\u0435",
            "eng": "Is this her hair? No, hers is lighter",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0433\u043E \u0435\u0434\u0430 \u0432\u043A\u0443\u0441\u043D\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u044F",
            "eng": "His food is tastier than mine",
            "regEng": "/(?:His food is (?:tastier|more delicious) than mine)/gm"
        },
        {
            "rus": "\u042F \u0441\u043F\u043E\u043A\u043E\u0439\u043D\u0435\u0435, \u0447\u0435\u043C \u043E\u043D\u0430",
            "eng": "I am calmer than she is",
            "regEng": "/(?:(?:I am|I\u2019m) calmer than (?:she(?: is)?|her))/gm"
        }
    ],
    [
        {
            "rus": "\u041D\u0430 \u0441\u0442\u043E\u043B\u0435 \u0441\u0442\u043E\u0438\u0442 \u0447\u0430\u0448\u043A\u0430",
            "eng": "There is a cup on the table",
            "regEng": "/(?:There(?:\u2019s| is) a cup on the table)/gm"
        },
        {
            "rus": "\u0421\u0442\u043E\u0438\u0442 \u043B\u0438 \u043D\u0430 \u0441\u0442\u043E\u043B\u0435 \u0447\u0430\u0448\u043A\u0430?",
            "eng": "Is there a cup on the table?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0434 \u043A\u0440\u043E\u0432\u0430\u0442\u044C\u044E \u0431\u044B\u043B\u0438 \u044F\u0449\u0438\u043A\u0438",
            "eng": "There were boxes under the bed",
            "regEng": ""
        },
        {
            "rus": "\u0411\u044B\u043B\u0438 \u043B\u0438 \u044F\u0449\u0438\u043A\u0438 \u043F\u043E\u0434 \u043A\u0440\u043E\u0432\u0430\u0442\u044C\u044E?",
            "eng": "Were there boxes under the bed?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u044F\u0449\u0438\u043A\u0435 \u043B\u0435\u0436\u0430\u0442 \u0438\u0433\u0440\u0443\u0448\u043A\u0438",
            "eng": "There are toys in the box",
            "regEng": ""
        },
        {
            "rus": "\u041B\u0435\u0436\u0430\u0442 \u043B\u0438 \u0432 \u044F\u0449\u0438\u043A\u0435 \u0438\u0433\u0440\u0443\u0448\u043A\u0438?",
            "eng": "Are there toys in the box?",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430 \u043A\u0440\u043E\u0432\u0430\u0442\u0438 \u043B\u0435\u0436\u0430\u043B\u0430 \u043F\u043E\u0434\u0443\u0448\u043A\u0430",
            "eng": "There was a pillow on the bed",
            "regEng": ""
        },
        {
            "rus": "\u041B\u0435\u0436\u0430\u043B\u0430 \u043B\u0438 \u043D\u0430 \u043A\u0440\u043E\u0432\u0430\u0442\u0438 \u043F\u043E\u0434\u0443\u0448\u043A\u0430?",
            "eng": "Was there a pillow on the bed?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0412 \u0437\u0430\u043C\u043A\u0435 \u0431\u0443\u0434\u0435\u0442 \u043A\u043B\u044E\u0447",
            "eng": "There will be a key in the lock",
            "regEng": "/(?:There(?:\u2019ll| will) be a key in the lock)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u0432 \u0437\u0430\u043C\u043A\u0435 \u043A\u043B\u044E\u0447?",
            "eng": "Will there be a key in the lock?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u0441\u0443\u043C\u043A\u0435 \u043B\u0435\u0436\u0430\u0442 \u0431\u0443\u0442\u044B\u043B\u043A\u0438",
            "eng": "There are bottles in the bag",
            "regEng": ""
        },
        {
            "rus": "\u041B\u0435\u0436\u0430\u0442 \u043B\u0438 \u0432 \u0441\u0443\u043C\u043A\u0435 \u0431\u0443\u0442\u044B\u043B\u043A\u0438?",
            "eng": "Are there bottles in the bag?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u043A\u043E\u043C\u043D\u0430\u0442\u0435 \u0431\u0443\u0434\u0443\u0442 \u043B\u044E\u0434\u0438",
            "eng": "There will be people in the room",
            "regEng": "/(?:There(?:\u2019ll| will) be people in the room)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0443\u0442 \u043B\u0438 \u0432 \u043A\u043E\u043C\u043D\u0430\u0442\u0435 \u043B\u044E\u0434\u0438?",
            "eng": "Will there be people in the room?",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430 \u043F\u043E\u0442\u043E\u043B\u043A\u0435 \u0432\u0438\u0441\u0435\u043B\u0430 \u043B\u0430\u043C\u043F\u0430",
            "eng": "There was a lamp on the ceiling",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0438\u0441\u0435\u043B\u0430 \u043B\u0438 \u043B\u0430\u043C\u043F\u0430 \u043D\u0430 \u043F\u043E\u0442\u043E\u043B\u043A\u0435?",
            "eng": "Was there a lamp on the ceiling?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041D\u0430 \u0441\u0442\u043E\u043B\u0435 \u043B\u0435\u0436\u0430\u043B\u0438 \u043A\u043D\u0438\u0433\u0438",
            "eng": "There were books on the table",
            "regEng": ""
        },
        {
            "rus": "\u041B\u0435\u0436\u0430\u043B\u0438 \u043B\u0438 \u043A\u043D\u0438\u0433\u0438 \u043D\u0430 \u0441\u0442\u043E\u043B\u0435?",
            "eng": "Were there books on the table?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u043A\u043E\u043C\u043D\u0430\u0442\u0435 \u0431\u0443\u0434\u0435\u0442 \u043A\u0440\u0435\u0441\u043B\u043E",
            "eng": "There will be an armchair in the room",
            "regEng": "/(?:There(?:\u2019ll| will) be an armchair in the room)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u0432 \u043A\u043E\u043C\u043D\u0430\u0442\u0435 \u043A\u0440\u0435\u0441\u043B\u043E?",
            "eng": "Will there be an armchair in the room",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430 \u043F\u043E\u043B\u0443 \u043B\u0435\u0436\u0438\u0442 \u043A\u043E\u0432\u0451\u0440",
            "eng": "There is a carpet on the floor",
            "regEng": "/(?:There(?:\u2019s| is) a carpet on the floor)/gm"
        },
        {
            "rus": "\u041B\u0435\u0436\u0438\u0442 \u043B\u0438 \u043D\u0430 \u043F\u043E\u043B\u0443 \u043A\u043E\u0432\u0451\u0440?",
            "eng": "Is there a carpet on the floor?",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430 \u0441\u0442\u0435\u043D\u0430\u0445 \u0431\u0443\u0434\u0443\u0442 \u043A\u0430\u0440\u0442\u0438\u043D\u044B",
            "eng": "There will be pictures on the walls",
            "regEng": "/(?:There(?:\u2019ll| will) be pictures on the walls)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0443\u0442 \u043B\u0438 \u043D\u0430 \u0441\u0442\u0435\u043D\u0430\u0445 \u043A\u0430\u0440\u0442\u0438\u043D\u044B?",
            "eng": "Will there be pictures on the walls?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0414\u0438\u0435\u0442\u0430 \u0442\u0432\u043E\u0438\u0445 \u0440\u043E\u0434\u0438\u0442\u0435\u043B\u0435\u0439 \u0431\u043E\u043B\u0435\u0435 \u0437\u0434\u043E\u0440\u043E\u0432\u0430\u044F, \u0447\u0435\u043C \u0442\u0432\u043E\u044F",
            "eng": "Your parents` diet is healthier than yours",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0435\u0433\u043E \u0434\u0435\u043D\u044C\u0433\u0438, \u043D\u0435 \u0435\u0451",
            "eng": "This is his money, not hers",
            "regEng": "/(?:This (?:is his money|money is his), not hers)/gm"
        },
        {
            "rus": "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u044D\u0442\u0438\u0445 \u043B\u044E\u0434\u0435\u0439 \u0445\u0443\u0436\u0435, \u0447\u0435\u043C \u0435\u0433\u043E",
            "eng": "These people`s results are worse than his",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u043A\u043E\u043C\u043D\u0430\u0442\u0430 \u0442\u0432\u043E\u0438\u0445 \u0434\u0435\u0442\u0435\u0439? \u041D\u0435\u0442, \u043E\u043D\u0430 \u043C\u043E\u044F",
            "eng": "Is this your children`s room? No, it is mine",
            "regEng": "/(?:Is this your children`s room\\? No, (?:it is|it\u2019s) mine)/gm"
        },
        {
            "rus": "\u0415\u0451 \u0432\u043E\u043B\u043E\u0441\u044B \u0442\u0435\u043C\u043D\u0435\u0435 \u0438\u043B\u0438 \u0441\u0432\u0435\u0442\u043B\u0435\u0435, \u0447\u0435\u043C \u0442\u0432\u043E\u0438?",
            "eng": "Is her hair darker or lighter than yours?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0435\u0439 \u044D\u0442\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D? \u042D\u0442\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u043C\u043E\u0435\u0433\u043E \u043C\u0443\u0436\u0430",
            "eng": "Whose phone is this? This is my husband`s phone",
            "regEng": "/(?:Whose (?:tele)?phone is this\\? This is my husband`s (?:tele)?phone)/gm"
        },
        {
            "rus": "\u0421\u043E\u0431\u0430\u043A\u0430 \u043D\u0430\u0448\u0438\u0445 \u0441\u043E\u0441\u0435\u0434\u0435\u0439 \u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u043D\u0430\u0448\u0430",
            "eng": "Our neighbours` dog is bigger than ours",
            "regEng": "/(?:Our neighbou?rs` dog is bigger than ours)/gm"
        },
        {
            "rus": "\u0412\u0430\u0448\u0430 \u043E\u0434\u0435\u0436\u0434\u0430 \u0431\u043E\u043B\u0435\u0435 \u0434\u0435\u0448\u0451\u0432\u0430\u044F, \u0447\u0435\u043C \u0438\u0445",
            "eng": "Your clothes are cheaper than theirs",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0412\u044B \u0431\u043E\u043B\u0435\u0435 \u0434\u0440\u0443\u0436\u0435\u043B\u044E\u0431\u043D\u044B, \u0447\u0435\u043C \u043E\u043D\u0438",
            "eng": "You are friendlier than they are",
            "regEng": "/(?:You(?: are|`re) friendlier than (?:they(?: are)?|them))/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0431\u043E\u043B\u0435\u0435 \u0441\u0435\u0440\u044C\u0435\u0437\u043D\u044B\u0435, \u0447\u0435\u043C \u044F",
            "eng": "They are more serious than I am",
            "regEng": "/(?:They(?: are|`re) more serious than (?:I(?: am)?|me))/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0438\u0436\u0435, \u0447\u0435\u043C \u0442\u044B",
            "eng": "She is shorter than you are",
            "regEng": "/(?:She(?: is|`s) shorter than you(?: are)?)/gm"
        },
        {
            "rus": "\u042F \u0441\u0438\u043B\u044C\u043D\u0435\u0435, \u0447\u0435\u043C \u043E\u043D",
            "eng": "I am stronger than he is",
            "regEng": "/(?:(?:I am|I\u2019m) stronger than (?:he(?: is)?|him))/gm"
        },
        {
            "rus": "\u0422\u044B \u0442\u043E\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u043E\u043D\u0430",
            "eng": "You are thinner than she is",
            "regEng": "/(?:You(?: are|`re) thinner than (?:she(?: is)?|her))/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0431\u043E\u043B\u0435\u0435 \u043E\u0431\u0435\u0441\u043F\u043E\u043A\u043E\u0435\u043D\u044B, \u0447\u0435\u043C \u044F",
            "eng": "They are more worried than I am",
            "regEng": "/(?:They(?: are|`re) more worried than (?:I(?: am)?|me))/gm"
        },
        {
            "rus": "\u041E\u043D \u043A\u0440\u0430\u0441\u0438\u0432\u0435\u0435 \u0442\u0435\u0431\u044F",
            "eng": "He is more handsome than you are",
            "regEng": "/(?:(?:He is|He\u2019s) more handsome than you(?: are)?)/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u043C\u043E\u043B\u043E\u0436\u0435, \u0447\u0435\u043C \u043E\u043D",
            "eng": "She is younger than he is",
            "regEng": "/(?:She(?: is|`s) younger than (?:he(?: is)?|him))/gm"
        }
    ],
    [
        {
            "rus": "\u0415\u0433\u043E \u0440\u0443\u043A\u0438 \u0441\u043B\u0430\u0431\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u0438",
            "eng": "His arms are weaker than mine",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u0431\u0438\u043B\u0435\u0442\u044B? \u041E\u043D\u0438 \u043D\u0430\u0448\u0438",
            "eng": "Whose tickets are these? They are ours",
            "regEng": "/(?:Whose tickets are these\\? They(?: are|`re) ours)/gm"
        },
        {
            "rus": "\u041E\u043D\u0438 \u0431\u043E\u043B\u0435\u0435 \u043F\u0430\u0441\u0441\u0438\u0432\u043D\u044B, \u0447\u0435\u043C \u043C\u044B",
            "eng": "They are more passive than we are",
            "regEng": "/(?:They(?: are|`re) more passive than (?:we(?: are)?|us))/gm"
        },
        {
            "rus": "\u041C\u043E\u0439 \u043E\u0442\u0447\u0451\u0442 \u0431\u043E\u043B\u0435\u0435 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u044B\u0439, \u0447\u0435\u043C \u0432\u0430\u0448",
            "eng": "My report is more detailed than yours",
            "regEng": ""
        },
        {
            "rus": "\u041C\u044B \u0431\u043E\u043B\u0435\u0435 \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u044B, \u0447\u0435\u043C \u043E\u043D\u0438",
            "eng": "We are more attractive than they are",
            "regEng": "/(?:We(?: are|`re) more attractive than they are)/gm"
        },
        {
            "rus": "\u0422\u043E \u0432\u0430\u0448\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B? \u041D\u0435\u0442, \u043C\u043E\u0438 \u0437\u0434\u0435\u0441\u044C",
            "eng": "Are these your documents? No, mine are here",
            "regEng": "/(?:Are these (?:your documents|documents yours)\\? No, mine are here)/gm"
        },
        {
            "rus": "\u0422\u0432\u043E\u0438 \u0432\u043E\u043B\u043E\u0441\u044B \u0431\u043E\u043B\u0435\u0435 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0435, \u0447\u0435\u043C \u0435\u0451",
            "eng": "Your hair is shorter than hers",
            "regEng": ""
        },
        {
            "rus": "\u0412\u044B \u0431\u043E\u043B\u0435\u0435 \u0442\u0435\u0440\u043F\u0435\u043B\u0438\u0432\u044B, \u0447\u0435\u043C \u044F",
            "eng": "You are more patient than I am",
            "regEng": "/(?:You(?: are|`re) more patient than (?:I(?: am)?|me))/gm"
        }
    ],
    [
        {
            "rus": "\u041D\u0430 \u0441\u0442\u043E\u043B\u0435 \u0441\u0442\u043E\u0438\u0442 \u044F\u0449\u0438\u043A",
            "eng": "There is a box on the table",
            "regEng": "/(?:There(?:`s| is) a box on the table)/gm"
        },
        {
            "rus": "\u0421\u0442\u043E\u0438\u0442 \u043B\u0438 \u044F\u0449\u0438\u043A \u043D\u0430 \u0441\u0442\u043E\u043B\u0435?",
            "eng": "Is there a box on the table?",
            "regEng": ""
        },
        {
            "rus": "\u0423 \u043E\u043A\u043D\u0430 \u0441\u0442\u043E\u044F\u043B\u0438 \u0441\u0442\u0443\u043B\u044C\u044F",
            "eng": "There were chairs by the window",
            "regEng": ""
        },
        {
            "rus": "\u0421\u0442\u043E\u044F\u043B\u0438 \u043B\u0438 \u0441\u0442\u0443\u043B\u044C\u044F \u0443 \u043E\u043A\u043D\u0430?",
            "eng": "Were there chairs by the window?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u044F\u0449\u0438\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u0447\u0430\u0448\u043A\u0438",
            "eng": "There will be cups in the box",
            "regEng": "/(?:There(?:`ll| will) be cups in the box)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0443\u0442 \u043B\u0438 \u0432 \u044F\u0449\u0438\u043A\u0435 \u0447\u0430\u0448\u043A\u0438?",
            "eng": "Will there be cups in the box?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0434 \u043C\u043E\u0441\u0442\u043E\u043C \u0441\u0442\u043E\u044F\u043B\u0430 \u043C\u0430\u0448\u0438\u043D\u0430",
            "eng": "There was a car under the bridge",
            "regEng": ""
        },
        {
            "rus": "\u0421\u0442\u043E\u044F\u043B\u0430 \u043B\u0438 \u043F\u043E\u0434 \u043C\u043E\u0441\u0442\u043E\u043C \u043C\u0430\u0448\u0438\u043D\u0430?",
            "eng": "Was there a car under the bridge?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041D\u0430 \u043A\u0440\u043E\u0432\u0430\u0442\u0438 \u043B\u0435\u0436\u0430\u0442 \u0438\u0433\u0440\u0443\u0448\u043A\u0438",
            "eng": "There are toys on the bed",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u0434\u0432\u0435\u0440\u0438 \u0431\u0443\u0434\u0435\u0442 \u0437\u0430\u043C\u043E\u043A",
            "eng": "There will be a lock in the door",
            "regEng": "/(?:(?:There will|There\u2019ll) be a lock in the door)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u0432 \u0434\u0432\u0435\u0440\u0438 \u0437\u0430\u043C\u043E\u043A?",
            "eng": "Will there be a lock in the door?",
            "regEng": ""
        },
        {
            "rus": "\u0423 \u043E\u043A\u043D\u0430 \u0441\u0442\u043E\u0438\u0442 \u043A\u0440\u0435\u0441\u043B\u043E",
            "eng": "There is an armchair by the window",
            "regEng": "/(?:(?:There is|There\u2019s) an armchair by the window)/gm"
        },
        {
            "rus": "\u0421\u0442\u043E\u0438\u0442 \u043B\u0438 \u043A\u0440\u0435\u0441\u043B\u043E \u0443 \u043E\u043A\u043D\u0430?",
            "eng": "Is there an armchair by the window?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u0441\u0443\u043C\u043A\u0435 \u043B\u0435\u0436\u0430\u043B \u043A\u043B\u044E\u0447",
            "eng": "There was a key in the bag",
            "regEng": ""
        },
        {
            "rus": "\u041B\u0435\u0436\u0430\u043B \u043B\u0438 \u0432 \u0441\u0443\u043C\u043A\u0435 \u043A\u043B\u044E\u0447?",
            "eng": "Was there a key in the bag?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041D\u0430 \u043F\u043E\u043B\u0443 \u0441\u0442\u043E\u044F\u043B\u0438 \u0431\u0443\u0442\u044B\u043B\u043A\u0438",
            "eng": "There were bottles on the floor",
            "regEng": ""
        },
        {
            "rus": "\u0421\u0442\u043E\u044F\u043B\u0438 \u043B\u0438 \u043D\u0430 \u043F\u043E\u043B\u0443 \u0431\u0443\u0442\u044B\u043B\u043A\u0438?",
            "eng": "Were there bottles on the floor?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u043A\u043E\u043C\u043D\u0430\u0442\u0435 \u0431\u0443\u0434\u0435\u0442 \u0434\u0438\u0432\u0430\u043D",
            "eng": "There will be a sofa in the room",
            "regEng": "/(?:(?:There will|There\u2019ll) be a (?:sofa|couch) in the room)/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u0432 \u043A\u043E\u043C\u043D\u0430\u0442\u0435 \u0434\u0438\u0432\u0430\u043D?",
            "eng": "Will there be a sofa in the room?",
            "regEng": "/(?:Will there be a (?:sofa|couch) in the room\\?)/gm"
        },
        {
            "rus": "\u041D\u0430 \u043F\u043E\u0442\u043E\u043B\u043A\u0435 \u0432\u0438\u0441\u0438\u0442 \u043B\u0430\u043C\u043F\u0430",
            "eng": "There is a lamp on the ceiling",
            "regEng": "/(?:(?:There is|There\u2019s) a lamp on the ceiling)/gm"
        },
        {
            "rus": "\u0412\u0438\u0441\u0438\u0442 \u043B\u0438 \u043B\u0430\u043C\u043F\u0430 \u043D\u0430 \u043F\u043E\u0442\u043E\u043B\u043A\u0435?",
            "eng": "Is there a lamp on the ceiling?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0434 \u043A\u0440\u043E\u0432\u0430\u0442\u044C\u044E \u0441\u0442\u043E\u044F\u0442 \u0441\u0443\u043C\u043A\u0438",
            "eng": "There are bags under the bed",
            "regEng": ""
        },
        {
            "rus": "\u0421\u0442\u043E\u044F\u0442 \u043B\u0438 \u0441\u0443\u043C\u043A\u0438 \u043F\u043E\u0434 \u043A\u0440\u043E\u0432\u0430\u0442\u044C\u044E?",
            "eng": "Are there bags under the bed?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041E\u0442\u043A\u0443\u0434\u0430 \u0442\u0432\u043E\u044F \u043F\u043E\u0434\u0440\u0443\u0433\u0430? \u041E\u043D\u0430 \u0438\u0437 \u0410\u043D\u0433\u043B\u0438\u0438",
            "eng": "Where is your friend from? She is from England",
            "regEng": "/(?:Where is your friend from\\? She(?: is|`s) from England)/gm"
        },
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0430 \u043A\u0443\u043F\u0438\u043B\u0430 \u044D\u0442\u043E \u043F\u043B\u0430\u0442\u044C\u0435? \u041E\u043D\u0430 \u043A\u0443\u043F\u0438\u043B\u0430 \u0435\u0433\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043D\u0438\u043A",
            "eng": "When did she buy this dress? She bought it on Tuesday",
            "regEng": ""
        },
        {
            "rus": "\u042F \u0433\u043E\u0440\u0436\u0443\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043C\u044C\u0435\u0439 \u0438 \u0441\u0432\u043E\u0438\u043C\u0438 \u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438!",
            "eng": "I am proud of my family and my friends!",
            "regEng": "/(?:(?:I am|I\u2019m) proud of my family and my friends!)/gm"
        },
        {
            "rus": "\u0427\u0435\u043C \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u0435\u0451 \u043C\u0443\u0436? \u0415\u0451 \u043C\u0443\u0436 \u043F\u043E\u0432\u0430\u0440",
            "eng": "What does her husband do? Her husband is a cook",
            "regEng": ""
        },
        {
            "rus": "\u0414\u0435\u0432\u0443\u0448\u043A\u0430 \u043C\u043E\u0435\u0433\u043E \u0431\u0440\u0430\u0442\u0430 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442 \u0432\u043E\u0432\u0440\u0435\u043C\u044F. \u0412\u0447\u0435\u0440\u0430 \u043E\u043D\u0430 \u043E\u043F\u043E\u0437\u0434\u0430\u043B\u0430 \u043E\u043F\u044F\u0442\u044C",
            "eng": "My brother`s girlfriend is never on time. Yesterday she was late again",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0442\u043E \u0442\u0435\u0431\u0435 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0430 \u0441\u0434\u0435\u043B\u0430\u043B\u0430? \u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0430 \u043C\u043D\u0435 \u0437\u0430\u0432\u0442\u0440\u0430",
            "eng": "What do you need her to do? I need her to call me tomorrow",
            "regEng": ""
        },
        {
            "rus": "\u041A\u0430\u0436\u0434\u044B\u0439 \u043C\u0435\u0441\u044F\u0446 \u043E\u043D\u0430 \u0435\u0437\u0434\u0438\u0442 \u0442\u0443\u0434\u0430, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0438\u0445",
            "eng": "Every month she goes there to see them",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u042F \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u0447\u0430\u0441\u0442\u043B\u0438\u0432 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u0442\u044C \u0441 \u0432\u0430\u043C\u0438. \u0412\u044B \u0442\u0430\u043A\u043E\u0439 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0439 \u0447\u0435\u043B\u043E\u0432\u0435\u043A",
            "eng": "I am always happy to talk to you. You are such an interesting person",
            "regEng": "/(?:(?:I am|I\u2019m) always happy to (?:talk|speak) (?:to|with) you. You(?: are|`re) such an interesting person)/gm"
        },
        {
            "rus": "\u0412\u0430\u0448\u0438 \u0434\u0435\u0442\u0438 \u0445\u043E\u0434\u044F\u0442 \u0432 \u0448\u043A\u043E\u043B\u0443 \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C? \u041D\u0435\u0442, \u043F\u043E \u0432\u044B\u0445\u043E\u0434\u043D\u044B\u043C \u043E\u043D\u0438 \u043D\u0435 \u0445\u043E\u0434\u044F\u0442 \u0432 \u0448\u043A\u043E\u043B\u0443",
            "eng": "Do your children go to school every day? No, at weekends they do not go to school",
            "regEng": "/(?:Do your children go to school every day\\? No, at weekends they (?:do not|don\u2019t) go to school)/gm"
        },
        {
            "rus": "\u0422\u044B \u043F\u043E\u0448\u0451\u043B \u0441\u043F\u0430\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u043E \u0432\u0447\u0435\u0440\u0430? \u041D\u0435\u0442, \u044F \u043F\u043E\u0448\u0451\u043B \u0441\u043F\u0430\u0442\u044C \u0440\u0430\u043D\u043E",
            "eng": "Did you go to bed late yesterday? No, I went to bed early",
            "regEng": "/(?:Did you go to (?:bed|sleep) late yesterday\\? No, I went to (?:bed|sleep) early)/gm"
        },
        {
            "rus": "\u0427\u0435\u0433\u043E \u043E\u043D\u0430 \u0431\u043E\u0438\u0442\u0441\u044F? \u041E\u043D\u0430 \u0431\u043E\u0438\u0442\u0441\u044F \u0432\u0441\u0435\u0433\u043E",
            "eng": "What is she afraid of? She is afraid of everything",
            "regEng": "/(?:What is she afraid of\\? She(?: is|`s) afraid of everything)/gm"
        },
        {
            "rus": "\u041A\u0430\u043A \u0432\u044B \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u0443\u0442\u0435\u0448\u0435\u0441\u0442\u0432\u0443\u0435\u0442\u0435? \u042F \u043E\u0431\u044B\u0447\u043D\u043E \u043F\u0443\u0442\u0435\u0448\u0435\u0441\u0442\u0432\u0443\u044E \u0441\u0430\u043C\u043E\u043B\u0451\u0442\u043E\u043C",
            "eng": "How do you usually travel? I usually travel by plane",
            "regEng": ""
        },
        {
            "rus": "\u042F \u0442\u0430\u043A \u0433\u043E\u043B\u043E\u0434\u0435\u043D. \u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u043F\u043E\u043E\u0431\u0435\u0434\u0430\u0442\u044C",
            "eng": "I am so hungry. I need to have lunch",
            "regEng": "/(?:(?:I am|I\u2019m) so hungry. I need to have lunch)/gm"
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u0432\u044B \u0447\u0430\u0441\u0442\u043E \u0434\u0443\u043C\u0430\u0435\u0442\u0435? \u042F \u0447\u0430\u0441\u0442\u043E \u0434\u0443\u043C\u0430\u044E \u043E \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043C\u044C\u0435",
            "eng": "What do you often think about? I often think about my family",
            "regEng": ""
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u0445\u043E\u0442\u0438\u043C, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u0441\u043E\u0436\u0430\u043B\u0435\u043B\u0438. \u0412\u0441\u0451 \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435",
            "eng": "We do not want you to be sorry. Everything is alright",
            "regEng": "/(?:We (?:do not|don\u2019t) want you to be sorry. Everything is alright)/gm"
        }
    ],
    [
        {
            "rus": "\u0412\u0447\u0435\u0440\u0430 \u0442\u044B \u043F\u0440\u0438\u0448\u0435\u043B \u0434\u043E\u043C\u043E\u0439 \u0440\u0430\u043D\u043E",
            "eng": "Yesterday you came home early",
            "regEng": "/(?:Yesterday you came home early)|(?:You came home early yesterday)/gm"
        },
        {
            "rus": "\u041C\u044B \u0431\u043E\u043B\u0435\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u044B, \u0447\u0435\u043C \u043E\u043D\u0438",
            "eng": "We are more successful than they are",
            "regEng": "/(?:We(?: are|\u2019re) more successful than (?:they(?: are)?|them))/gm"
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0447\u0430\u0441\u044B \u0435\u0433\u043E \u0434\u0435\u0434\u0443\u0448\u043A\u0438?",
            "eng": "Was that his grandfather`s watch?",
            "regEng": "/Was that his (?:grandfather\u2019s|grandpa\u2019s) watch\\?/gm"
        },
        {
            "rus": "\u0415\u043C\u0443 \u043D\u0435 \u043D\u0443\u0436\u043D\u043E \u0438\u0441\u043A\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443",
            "eng": "He does not need to look for a new job",
            "regEng": "/(?:He (?:does not|doesn\u2019t) need to (?:look|search) for a new job)/gm"
        },
        {
            "rus": "\u042F \u0441\u043F\u043E\u043A\u043E\u0439\u043D\u0435\u0435, \u0447\u0435\u043C \u043E\u043D\u0430",
            "eng": "I am calmer than she is",
            "regEng": "/(?:(?:I am|I\u2019m) calmer than (?:she(?: is)?|her))/gm"
        }
    ],
    [
        {
            "rus": "\u041E\u043D\u0438 \u0447\u0430\u0441\u0442\u043E \u0441\u043B\u0443\u0448\u0430\u044E\u0442 \u044D\u0442\u0438\u0445 \u043B\u044E\u0434\u0435\u0439",
            "eng": "They often listen to these people",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u0437\u0430\u043C\u043A\u0435 \u0431\u0443\u0434\u0435\u0442 \u043A\u043B\u044E\u0447",
            "eng": "There will be a key in the lock",
            "regEng": "/(?:There(?:\u2019ll| will) be a key in the lock)/gm"
        },
        {
            "rus": "\u042F \u0432\u0438\u0434\u0435\u043B \u0442\u0432\u043E\u044E \u0441\u0435\u0441\u0442\u0440\u0443 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434. \u041E\u043D\u0430 \u0441\u043F\u0435\u0448\u0438\u043B\u0430",
            "eng": "I saw your sister an hour ago. She was in a hurry",
            "regEng": ""
        },
        {
            "rus": "\u041C\u043E\u0438 \u0440\u0443\u043A\u0438 \u0441\u0438\u043B\u044C\u043D\u0435\u0435, \u0447\u0435\u043C \u0435\u0433\u043E",
            "eng": "My arms are stronger than his",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0435\u0439 \u044D\u0442\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D? \u041E\u043D \u043C\u043E\u0439",
            "eng": "Whose phone is this? It is mine",
            "regEng": "/(?:Whose (?:phone|telephone) is this\\? It(?: is|\u2019s) mine)/gm"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u043E \u0435\u0451 \u044E\u0431\u043A\u0430? \u042D\u0442\u0430 \u044E\u0431\u043A\u0430 \u0435\u0451?",
            "eng": "Is this her skirt? Is this skirt hers?",
            "regEng": ""
        },
        {
            "rus": "\u042F \u0432\u0441\u0435\u0433\u0434\u0430 \u0445\u043E\u0436\u0443 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043F\u0435\u0448\u043A\u043E\u043C. \u041C\u043D\u0435 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0441\u0432\u0435\u0436\u0438\u0439 \u0432\u043E\u0437\u0434\u0443\u0445",
            "eng": "I always go to work on foot. I like fresh air",
            "regEng": ""
        },
        {
            "rus": "\u0421\u0442\u043E\u0438\u0442 \u043B\u0438 \u043D\u0430 \u0441\u0442\u043E\u043B\u0435 \u0447\u0430\u0448\u043A\u0430?",
            "eng": "Is there a cup on the table?",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0451 \u0442\u0435\u043B\u043E \u0442\u043E\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0442\u0432\u043E\u0451",
            "eng": "Her body is thinner than yours",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0438 \u043F\u043E\u043E\u0431\u0435\u0434\u0430\u043B\u0438 \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434",
            "eng": "They had lunch an hour ago",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u042F \u043D\u0435 \u0431\u044B\u043B \u0437\u0434\u0435\u0441\u044C \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            "eng": "I was not here a minute ago",
            "regEng": "/I (?:was not|wasn\u2019t) here a minute ago/gm"
        },
        {
            "rus": "\u0418\u0449\u0435\u043C \u043B\u0438 \u043C\u044B \u0447\u0430\u0441\u0442\u043E \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043A\u043D\u0438\u0433\u0438 \u0437\u0434\u0435\u0441\u044C?",
            "eng": "Do we often look for interesting books here?",
            "regEng": "/Do we often (?:look|search) for interesting books here\\?/gm"
        },
        {
            "rus": "\u0422\u0432\u043E\u0438 \u0440\u0435\u0441\u043D\u0438\u0446\u044B \u0434\u043B\u0438\u043D\u043D\u0435\u0435 \u043C\u043E\u0438\u0445",
            "eng": "Your eyelashes are longer than mine",
            "regEng": ""
        },
        {
            "rus": "\u041A\u043E\u0433\u043E \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u044F \u0441\u043B\u0443\u0448\u0430\u043B?",
            "eng": "Who do you want me to listen to?",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0435\u0451 \u0441\u0438\u043D\u044F\u044F \u043C\u0430\u0448\u0438\u043D\u0430. \u0422\u0430 \u0441\u0438\u043D\u044F\u044F \u043C\u0430\u0448\u0438\u043D\u0430 \u0435\u0451",
            "eng": "That is her blue car. That blue car is hers",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0427\u044C\u0438 \u043A\u043D\u0438\u0433\u0438 \u0442\u043E \u0431\u044B\u043B\u0438?",
            "eng": "Whose books were those?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0430 \u043F\u043E\u0443\u0436\u0438\u043D\u0430\u043B\u0430 \u0441 \u043D\u0438\u043C",
            "eng": "He wants her to have dinner with him",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0430\u0448\u0438 \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0435\u0435 \u043D\u0430\u0448\u0438\u0445",
            "eng": "Your stories are more interesting than ours",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0430 \u0431\u0435\u0437 \u0443\u043C\u0430 \u043E\u0442 \u0441\u0432\u043E\u0435\u0433\u043E \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u043D\u044F",
            "eng": "She is crazy about her new boyfriend",
            "regEng": "/(?:She(?: is|`s) crazy about her new boyfriend/gm"
        },
        {
            "rus": "\u041D\u0430 \u0441\u0442\u043E\u043B\u0435 \u043B\u0435\u0436\u0430\u043B\u0438 \u043A\u043D\u0438\u0433\u0438",
            "eng": "There were books on the table",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u043F\u0440\u0438\u043D\u0435\u0441\u0443\u0442 \u044D\u0442\u0438 \u0432\u0435\u0449\u0438 \u0441\u044E\u0434\u0430?",
            "eng": "When will they bring these things here?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0430\u043B\u044C\u0447\u0438\u043A \u0442\u0440\u0435\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "This boy exercises every day",
            "regEng": ""
        },
        {
            "rus": "\u0422\u044B \u0433\u043E\u043B\u043E\u0434\u0435\u043D? \u041D\u0435\u0442, \u043D\u043E \u044F \u043E\u0447\u0435\u043D\u044C \u0445\u043E\u0447\u0443 \u043F\u0438\u0442\u044C",
            "eng": "Are you hungry? No, but I am very thirsty",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0451 \u0440\u0443\u043A\u0438 \u0433\u0440\u044F\u0437\u043D\u0435\u0435, \u0447\u0435\u043C \u0442\u0432\u043E\u0438",
            "eng": "Her hands are dirtier than yours",
            "regEng": ""
        },
        {
            "rus": "\u0421\u043F\u0435\u0448\u0438\u0442 \u043B\u0438 \u043E\u043D?",
            "eng": "Is he in a hurry?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D \u043E\u0431\u044B\u0447\u043D\u043E \u0445\u043E\u0434\u0438\u0442 \u0442\u0443\u0434\u0430?",
            "eng": "Who does he usually go there with?",
            "regEng": ""
        },
        {
            "rus": "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043C\u043E\u0435\u0433\u043E \u0431\u0440\u0430\u0442\u0430 \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u043C\u043E\u0438",
            "eng": "My brother\u2019s results are better than mine",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u0434\u0435\u043A\u0430\u0431\u0440\u0435 \u043E\u043D\u0438 \u0440\u0435\u0434\u043A\u043E \u0435\u0437\u0434\u044F\u0442 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0432\u0435\u043B\u043E\u0441\u0438\u043F\u0435\u0434\u0435",
            "eng": "In December they rarely go to work by bicycle",
            "regEng": "/In December they (?:rarely|seldom) go to work by bicycle/gm"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u0437\u0435\u043B\u0451\u043D\u044B\u0439 \u0437\u043E\u043D\u0442\u0438\u043A \u043D\u0430\u0448, \u043D\u0435 \u0438\u0445",
            "eng": "This green umbrella is ours, not theirs",
            "regEng": ""
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u044F \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B?",
            "eng": "Who do you want me to talk to?",
            "regEng": "/Who do you want me to talk (?:to|with)\\?/gm"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u0438 \u043B\u044E\u0434\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u043D\u0435 \u043F\u0440\u0438\u0445\u043E\u0434\u044F\u0442 \u0432\u043E\u0432\u0440\u0435\u043C\u044F",
            "eng": "These people are not usually on time",
            "regEng": "/These people (?:are not|aren\u2019t) usually on time/gm"
        },
        {
            "rus": "\u041A\u0442\u043E \u0433\u043E\u0442\u043E\u0432 \u043F\u043E\u043C\u043E\u0447\u044C \u043D\u0430\u043C \u0441\u0435\u0433\u043E\u0434\u043D\u044F?",
            "eng": "Who is ready to help us today?",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0442\u0432\u043E\u0438 \u043A\u043D\u0438\u0433\u0438? \u041D\u0435\u0442, \u043C\u043E\u0438 \u0437\u0434\u0435\u0441\u044C",
            "eng": "Are those your books? No, mine are here",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0447\u0435\u043C\u0443 \u043E\u043D \u0447\u0430\u0441\u0442\u043E \u0443\u0436\u0438\u043D\u0430\u0435\u0442 \u0442\u0430\u043C \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A?",
            "eng": "Why does he often have dinner there on Monday?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0435\u0433\u043E \u0431\u043E\u044F\u043B\u0438\u0441\u044C \u0442\u0435 \u0434\u0435\u0442\u0438?",
            "eng": "What were those children afraid of?",
            "regEng": "/What were those children (?:afraid|scared) of\\?/gm"
        }
    ],
    [
        {
            "rus": "\u0422\u043E \u043D\u0435 \u0431\u044B\u043B\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0435\u0451 \u043E\u0442\u0446\u0430",
            "eng": "Those were not her father`s documents",
            "regEng": "/Those (?:were not|weren\u2019t) her (?:father`s|dad`s) documents/gm"
        },
        {
            "rus": "\u041D\u0430 \u043F\u0440\u043E\u0448\u043B\u043E\u0439 \u043D\u0435\u0434\u0435\u043B\u0435 \u043E\u043D\u0438 \u043F\u043E\u0443\u0436\u0438\u043D\u0430\u043B\u0438 \u0432\u043C\u0435\u0441\u0442\u0435",
            "eng": "Last week they had dinner together",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0430\u0448\u0430 \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044F \u0445\u0443\u0436\u0435, \u0447\u0435\u043C \u0438\u0445",
            "eng": "Your situation is worse than theirs",
            "regEng": ""
        },
        {
            "rus": "\u0422\u044B \u0437\u043D\u0430\u0435\u0448\u044C \u0442\u0435\u0445 \u043B\u044E\u0434\u0435\u0439?",
            "eng": "Do you know those people?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u0435\u0439 \u0442\u043E \u0431\u044B\u043B \u043C\u0430\u0433\u0430\u0437\u0438\u043D? \u0422\u043E \u0431\u044B\u043B \u043C\u0430\u0433\u0430\u0437\u0438\u043D \u043C\u043E\u0435\u0439 \u0441\u0435\u043C\u044C\u0438",
            "eng": "Whose shop was that? That was my family`s shop",
            "regEng": "/Whose (?:shop|store) was that\\? That was my family`s (?:shop|store)/gm"
        }
    ],
    [
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u0442\u044B \u043F\u043E\u0439\u0434\u0435\u0448\u044C \u0432 \u043A\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u043E",
            "eng": "Tomorrow you will go to bed late",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0432\u0430\u0448\u0438 \u0434\u0435\u043D\u044C\u0433\u0438. \u0422\u0435 \u0434\u0435\u043D\u044C\u0433\u0438 \u0431\u044B\u043B\u0438 \u0432\u0430\u0448\u0438",
            "eng": "That was your money. That money was yours",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0433\u043E \u0432\u043E\u043B\u043E\u0441\u044B \u043A\u043E\u0440\u043E\u0447\u0435, \u0447\u0435\u043C \u0435\u0451",
            "eng": "His hair is shorter than hers",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0430 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0441\u043B\u0443\u0448\u0430\u0435\u0442 \u044D\u0442\u0438 \u043F\u0435\u0441\u043D\u0438 \u0432 \u0441\u0440\u0435\u0434\u0443",
            "eng": "She does not always listen to these songs on Wednesday",
            "regEng": "/She (?:does not|doesn\u2019t) always listen to these songs on Wednesday/gm"
        },
        {
            "rus": "\u0420\u0430\u0434 \u043B\u0438 \u044D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u0432\u0441\u0435\u0433\u0434\u0430 \u0432\u0438\u0434\u0435\u0442\u044C \u0435\u0451?",
            "eng": "Is this man always glad to see her?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041E\u0447\u0435\u043D\u044C \u043B\u0438 \u0442\u0435\u0431\u0435 \u0445\u043E\u043B\u043E\u0434\u043D\u043E?",
            "eng": "Are you very cold?",
            "regEng": ""
        },
        {
            "rus": "\u041E \u0447\u0451\u043C \u043C\u044B \u043F\u043E\u0434\u0443\u043C\u0430\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u0434\u0435\u043B\u044E?",
            "eng": "What will we think about in a week?",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u0438 \u0436\u0435\u043D\u0449\u0438\u043D\u044B \u043A\u0443\u0448\u0430\u044E\u0442 \u0442\u0430\u043A\u0438\u0435 \u0432\u043A\u0443\u0441\u043D\u044B\u0435 \u043F\u0438\u0440\u043E\u0436\u043D\u044B\u0435 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F",
            "eng": "These women eat such tasty cakes all the time",
            "regEng": ""
        },
        {
            "rus": "\u0422\u043E \u0431\u044B\u043B\u0438 \u0438\u0445 \u0441\u0435\u0440\u0435\u0431\u0440\u044F\u043D\u044B\u0435 \u0441\u0435\u0440\u0451\u0436\u043A\u0438? \u0422\u0435 \u0441\u0435\u0440\u0435\u0431\u0440\u044F\u043D\u044B\u0435 \u0441\u0435\u0440\u0451\u0436\u043A\u0438 \u0431\u044B\u043B\u0438 \u0438\u0445?",
            "eng": "Were those their silver earrings? Were those silver earrings theirs?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0435\u0445\u0430\u043B\u0438 \u043B\u0438 \u043E\u043D\u0438 \u0434\u043E\u043C\u043E\u0439 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u0435 \u043C\u0435\u0441\u044F\u0446 \u043D\u0430\u0437\u0430\u0434?",
            "eng": "Did they go home by train a month ago?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041E \u0447\u0451\u043C \u0431\u044B\u043B \u0442\u043E\u0442 \u0444\u0438\u043B\u044C\u043C?",
            "eng": "What was that film about?",
            "regEng": "/What was that (?:film|movie) about?/gm"
        },
        {
            "rus": "\u041E\u043D \u0431\u0443\u0434\u0435\u0442 \u043E\u0447\u0435\u043D\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u043C \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0433\u043E\u0434\u0443",
            "eng": "He will be very successful next year",
            "regEng": "/(?:He will|He\u2019ll) be very successful next year/gm"
        },
        {
            "rus": "\u0427\u0435\u0439 \u0442\u043E \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A? \u0422\u043E \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A \u0435\u0433\u043E \u0436\u0435\u043D\u044B",
            "eng": "Whose relative is that? That is his wife\u2019s relative",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D \u0432\u0441\u0435\u0433\u0434\u0430 \u0436\u0434\u0451\u0442 \u044D\u0442\u0438\u0445 \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043E\u043A",
            "eng": "He always waits for these parties",
            "regEng": ""
        },
        {
            "rus": "\u0421 \u043A\u0435\u043C \u043E\u043D\u0430 \u043F\u0440\u0438\u0435\u0434\u0435\u0442 \u0441\u044E\u0434\u0430 \u0447\u0435\u0440\u0435\u0437 \u0433\u043E\u0434?",
            "eng": "Who will she come here with in a year?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0427\u0442\u043E \u0435\u043C\u0443 \u043D\u0443\u0436\u043D\u043E \u0438\u0441\u043A\u0430\u0442\u044C?",
            "eng": "What does he need to look for?",
            "regEng": "/What does he need to (?:look|search) for\\?/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u0442\u0432\u043E\u0438 \u0431\u0440\u044E\u043A\u0438? \u042D\u0442\u0438 \u0431\u0440\u044E\u043A\u0438 \u0442\u0432\u043E\u0438?",
            "eng": "Are these your trousers? Are these trousers yours?",
            "regEng": "/Are these your (?:trousers|pants)\\? Are these (?:trousers|pants) yours\\?/gm"
        },
        {
            "rus": "\u0418\u0445 \u0431\u0443\u0442\u0435\u0440\u0431\u0440\u043E\u0434\u044B \u0432\u043A\u0443\u0441\u043D\u0435\u0435, \u0447\u0435\u043C \u043C\u043E\u0438",
            "eng": "Their sandwiches are tastier than mine",
            "regEng": "/Their sandwiches are (?:tastier|more delicious) than mine/gm"
        },
        {
            "rus": "\u0412\u044B \u043D\u0435 \u043E\u043F\u043E\u0437\u0434\u0430\u043B\u0438 \u0432 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "You were not late on Monday",
            "regEng": "/(?:You (?:were not|weren\u2019t) late on Monday)|(?:On Monday You (?:were not|weren\u2019t) late)/gm"
        },
        {
            "rus": "\u042F \u0445\u043E\u0447\u0443, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u043F\u043E\u0448\u043B\u0438 \u0432 \u044D\u0442\u043E \u043C\u0435\u0441\u0442\u043E \u0432\u043C\u0435\u0441\u0442\u0435 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0433",
            "eng": "I want us to go to this place together on Thursday",
            "regEng": "/(?:I want us to go to this place together on Thursday)|(?:On Thursday I want is to go to this place together)/gm"
        }
    ],
    [
        {
            "rus": "\u042D\u0442\u0430 \u043E\u0434\u0435\u0436\u0434\u0430 \u0438\u0445, \u043D\u0435 \u043D\u0430\u0448\u0430",
            "eng": "These clothes are theirs, not ours",
            "regEng": "/These clothes are theirs, (?:not ours|they are not ours|they\u2019re not ours|these are not ours|these aren\u2019t ours)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E\u0442 \u043C\u0443\u0436\u0447\u0438\u043D\u0430 \u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u0433\u043E\u0440\u0434\u0438\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0435\u0439 \u0434\u043E\u0447\u0435\u0440\u044C\u044E",
            "eng": "This man will not always be proud of his daughter",
            "regEng": "/This man (?:will not|won\u2019t) always be proud of his daughter/gm"
        },
        {
            "rus": "\u0417\u0430\u0432\u0442\u0440\u0430 \u044F \u043F\u043E\u043F\u044B\u0442\u0430\u044E\u0441\u044C \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u0442\u044C \u044D\u0442\u043E \u0443\u043F\u0440\u0430\u0436\u043D\u0435\u043D\u0438\u0435",
            "eng": "Tomorrow I will try to finish this exercise",
            "regEng": "/Tomorrow (?:I will|I\u2019ll) try to finish this exercise/gm"
        },
        {
            "rus": "\u0415\u0439 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0448\u043E\u043A\u043E\u043B\u0430\u0434?",
            "eng": "Does she like chocolate?",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u043F\u043B\u0430\u0442\u044C\u044F? \u041E\u043D\u0438 \u0442\u0432\u043E\u0438",
            "eng": "Whose dresses are these? They are yours",
            "regEng": "/Whose dresses are these\\? (?:They are|They\u2019re) yours/gm"
        }
    ],
    [
        {
            "rus": "\u0412\u044B \u0440\u0430\u0437\u0433\u043E\u0432\u0430\u0440\u0438\u0432\u0430\u0435\u0442\u0435 \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u043A\u043E\u043B\u043B\u0435\u0433\u0430\u043C\u0438 \u043A\u0430\u0436\u0434\u044B\u0439 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
            "eng": "You talk to your colleagues every Monday",
            "regEng": "/You talk (?:to|with) your colleagues every Monday/gm"
        },
        {
            "rus": "\u041C\u044B \u043D\u0435 \u0447\u0430\u0441\u0442\u043E \u0433\u043E\u0432\u043E\u0440\u0438\u043C \u043E\u0431 \u044D\u0442\u043E\u043C \u0431\u0438\u0437\u043D\u0435\u0441\u0435",
            "eng": "We do not often talk about this business",
            "regEng": "/We (?:do not|don\u2019t) often (?:talk|speak) about this business/gm"
        },
        {
            "rus": "\u0423 \u043D\u0435\u0451 \u043A\u0440\u0430\u0441\u0438\u0432\u0430\u044F \u0434\u043E\u0447\u043A\u0430",
            "eng": "She has a beautiful daughter",
            "regEng": ""
        },
        {
            "rus": "\u0413\u0434\u0435 \u0436\u0438\u0432\u0451\u0442 \u0442\u0432\u043E\u044F \u043F\u043E\u0434\u0440\u0443\u0433\u0430?",
            "eng": "Where does your friend live?",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0438 \u0438\u0433\u0440\u0430\u044E\u0442 \u0432 \u0442\u0435\u043D\u043D\u0438\u0441 \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
            "eng": "They play tennis every day",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0427\u044C\u0438 \u044D\u0442\u043E \u0431\u0440\u044E\u043A\u0438? \u041E\u043D\u0438 \u0414\u0436\u043E\u043D\u0430",
            "eng": "Whose trousers are these? They are John`s",
            "regEng": "/Whose (?:trousers|pants) are these\\? (?:They are|They\u2019re|These are) John`s/gm"
        },
        {
            "rus": "\u041E\u043D\u0430 \u0431\u043E\u043B\u0435\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430\u044F, \u0447\u0435\u043C \u044F",
            "eng": "She is more active than me",
            "regEng": "/(?:She(?: is|`s)) more active than me/gm"
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u0440\u0443\u0447\u043A\u0430? \u041E\u043D\u0430 \u043C\u043E\u0435\u0439 \u0441\u0435\u0441\u0442\u0440\u044B",
            "eng": "Whose pen is this? It is my sister`s",
            "regEng": "/Whose pen is this\\? (?:It is|It\u2019s) my sister`s/gm"
        },
        {
            "rus": "\u0422\u0432\u043E\u0438 \u0432\u043E\u043B\u043E\u0441\u044B \u0442\u0435\u043C\u043D\u0435\u0435, \u0447\u0435\u043C \u0443 \u0442\u0432\u043E\u0435\u0433\u043E \u0431\u0440\u0430\u0442\u0430",
            "eng": "Your hair is darker than your brother`s",
            "regEng": ""
        },
        {
            "rus": "\u041E\u043D\u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u0440\u0443\u0441\u0442\u043D\u044B\u0435, \u0447\u0435\u043C \u043C\u044B",
            "eng": "They are sadder than us",
            "regEng": "/(?:They are|They\u2019re) sadder than (?:us|we are|we)/gm"
        },
        {
            "rus": "\u0414\u0435\u0442\u0438 \u044D\u0442\u0438\u0445 \u0436\u0435\u043D\u0449\u0438\u043D \u0441\u043F\u043E\u043A\u043E\u0439\u043D\u0435\u0435 \u043D\u0430\u0448\u0438\u0445",
            "eng": "These women`s children are calmer than ours",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0442\u0432\u043E\u044F \u043C\u0430\u0448\u0438\u043D\u0430? \u041D\u0435\u0442, \u043E\u043D\u0430 \u043C\u043E\u0438\u0445 \u0440\u043E\u0434\u0438\u0442\u0435\u043B\u0435\u0439",
            "eng": "Is this your car? No, it is my parents`",
            "regEng": "/Is this (?:your car|car yours)\\? No, (?:it is|it\u2019s) my parents`/gm"
        },
        {
            "rus": "\u0427\u0435\u0439 \u044D\u0442\u043E \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440? \u041E\u043D \u041C\u044D\u0440\u0438",
            "eng": "Whose computer is this? It is Mary`s",
            "regEng": "/Whose computer is this\\? (?:It is|It\u2019s) Mary`s/gm"
        }
    ],
    [
        {
            "rus": "\u042F \u0441\u0447\u0430\u0441\u0442\u043B\u0438\u0432\u0435\u0435, \u0447\u0435\u043C \u043E\u043D\u0438",
            "eng": "I am happier than them",
            "regEng": "/(?:I am|I\u2019m) happier than (?:them|they are|they)/gm"
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u043E\u0434\u0435\u0436\u0434\u0430? \u041E\u043D\u0430 \u043D\u0430\u0448\u0438\u0445 \u0441\u044B\u043D\u043E\u0432\u0435\u0439",
            "eng": "Whose clothes are these? They are our sons`",
            "regEng": "/Whose clothes are these\\? (?:They are|They\u2019re|These) our sons\u2019/gm"
        },
        {
            "rus": "\u0422\u044B \u0431\u043E\u043B\u0435\u0435 \u0442\u0430\u043B\u0430\u043D\u0442\u043B\u0438\u0432\u044B\u0439, \u0447\u0435\u043C \u043E\u043D\u0430",
            "eng": "You are more talented than her",
            "regEng": "/(?:You are|You\u2019re) more talented than (?:she(?: is)?|her)/gm"
        },
        {
            "rus": "\u0418\u0445 \u0434\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0443 \u0438\u0445 \u0441\u043E\u0441\u0435\u0434\u0435\u0439",
            "eng": "Their house is bigger than their neighbours`",
            "regEng": "/Their house is (?:bigger|larger) than their neighbou?rs`/gm"
        },
        {
            "rus": "\u0427\u044C\u0438 \u0442\u043E \u0442\u0443\u0444\u043B\u0438? \u041E\u043D\u0438 \u043C\u043E\u0435\u0439 \u043C\u0430\u0442\u0435\u0440\u0438",
            "eng": "Whose shoes are those? They are my mother`s",
            "regEng": "/Whose shoes are those\\? (?:They(?:`re)?|Those) are my (?:mother|mom|mum)`s/gm"
        },
        {
            "rus": "\u042D\u0442\u0438 \u0447\u0430\u0441\u044B \u043D\u0435 \u043C\u043E\u0438, \u043E\u043D\u0438 \u043C\u043E\u0435\u0433\u043E \u043E\u0442\u0446\u0430",
            "eng": "This watch is not mine, it is my father`s",
            "regEng": "/This(?: watch)? (?:is not|isn`t) (?:mine|my watch), it(?: is|`s) my (?:father|dad|daddy)`s/gm"
        },
        {
            "rus": "\u0416\u0443\u0440\u043D\u0430\u043B\u044B \u0442\u0432\u043E\u0438\u0445 \u0434\u0440\u0443\u0437\u0435\u0439 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0435\u0435, \u0447\u0435\u043C \u0442\u0432\u043E\u0438",
            "eng": "Your friends` magazines are more interesting than yours",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041D\u0430 \u043F\u043E\u043B\u043A\u0435 \u043B\u0435\u0436\u0430\u0442 \u0436\u0443\u0440\u043D\u0430\u043B\u044B",
            "eng": "There are magazines on the shelf",
            "regEng": ""
        },
        {
            "rus": "\u041B\u0435\u0436\u0430\u0442 \u043B\u0438 \u043D\u0430 \u043F\u043E\u043B\u043A\u0435 \u0436\u0443\u0440\u043D\u0430\u043B\u044B?",
            "eng": "Are there magazines on the shelf?",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430 \u0434\u0438\u0432\u0430\u043D\u0435 \u0431\u044B\u043B\u0430 \u043F\u043E\u0434\u0443\u0448\u043A\u0430",
            "eng": "There was a cushion on the sofa",
            "regEng": "/There was a cushion on the (?:sofa|couch)/gm"
        },
        {
            "rus": "\u0411\u044B\u043B\u0430 \u043B\u0438 \u043D\u0430 \u0434\u0438\u0432\u0430\u043D\u0435 \u043F\u043E\u0434\u0443\u0448\u043A\u0430?",
            "eng": "Was there a cushion on the sofa?",
            "regEng": "/Was there a cushion on the (?:sofa|couch)\\?/gm"
        },
        {
            "rus": "\u0423 \u0441\u0442\u0435\u043D\u044B \u0431\u0443\u0434\u0443\u0442 \u044F\u0449\u0438\u043A\u0438",
            "eng": "There will be boxes by the wall",
            "regEng": "/There(?: will|`ll) be boxes by the wall/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0443\u0442 \u043B\u0438 \u0443 \u0441\u0442\u0435\u043D\u044B \u044F\u0449\u0438\u043A\u0438?",
            "eng": "Will there be boxes by the wall?",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430 \u043F\u043E\u0442\u043E\u043B\u043A\u0435 \u0435\u0441\u0442\u044C \u043F\u044F\u0442\u043D\u043E",
            "eng": "There is a stain on the ceiling",
            "regEng": "/There(?: is|`s) a stain on the ceiling/gm"
        },
        {
            "rus": "\u0415\u0441\u0442\u044C \u043B\u0438 \u043F\u044F\u0442\u043D\u043E \u043D\u0430 \u043F\u043E\u0442\u043E\u043B\u043A\u0435?",
            "eng": "Is there a stain on the ceiling?",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0412 \u0434\u043E\u043C\u0435 \u0435\u0441\u0442\u044C \u043A\u0430\u043A\u0438\u0435-\u0442\u043E \u043B\u044E\u0434\u0438",
            "eng": "There are some people in the house",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0441\u0442\u044C \u043B\u0438 \u0432 \u0434\u043E\u043C\u0435 \u043A\u0430\u043A\u0438\u0435-\u043D\u0438\u0431\u0443\u0434\u044C \u043B\u044E\u0434\u0438?",
            "eng": "Are there any people in the house?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u0434\u043E\u043C\u0435 \u043D\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u043B\u044E\u0434\u0435\u0439",
            "eng": "There aren`t any people in the house",
            "regEng": "/There (?:are not|aren`t) any people in the house/gm"
        },
        {
            "rus": "\u0412 \u0434\u043E\u043C\u0435 \u043D\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u043B\u044E\u0434\u0435\u0439",
            "eng": "There are no people in the house",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u0431\u0443\u0442\u044B\u043B\u043A\u0435 \u0431\u044B\u043B\u043E \u043D\u0435\u043C\u043D\u043E\u0433\u043E \u0432\u043E\u0434\u044B",
            "eng": "There was some water in the bottle",
            "regEng": ""
        },
        {
            "rus": "\u0411\u044B\u043B\u043E \u043B\u0438 \u0432 \u0431\u0443\u0442\u044B\u043B\u043A\u0435 \u0441\u043A\u043E\u043B\u044C\u043A\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u0432\u043E\u0434\u044B?",
            "eng": "Was there any water in the bottle?",
            "regEng": ""
        },
        {
            "rus": "\u0412 \u0431\u0443\u0442\u044B\u043B\u043A\u0435 \u043D\u0435 \u0431\u044B\u043B\u043E \u043D\u0438\u043A\u0430\u043A\u043E\u0439 \u0432\u043E\u0434\u044B",
            "eng": "There wasn`t any water in the bottle",
            "regEng": "/There (?:was not|wasn`t) any water in the bottle/gm"
        },
        {
            "rus": "\u0412 \u0431\u0443\u0442\u044B\u043B\u043A\u0435 \u043D\u0435 \u0431\u044B\u043B\u043E \u043D\u0438\u043A\u0430\u043A\u043E\u0439 \u0432\u043E\u0434\u044B",
            "eng": "There was no water in the bottle",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041D\u0430 \u0441\u0442\u043E\u043B\u0435 \u0431\u0443\u0434\u0443\u0442 \u043A\u043E\u0435-\u043A\u0430\u043A\u0438\u0435 \u0442\u0430\u0440\u0435\u043B\u043A\u0438",
            "eng": "There will be some plates on the table",
            "regEng": "/There(?: will|`ll) be some plates on the table/gm"
        },
        {
            "rus": "\u0411\u0443\u0434\u0443\u0442 \u043B\u0438 \u043D\u0430 \u0441\u0442\u043E\u043B\u0435 \u043A\u0430\u043A\u0438\u0435-\u043D\u0438\u0431\u0443\u0434\u044C \u0442\u0430\u0440\u0435\u043B\u043A\u0438?",
            "eng": "Will there be any plates on the table?",
            "regEng": ""
        },
        {
            "rus": "\u041D\u0430 \u0441\u0442\u043E\u043B\u0435 \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u0442\u0430\u0440\u0435\u043B\u043E\u043A",
            "eng": "There won`t be any plates on the table",
            "regEng": "/There (?:will not|won`t) be any plates on the table/gm"
        },
        {
            "rus": "\u041D\u0430 \u0441\u0442\u043E\u043B\u0435 \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u0442\u0430\u0440\u0435\u043B\u043E\u043A",
            "eng": "There will be no plates on the table",
            "regEng": "/There(?: will|`ll) be no plates on the table/gm"
        },
        {
            "rus": "\u041F\u043E\u0434 \u0434\u0435\u0440\u0435\u0432\u043E\u043C \u0431\u044B\u043B\u043E \u0441\u043A\u043E\u043B\u044C\u043A\u043E-\u0442\u043E \u044F\u0431\u043B\u043E\u043A",
            "eng": "There were some apples under the tree",
            "regEng": ""
        },
        {
            "rus": "\u0411\u044B\u043B\u043E \u043B\u0438 \u0441\u043A\u043E\u043B\u044C\u043A\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u044F\u0431\u043B\u043E\u043A \u043F\u043E\u0434 \u0434\u0435\u0440\u0435\u0432\u043E\u043C?",
            "eng": "Were there any apples under the tree?",
            "regEng": ""
        },
        {
            "rus": "\u041F\u043E\u0434 \u0434\u0435\u0440\u0435\u0432\u043E\u043C \u043D\u0435 \u0431\u044B\u043B\u043E \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u044F\u0431\u043B\u043E\u043A",
            "eng": "There weren`t any apples under the tree",
            "regEng": "/There (?:were not|weren`t) any apples under the tree/gm"
        },
        {
            "rus": "\u041F\u043E\u0434 \u0434\u0435\u0440\u0435\u0432\u043E\u043C \u043D\u0435 \u0431\u044B\u043B\u043E \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u044F\u0431\u043B\u043E\u043A",
            "eng": "There were no apples under the tree",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u0413\u0434\u0435 \u0434\u0435\u0442\u0438? \u042F \u0432\u0438\u0434\u0435\u043B \u0438\u0445 \u0432 \u0441\u0430\u0434\u0443 \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            "eng": "Where are the children? I saw them in the garden a minute ago",
            "regEng": ""
        },
        {
            "rus": "\u0423 \u043E\u043A\u043D\u0430 \u0441\u0442\u043E\u0438\u0442 \u043A\u0440\u0435\u0441\u043B\u043E. \u041A\u0440\u0435\u0441\u043B\u043E \u0441\u0438\u043D\u0435\u0435",
            "eng": "There is an armchair by the window. The armchair is blue",
            "regEng": "/There(?: is|`s) an armchair by the window. The armchair is blue/gm"
        },
        {
            "rus": "\u0422\u044B \u0437\u0430\u043A\u0440\u044B\u043B \u0434\u0432\u0435\u0440\u044C? \u042F \u043D\u0435 \u043F\u043E\u043C\u043D\u044E",
            "eng": "Did you close the door? I do not remember",
            "regEng": "/Did you close the door\\? I (?:do not|don\u2019t) remember/gm"
        },
        {
            "rus": "\u041C\u044B \u0445\u043E\u0442\u0438\u043C, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0438 \u043D\u0430\u0441\u043B\u0430\u0436\u0434\u0430\u043B\u0438\u0441\u044C \u0441\u043E\u043B\u043D\u0446\u0435\u043C \u0438 \u043C\u043E\u0440\u0435\u043C",
            "eng": "We want them to enjoy the sun and the sea",
            "regEng": ""
        },
        {
            "rus": "\u0413\u0434\u0435 \u0441\u0443\u043C\u043A\u0430? \u041E\u043D\u0430 \u0432 \u043C\u0430\u0448\u0438\u043D\u0435",
            "eng": "Where is the bag? It is in the car",
            "regEng": "/Where(?: is|`s) the bag\\? (?:It is|It\u2019s) in the car/gm"
        },
        {
            "rus": "\u041D\u0430 \u043F\u0440\u043E\u0448\u043B\u043E\u0439 \u043D\u0435\u0434\u0435\u043B\u0435 \u043E\u043D\u0430 \u043A\u0443\u043F\u0438\u043B\u0430 \u043D\u043E\u0432\u043E\u0435 \u043F\u043B\u0430\u0442\u044C\u0435. \u041F\u043B\u0430\u0442\u044C\u0435 \u0431\u044B\u043B\u043E \u043E\u0447\u0435\u043D\u044C \u0434\u043E\u0440\u043E\u0433\u043E\u0435",
            "eng": "Last week she bought a new dress. The dress was very expensive",
            "regEng": ""
        },
        {
            "rus": "\u041C\u043D\u0435 \u043D\u0443\u0436\u043D\u043E, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0438 \u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0447\u0435\u0440\u0435\u0437 \u0447\u0430\u0441",
            "eng": "I need you to finish the exercises in an hour",
            "regEng": ""
        },
        {
            "rus": "\u0412\u0435\u0442\u0435\u0440 \u0441\u0438\u043B\u044C\u043D\u044B\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F, \u0432\u0447\u0435\u0440\u0430 \u043E\u043D \u0431\u044B\u043B \u0441\u043B\u0430\u0431\u0435\u0435",
            "eng": "The wind is strong today, yesterday it was weaker",
            "regEng": ""
        }
    ],
    [
        {
            "rus": "\u041C\u043E\u0439 \u043E\u0442\u0432\u0435\u0442 \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u0443 \u041A\u0435\u0439\u0442",
            "eng": "My answer is better than Kate`s",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u044F \u044D\u0442\u043E \u043A\u043E\u043C\u043D\u0430\u0442\u0430? \u041E\u043D\u0430 \u043C\u043E\u0435\u0439 \u0442\u0451\u0442\u0438",
            "eng": "Whose room is this? It is my aunt`s",
            "regEng": "/Whose room is this\\? (?:It is|It\u2019s) my aunt\u2019s/gm"
        },
        {
            "rus": "\u0422\u044B \u0431\u043E\u043B\u0435\u0435 \u0441\u0442\u0440\u043E\u0439\u043D\u0430\u044F, \u0447\u0435\u043C \u043E\u043D\u0430",
            "eng": "You are slimmer than her",
            "regEng": "/(?:You are|You\u2019re) slimmer than (?:she(?: is)?|her)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u043D\u0435 \u043C\u043E\u044F \u0438\u0434\u0435\u044F, \u043E\u043D\u0430 \u043C\u043E\u0435\u0433\u043E \u043E\u0442\u0446\u0430",
            "eng": "This is not my idea, it is my father`s",
            "regEng": "/This (?:is not|isn`t) my idea, (?:it is|it`s) my (?:father`s|dad`s)/gm"
        },
        {
            "rus": "\u042D\u0442\u043E \u0432\u0430\u0448\u0438 \u0441\u043E\u0431\u0430\u043A\u0438? \u041D\u0435\u0442, \u043E\u043D\u0438 \u043D\u0430\u0448\u0438\u0445 \u0441\u043E\u0441\u0435\u0434\u0435\u0439",
            "eng": "Are these your dogs? No, they are our neighbours`",
            "regEng": "/Are these your dogs\\? No, (?:they are|they\u2019re|these are) our neighbou?rs`/gm"
        },
        {
            "rus": "\u041C\u044B \u0431\u043E\u043B\u0435\u0435 \u0443\u0441\u0442\u0430\u0432\u0448\u0438\u0435, \u0447\u0435\u043C \u043E\u043D",
            "eng": "We are more tired than him",
            "regEng": "/We(?: are|`re) more tired than (?:him|he(?: is)?)/gm"
        },
        {
            "rus": "\u0422\u0432\u043E\u044F \u043E\u0434\u0435\u0436\u0434\u0430 \u0431\u043E\u043B\u0435\u0435 \u0441\u0442\u0438\u043B\u044C\u043D\u0430\u044F, \u0447\u0435\u043C \u0435\u0451",
            "eng": "Your clothes are more stylish than hers",
            "regEng": ""
        },
        {
            "rus": "\u042D\u0442\u043E \u0434\u0435\u043D\u044C\u0433\u0438 \u043C\u043E\u0435\u0433\u043E \u0434\u044F\u0434\u0438, \u043D\u0435 \u043C\u043E\u0438",
            "eng": "This is my uncle`s money, not mine",
            "regEng": "/This (?:is my uncle`s money|money is my uncle`s), not mine/gm"
        }
    ],
    [
        {
            "rus": "\u0422\u043E \u0442\u0432\u043E\u0439 \u043A\u043B\u044E\u0447? \u041D\u0435\u0442, \u043E\u043D \u041F\u043E\u043B\u0430 \u0438\u043B\u0438 \u0414\u0436\u0435\u043A\u0430",
            "eng": "Is that your key? No, it is Paul`s or Jack`s",
            "regEng": "/Is that your key\\? No, (?:it is|it`s) Paul`s or Jack`s/gm"
        },
        {
            "rus": "\u042F \u0431\u043E\u043B\u0435\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0439, \u0447\u0435\u043C \u043E\u043D\u0438",
            "eng": "I am more successful than them",
            "regEng": "/(?:I am|I\u2019m) more successful than (?:them|they are|they)/gm"
        },
        {
            "rus": "\u0413\u043B\u0430\u0437\u0430 \u0438\u0445 \u0434\u043E\u0447\u0435\u0440\u0435\u0439 \u0441\u0432\u0435\u0442\u043B\u0435\u0435, \u0447\u0435\u043C \u0443 \u043D\u0438\u0445",
            "eng": "Their daughters` eyes are lighter than theirs",
            "regEng": ""
        },
        {
            "rus": "\u0415\u0433\u043E \u0436\u0435\u043D\u0430 \u0442\u0435\u0440\u043F\u0435\u043B\u0438\u0432\u0435\u0435, \u0447\u0435\u043C \u043E\u043D",
            "eng": "His wife is more patient than him",
            "regEng": "/His wife(?: is|`s) more patient than (?:him|he(?: is)?)/gm"
        },
        {
            "rus": "\u0412\u043E\u043B\u043E\u0441\u044B \u041A\u0435\u0439\u0442 \u0434\u043B\u0438\u043D\u043D\u0435\u0435, \u0447\u0435\u043C \u0443 \u0442\u0435\u0431\u044F",
            "eng": "Kate`s hair is longer than yours",
            "regEng": ""
        },
        {
            "rus": "\u0427\u044C\u0438 \u0442\u043E \u043A\u0443\u0440\u0442\u043A\u0438? \u041E\u043D\u0438 \u043D\u0430\u0448\u0438\u0445 \u0434\u0435\u0442\u0435\u0439",
            "eng": "Whose jackets are those? They are our children`s",
            "regEng": "/Whose jackets are those\\? (?:They are|They\u2019re|These) our children`s/gm"
        },
        {
            "rus": "\u041C\u043E\u0439 \u0434\u0440\u0443\u0433 \u043C\u043B\u0430\u0434\u0448\u0435 (\u043C\u043E\u043B\u043E\u0436\u0435) \u043C\u0435\u043D\u044F",
            "eng": "My friend is younger than me",
            "regEng": "/My friend(?: is|`s) younger than (?:I(?: am)?|me)/gm"
        }
    ]
];


class $c211e1d1e9151282$var$PackData {
    static userDataKey = 'userData';
    static setData(key, val) {
        let data;
        if (!localStorage.getItem($c211e1d1e9151282$var$PackData.userDataKey)) data = {
            [key]: val
        };
        else {
            let strData = localStorage.getItem($c211e1d1e9151282$var$PackData.userDataKey);
            data = JSON.parse(strData);
            data[key] = val;
        }
        try {
            localStorage.setItem($c211e1d1e9151282$var$PackData.userDataKey, JSON.stringify(data));
        } catch (error) {
            console.log('Error! localStorage not complete!');
        }
    }
    static getData(key) {
        const storedData = localStorage.getItem($c211e1d1e9151282$var$PackData.userDataKey);
        if (!storedData) return undefined;
        try {
            const data = JSON.parse(storedData);
            return key in data ? data[key] : undefined;
        } catch (error) {
            console.error('Error parsing JSON from localStorage:', error);
            return undefined;
        }
    }
    static clearData() {
        try {
            localStorage.removeItem($c211e1d1e9151282$var$PackData.userDataKey);
        } catch (error) {
            console.error('Error parsing JSON from localStorage:', error);
        }
    }
}
var $c211e1d1e9151282$export$2e2bcd8739ae039 = $c211e1d1e9151282$var$PackData;


function $9ba3a75466d63400$export$6deef7234d422c09(booln) {
    const rus = document.getElementById('rus');
    const eng = document.getElementById('eng');
    const mix = document.getElementById('mix');
    const blk = document.getElementsByClassName('blk');
    if (booln) for(let i = 0; i <= 2; i++)blk[i].classList.add('grey');
    else for(let i = 0; i <= 2; i++)blk[i].classList.remove('grey');
    rus.disabled = booln;
    eng.disabled = booln;
    mix.disabled = booln;
}
function $9ba3a75466d63400$export$3d19eefe17667b51(array, searchString, lang) {
    const str = searchString.toLowerCase();
    return array.map((innerArray, ind)=>innerArray.filter((item)=>item[lang].toLowerCase().includes(str)).map((el)=>{
            // Создаем поверхностную копию объекта, чтобы не мутировать оригинал
            const newEl = {
                ...el
            };
            newEl[lang] = newEl[lang] + ` <small>[${ind + 1}]</small>`;
            return newEl;
        })).flat();
}
function $9ba3a75466d63400$export$4bd6329641209a2e(array) {
    for(let i = array.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
}
function $9ba3a75466d63400$export$193fbd3e21d00825(arrayPages, data) {
    const el = document.getElementById("progress");
    el.classList.remove('fadeOpacity');
    // Важно: принудительно перерисовать элемент, чтобы удалить предыдущую анимацию
    el.offsetWidth;
    let str = data.length - arrayPages.length + "/" + data.length;
    el.innerHTML = "<span>Random progress:</span><br>" + str;
    el.classList.add('fadeOpacity');
}
function $9ba3a75466d63400$export$57bf213be019eeb0() {
    let elm = document.querySelectorAll('.el span');
    let btnShow = document.getElementById('show');
    btnShow.disabled = true;
    let event = new MouseEvent('dblclick', {
        'view': window,
        'bubbles': true,
        'cancelable': true
    });
    for(let i = 0; i < elm.length; i++)elm[i].dispatchEvent(event);
}


let $769347b3c7b397d7$var$arrayPages = Array.from({
    length: (0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039).length
}, (_, i)=>i + 1);
const $769347b3c7b397d7$var$fonts = [
    'source',
    'lora',
    'philosopher',
    'literata',
    'vollkorn',
    'firacode'
];
function $769347b3c7b397d7$var$getRandomPage() {
    if ($769347b3c7b397d7$var$arrayPages.length < 1) $769347b3c7b397d7$var$arrayPages = Array.from({
        length: (0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039).length
    }, (_, i)=>i + 1);
    return Math.floor(Math.random() * $769347b3c7b397d7$var$arrayPages.length);
}
function $769347b3c7b397d7$var$countObjects(arrays) {
    return arrays.reduce((total, array)=>total + array.length, 0);
}
console.log("\u0412\u0441\u0435\u0433\u043E", $769347b3c7b397d7$var$countObjects((0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039)), " \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u0439");
let $769347b3c7b397d7$var$GlobalHistory = true;
const $769347b3c7b397d7$var$state = {
    lang: 'rus',
    font: (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('font') ?? $769347b3c7b397d7$var$fonts[0],
    mix: false,
    links: (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('links') ?? false,
    currentPage: 1
};
const $769347b3c7b397d7$var$prx = new Proxy($769347b3c7b397d7$var$state, {
    set (target, key, val) {
        if (target[key] === val) return;
        target[key] = val;
        if (key === 'links') {
            const lnk = document.getElementById('links');
            lnk.innerHTML = $769347b3c7b397d7$var$get_links((0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039).length);
            return true;
        }
        const panel = document.getElementById('panel');
        if (key === 'font') {
            panel.classList.remove(...$769347b3c7b397d7$var$fonts, 'userfont');
            panel.classList.add(val);
            (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('font', val);
            return true;
        }
        const body = document.querySelector('body');
        if (fade.checked) {
            body.classList.add('hide');
            setTimeout(function() {
                panel.innerHTML = $769347b3c7b397d7$var$get_rows((0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039), target.currentPage);
                body.classList.remove('hide');
            }, 145);
        } else panel.innerHTML = $769347b3c7b397d7$var$get_rows((0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039), target.currentPage);
        (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('page', target.currentPage);
        (0, $9ba3a75466d63400$export$6deef7234d422c09)(false);
        if (key === 'currentPage') {
            const lnk = document.getElementById('links');
            lnk.innerHTML = $769347b3c7b397d7$var$get_links((0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039).length);
            if ($769347b3c7b397d7$var$GlobalHistory) history.pushState({
                page: target.currentPage
            }, "", "#" + target.currentPage);
            $769347b3c7b397d7$var$GlobalHistory = true;
        }
        return true;
    }
});
function $769347b3c7b397d7$export$f22da7240b7add18() {
    return $769347b3c7b397d7$var$get_langToggle() + $769347b3c7b397d7$var$get_searchPanel() + $769347b3c7b397d7$var$get_fontToggle($769347b3c7b397d7$var$fonts) + $769347b3c7b397d7$var$get_panel() + $769347b3c7b397d7$var$get_full_links((0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039).length);
}
function $769347b3c7b397d7$var$get_langToggle() {
    return `
 <section class="flexrow" aria-label="\u{43E}\u{43F}\u{446}\u{438}\u{438}">
  <span class="blk"><label for="rus" tabindex="0" title="\u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C} \u{43D}\u{430} \u{440}\u{443}\u{441}\u{441}\u{43A}\u{438}\u{439}" aria-label="\u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C} \u{43D}\u{430} \u{440}\u{443}\u{441}\u{441}\u{43A}\u{438}\u{439}">rus</label></span>
  <div class="flexcol">
   <span role="radiogroup" class="toggle-bg" id="langToggles">
     <input type="radio" name="toggle" value="rus" id="rus" onchange="prx.lang='rus'" tabindex="-1">
     <input type="radio" name="toggle" value="eng" id="eng" onchange="prx.lang='eng'" tabindex="-1">
     <span class="switch"></span>
   </span>
  </div>
  <span class="blk"><label for="eng" tabindex="0" title="\u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C} \u{43D}\u{430} \u{430}\u{43D}\u{433}\u{43B}\u{438}\u{439}\u{441}\u{43A}\u{438}\u{439}" aria-label="\u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C} \u{43D}\u{430} \u{430}\u{43D}\u{433}\u{43B}\u{438}\u{439}\u{441}\u{43A}\u{438}\u{439}">eng</label></span>
  <span class="blk side-margin">
    <label for="mix">\u{43F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{448}\u{430}\u{442}\u{44C} <input type="checkbox" id="mix" onchange="prx.mix=this.checked"></label>
  </span>
  <span class="blk">
    <button type="button" id="show" onclick="show()">\u{43F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C}</button>
  </span>
 </section>`;
}
function $769347b3c7b397d7$var$get_searchPanel() {
    let flag = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('showSearch');
    let style = 'style="display: flex"';
    if (flag === false) style = 'style="display: none"';
    return `<section class="flexrow w100" ${style}>
  <input autocomplete="off" type="text" name="search" id="search" class="search" aria-label="\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{442}\u{435}\u{43A}\u{441}\u{442} \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}" title="\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{442}\u{435}\u{43A}\u{441}\u{442} \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}"><button class="go"
  onclick="goHandler()" aria-label="\u{41F}\u{43E}\u{438}\u{441}\u{43A}">GO</button></section>`;
}
function $769347b3c7b397d7$var$goHandler() {
    const input = document.getElementById('search');
    const panel = document.getElementById('panel');
    let txt = input.value.trim();
    if (!txt.length) return;
    input.focus();
    if (txt.length < 3) {
        panel.innerHTML = "<span>\u041D\u0443\u0436\u043D\u043E \u043C\u0438\u043D\u0438\u043C\u0443\u043C 3 \u0441\u0438\u043C\u0432\u043E\u043B\u0430 \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430!</span>";
        return;
    }
    let answ = (0, $9ba3a75466d63400$export$3d19eefe17667b51)((0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039), input.value, $769347b3c7b397d7$var$prx.lang);
    if (!answ.length) {
        panel.innerHTML = "<span>\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E!</span>";
        return;
    }
    let dt = [];
    dt.push(answ);
    panel.innerHTML = $769347b3c7b397d7$var$get_rows(dt);
    (0, $9ba3a75466d63400$export$6deef7234d422c09)(true);
}
function $769347b3c7b397d7$var$get_fontToggle(fnt) {
    let flag = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('showFonts');
    let style = 'style="display: flex"';
    if (flag === false) style = 'style="display: none"';
    const li = fnt.map((el)=>{
        const ch = el === $769347b3c7b397d7$var$state.font ? 'checked' : '';
        return `
  <li><input type="radio" name="fonts" value="${el}" id="${el}" onchange="prx.font='${el}'" ${ch}>
    <label class="${el} flexrow" for="${el}" tabindex="0">${el}</label>
  </li>`;
    }).join('');
    return `
<section class="flexcol" id="fontToggles" ${style}>
 <ul class="flexrow">
${li}
 </ul>
</section>`;
}
function $769347b3c7b397d7$var$get_panel() {
    let page = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('page') ?? 1 // номер страницы из локалсторадж или 1
    ;
    $769347b3c7b397d7$var$state.currentPage = Number(page);
    let rw = $769347b3c7b397d7$var$get_rows((0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039), page);
    let font = $769347b3c7b397d7$var$prx.font;
    return `<section class="flexcol ${font}" id="panel">${rw}</section>`;
}
function $769347b3c7b397d7$var$get_rows(arr, page = 0) {
    let stranica = page > 0 ? page - 1 : 0;
    if (stranica > arr.length || arr.length < 1) return `<div>\u{41D}\u{435}\u{442} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{44B} \u{438}\u{43B}\u{438} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}</div>`;
    const part = [
        ...arr[stranica]
    ];
    let btnShow = document.getElementById('show');
    if (btnShow) btnShow.disabled = false;
    if ($769347b3c7b397d7$var$state.mix) (0, $9ba3a75466d63400$export$4bd6329641209a2e)(part);
    return $769347b3c7b397d7$var$state.lang === 'rus' ? part.map((ob)=>$769347b3c7b397d7$var$make_row(ob.rus, ob.eng, ob.regEng ? ob.regEng : null)).join('') : part.map((ob)=>$769347b3c7b397d7$var$make_row(ob.eng, ob.rus, ob.regRus ? ob.regRus : null)).join('');
}
function $769347b3c7b397d7$var$make_row(vis, answer, pattern) {
    let pt = '';
    if (pattern) pt = `data-pattern="${pattern}"`;
    return `<article class="el" data-lang="${answer}" ${pt}>
<span ondblclick="dblHandler(this,'${answer}')">${vis}</span>
<span class="editor" contenteditable="true" oninput="chHandler(this)" onblur="chHandler(this)" spellcheck="false" /></span></article>`;
}
function $769347b3c7b397d7$var$dblHandler(el, ans) {
    const thElement = el.parentNode.getElementsByTagName('span')[1];
    thElement.title = thElement.innerText;
    thElement.innerText = ans;
    $769347b3c7b397d7$var$chHandler(thElement);
//thElement.readOnly = true
}
function $769347b3c7b397d7$var$chHandler(el) {
    // Удаляем кнопку help, если она есть
    const existingHelp = el.parentNode.querySelector('.help-btn');
    if (existingHelp) existingHelp.remove();
    if (el.innerText.trim() === '') {
        el.classList.remove('err');
        el.classList.remove('done');
        return;
    }
    let input = el.innerText.trim().toLowerCase().replace(/\s+/g, ' ');
    let answer = el.parentNode.dataset.lang.trim().toLowerCase();
    let condition = answer === input;
    if (el.parentNode.dataset.pattern) {
        let reg = el.parentNode.dataset.pattern.split('/')[1] // берем выражение между //
        ;
        reg = reg.trim().toLowerCase().replaceAll("\u2019", '`') // меняем проклятый апостроф на нормальный
        ;
        const regExp = new RegExp(reg) // создаем шаблон регулярки
        ;
        condition = regExp.test(input);
    }
    // нет шаблона сравниваем в лоб
    el.className = condition ? 'done' : 'err';
    el.classList.add('editor');
    if (!condition) {
        const helpBtn = document.createElement('button');
        helpBtn.type = 'button';
        helpBtn.textContent = 'help';
        helpBtn.classList.add('help-btn');
        helpBtn.addEventListener('mouseover', ()=>{
            el.blur();
        });
        helpBtn.addEventListener('click', function(e) {
            e.stopPropagation() // предотвращаем всплытие события
            ;
            $769347b3c7b397d7$var$compareMe(el, answer, input) // вызываем функцию, передавая элемент
            ;
        });
        el.parentNode.appendChild(helpBtn);
    }
}
function $769347b3c7b397d7$var$compareMe(el, ans, inp) {
    let matchLen = 0;
    // Ограничиваем сравнение длиной первой строки (или второй, если она короче)
    const limit = Math.min(ans.length, inp.length);
    while(matchLen < limit && ans[matchLen] === inp[matchLen])matchLen++;
    let nwHTML;
    // Если первый символ не совпал — возвращаем вторую строку без изменений
    if (matchLen === 0) nwHTML = inp;
    // Возвращаем HTML по шаблону: <u>совпадение</u>остаток второй строки
    nwHTML = `<u contenteditable="false">${inp.slice(0, matchLen)}</u>${inp.slice(matchLen)}`;
    el.innerHTML = nwHTML;
}
function $769347b3c7b397d7$var$get_full_links(len) {
    const links = $769347b3c7b397d7$var$get_links(len);
    return `
<nav class="flexrow" id="links" aria-label="\u{41F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{43D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{438}" role="navigation">
  ${links}
</nav>`;
}
function $769347b3c7b397d7$var$get_links(len) {
    if (!$769347b3c7b397d7$var$prx.links) return $769347b3c7b397d7$var$long_navigatio(len);
    else return $769347b3c7b397d7$var$short_navigatio(len);
}
function $769347b3c7b397d7$var$long_navigatio(len) {
    const cnt = new Array(len).fill(0).map((el, i)=>{
        const activePage = i + 1 === $769347b3c7b397d7$var$state.currentPage;
        return $769347b3c7b397d7$var$createLink(i + 1, activePage);
    }).join('');
    return cnt;
}
const $769347b3c7b397d7$var$createLink = (page, isActive = false)=>{
    let cls = '', aria = '';
    if (isActive) {
        cls = ' active';
        aria = 'aria-current="page"';
    }
    return `<a href="#" class="link-page${cls}" onclick="prx.currentPage=${page}; return false;" ${aria} aria-label="\u{421}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430} ${page}">${page}</a>`;
};
function $769347b3c7b397d7$var$short_navigatio(totalPages) {
    const currentPage = $769347b3c7b397d7$var$prx.currentPage;
    const links = [];
    const visiblePages = 4;
    const addRangeLinks = (start, end, activePage)=>{
        for(let i = start; i <= end; i++)links.push($769347b3c7b397d7$var$createLink(i, i === activePage));
    };
    if (totalPages <= 4 * visiblePages - 1) addRangeLinks(1, totalPages, currentPage);
    else {
        if (currentPage < visiblePages * 2) {
            addRangeLinks(1, visiblePages + currentPage - 1, currentPage);
            links.push('<span class="ellipsis">...</span>');
            addRangeLinks(totalPages - visiblePages + 1, totalPages);
        } else if (currentPage > totalPages - visiblePages * 2) {
            addRangeLinks(1, visiblePages);
            links.push('<span class="ellipsis">...</span>');
            addRangeLinks(currentPage - visiblePages + 1, totalPages, currentPage);
        } else {
            addRangeLinks(1, visiblePages);
            links.push('<span class="ellipsis">...</span>');
            addRangeLinks(currentPage - visiblePages + 1, currentPage + visiblePages - 1, currentPage);
            links.push('<span class="ellipsis">...</span>');
            addRangeLinks(totalPages - visiblePages + 1, totalPages);
        }
    }
    return links.join("");
}
document.addEventListener('keydown', function(event) {
    if (event.ctrlKey && event.altKey) {
        if (event.key === 'ArrowLeft') {
            if ($769347b3c7b397d7$var$prx.currentPage > 1) $769347b3c7b397d7$var$prx.currentPage--;
        } else if (event.key === 'ArrowRight') {
            if ($769347b3c7b397d7$var$prx.currentPage < (0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039).length) $769347b3c7b397d7$var$prx.currentPage++;
        } else if (event.code === 'Space') {
            event.preventDefault() // нужно - иначе пробелом нажимаются кнопки в фокусе
            ;
            event.stopImmediatePropagation(); // останавливаем всплытие
            // 👇 Снимаем фокус с текущего элемента (label, input и т.д.)
            if (document.activeElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
            let pg = $769347b3c7b397d7$var$getRandomPage();
            $769347b3c7b397d7$var$prx.currentPage = $769347b3c7b397d7$var$arrayPages[pg];
            $769347b3c7b397d7$var$arrayPages.splice(pg, 1) // страницы не должны повторяться
            ;
            (0, $9ba3a75466d63400$export$193fbd3e21d00825)($769347b3c7b397d7$var$arrayPages, (0, $f6d2e675cb3f0a02$export$2e2bcd8739ae039));
        }
        return;
    }
    if (event.key === 'Enter' && event.target.id === "search") {
        $769347b3c7b397d7$var$goHandler();
        return;
    }
    if (event.key === ' ' || event.key === 'Enter') {
        const labelFor = [
            'eng',
            'rus',
            ...$769347b3c7b397d7$var$fonts
        ];
        const attrFor = event.target.getAttribute('for');
        if (labelFor.includes(attrFor)) {
            event.target.click();
            event.preventDefault();
        }
        return;
    }
}, true);
window.goHandler = $769347b3c7b397d7$var$goHandler;
window.show = (0, $9ba3a75466d63400$export$57bf213be019eeb0);
window.dblHandler = $769347b3c7b397d7$var$dblHandler;
window.chHandler = $769347b3c7b397d7$var$chHandler;
window.prx = $769347b3c7b397d7$var$prx;
window.onpopstate = function(event) {
    if (event.state && event.state.page) {
        $769347b3c7b397d7$var$GlobalHistory = false // чтобы не добавлять в историю еще раз
        ;
        $769347b3c7b397d7$var$prx.currentPage = event.state.page;
    }
};
const $769347b3c7b397d7$var$showLinks = document.getElementById('showLinks');
$769347b3c7b397d7$var$showLinks.checked = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('links') ?? false;
$769347b3c7b397d7$var$showLinks.addEventListener('change', function(event) {
    (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('links', event.target.checked);
    $769347b3c7b397d7$var$prx.links = event.target.checked;
});



const $891048a322cecc4f$var$hueSlider = document.getElementById('hue');
const $891048a322cecc4f$var$saturationSlider = document.getElementById('saturation');
const $891048a322cecc4f$var$lightnessSlider = document.getElementById('lightness');
document.addEventListener("DOMContentLoaded", ()=>{
    const dom = document.getElementById('main');
    $891048a322cecc4f$var$init(dom);
    if ((0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('theme') === 'theme-dark') {
        document.getElementById('slider').checked = false;
        document.documentElement.className = 'theme-dark';
    } else document.getElementById('slider').checked = true;
});
function $891048a322cecc4f$var$setTheme(themeName) {
    (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('theme', themeName);
    document.documentElement.className = themeName;
    if (themeName === 'theme-dark') {
        $891048a322cecc4f$var$hueSlider.value = 200;
        $891048a322cecc4f$var$saturationSlider.value = 40;
        $891048a322cecc4f$var$lightnessSlider.value = 12;
    } else {
        $891048a322cecc4f$var$hueSlider.value = 128;
        $891048a322cecc4f$var$saturationSlider.value = 100;
        $891048a322cecc4f$var$lightnessSlider.value = 90;
    }
    $891048a322cecc4f$var$SaveColor();
}
function $891048a322cecc4f$var$SaveColor() {
    const { value: h } = $891048a322cecc4f$var$hueSlider;
    const { value: s } = $891048a322cecc4f$var$saturationSlider;
    const { value: l } = $891048a322cecc4f$var$lightnessSlider;
    hueVal.textContent = h;
    saturationVal.textContent = s;
    lightnessVal.textContent = l;
    (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('bgColor', {
        h: h,
        s: s,
        l: l
    });
    document.body.style.backgroundColor = `hsl(${h}, ${s}%, ${l}%)`;
}
// function to toggle between light and dark theme
function $891048a322cecc4f$var$toggleTheme() {
    (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('theme') === 'theme-dark' ? $891048a322cecc4f$var$setTheme('theme-light') : $891048a322cecc4f$var$setTheme('theme-dark');
}
window.toggleTheme = $891048a322cecc4f$var$toggleTheme;
function $891048a322cecc4f$var$init(el) {
    el.innerHTML = (0, $769347b3c7b397d7$export$f22da7240b7add18)();
    const search = document.getElementById('search');
    const fonts = document.getElementById('fontToggles');
    const showTitle = document.getElementById('showTitle');
    const fade = document.getElementById('fade');
    fade.checked = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('fade') ?? true;
    fade.addEventListener('input', (e)=>{
        (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('fade', e.target.checked);
    });
    showTitle.checked = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('showTitle') ?? true;
    const titles = document.querySelectorAll('h3.center, a.repo, div.spoiler');
    if (!showTitle.checked) titles.forEach((el)=>el.style.display = 'none');
    const showSearch = document.getElementById('showSearch');
    showSearch.checked = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('showSearch') ?? true;
    const showFonts = document.getElementById('showFonts');
    showFonts.checked = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('showFonts') ?? true;
    showSearch.addEventListener('input', (e)=>{
        search.parentNode.style.display = e.target.checked ? 'flex' : 'none';
        (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('showSearch', e.target.checked);
    });
    showFonts.addEventListener('input', (e)=>{
        fonts.style.display = e.target.checked ? 'flex' : 'none';
        (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('showFonts', e.target.checked);
    });
    showTitle.addEventListener('input', (e)=>{
        const current = e.target.checked ? 'block' : 'none';
        titles.forEach((el)=>el.style.display = current);
        (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('showTitle', e.target.checked);
    });
    const increaseButton = document.getElementById('increaseFont');
    const decreaseButton = document.getElementById('decreaseFont');
    // Функция для изменения размера шрифта в rem на body
    function adjustBodyFontSize(change) {
        const MIN_FONT_SIZE = 12;
        const MAX_FONT_SIZE = 30;
        const oldVal = getComputedStyle(document.documentElement).getPropertyValue('--max_size');
        let res = Number(oldVal) + change;
        if (res < MIN_FONT_SIZE || res > MAX_FONT_SIZE) return;
        document.documentElement.style.setProperty('--max_size', Number(oldVal) + change);
        document.getElementById('fsize').innerHTML = Number(oldVal) + change;
    }
    // Обработчики событий для кнопок
    increaseButton.addEventListener('click', ()=>adjustBodyFontSize(0.5)); // Увеличить шрифт
    decreaseButton.addEventListener('click', ()=>adjustBodyFontSize(-0.5)); // Уменьшить шрифт
    // Функция для получения текущего цвета фона страницы в формате HSL
    function getCurrentHSL() {
        const computedStyle = getComputedStyle(document.body);
        const bgColor = computedStyle.backgroundColor;
        // Преобразуем текущий цвет фона в HSL
        const rgb = bgColor.match(/\d+/g).map(Number);
        const r = rgb[0] / 255;
        const g = rgb[1] / 255;
        const b = rgb[2] / 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;
        if (max === min) h = s = 0; // achromatic
        else {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        h = Math.round(h * 360);
        s = Math.round(s * 100);
        l = Math.round(l * 100);
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // Устанавливаем начальные значения ползунков из текущего цвета фона
    const { h: h, s: s, l: l } = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('bgColor') ?? getCurrentHSL();
    const hueVal1 = document.getElementById('hueVal');
    const saturationVal1 = document.getElementById('saturationVal');
    const lightnessVal1 = document.getElementById('lightnessVal');
    $891048a322cecc4f$var$hueSlider.value = h;
    $891048a322cecc4f$var$saturationSlider.value = s;
    $891048a322cecc4f$var$lightnessSlider.value = l;
    hueVal1.innerHTML = h;
    saturationVal1.innerHTML = s;
    lightnessVal1.innerHTML = l;
    document.body.style.backgroundColor = `hsl(${h}, ${s}%, ${l}%)`;
    // Добавляем обработчики событий для ползунков
    $891048a322cecc4f$var$hueSlider.addEventListener('input', $891048a322cecc4f$var$SaveColor);
    $891048a322cecc4f$var$saturationSlider.addEventListener('input', $891048a322cecc4f$var$SaveColor);
    $891048a322cecc4f$var$lightnessSlider.addEventListener('input', $891048a322cecc4f$var$SaveColor);
    document.querySelector('button[title="Delete"]').addEventListener('click', ()=>{
        (0, $c211e1d1e9151282$export$2e2bcd8739ae039).clearData();
        location.reload();
    //document.documentElement.className = 'theme-light';
    });
}
// Функция для применения шрифта по ссылке Google Fonts
function $891048a322cecc4f$var$applyFontFromUrl(fontUrl) {
    if (!$891048a322cecc4f$var$isValidGoogleFontUrl(fontUrl)) return;
    (0, $c211e1d1e9151282$export$2e2bcd8739ae039).setData('urlFonts', fontUrl);
    let fontLink = document.getElementById('googleFontLink');
    if (!fontLink) {
        fontLink = document.createElement('link');
        fontLink.id = 'googleFontLink';
        fontLink.rel = 'stylesheet';
        document.head.appendChild(fontLink);
    }
    fontLink.href = fontUrl;
    // Извлекаем имя шрифта из ссылки
    const fontName = $891048a322cecc4f$var$extractFontName(fontUrl);
    $891048a322cecc4f$var$applyUserFont(fontName);
}
function $891048a322cecc4f$var$applyUserFont(userFont) {
    // Применяем шрифт к элементам
    const panel = document.getElementById('panel');
    const fonts = [
        'source',
        'lora',
        'philosopher',
        'literata',
        'vollkorn',
        'firacode'
    ];
    panel.classList.remove(...fonts);
    // https://fonts.googleapis.com/css2?family=Marmelad
    // https://fonts.googleapis.com/css2?family=Balsamiq+Sans:ital,wght@0,400;0,700;1,400;1,700&family=Protest+Guerrilla&display=swap
    // https://fonts.googleapis.com/css2?family=Shantell+Sans:ital,wght@0,300..800;1,300..800&display=swap
    // https://fonts.googleapis.com/css2?family=Neucha&display=swap
    const styleSheet = document.styleSheets[0]; // Первая таблица стилей
    const bodyRule = Array.from(styleSheet.cssRules).find((rule)=>rule.selectorText === '.userfont');
    if (bodyRule) bodyRule.style.fontFamily = userFont;
    panel.classList.add('userfont');
    document.querySelectorAll('input[type="radio"]').forEach((radio)=>{
        radio.checked = false;
    });
}
// Функция для извлечения имени шрифта из ссылки Google Fonts
function $891048a322cecc4f$var$extractFontName(fontUrl) {
    const url = new URL(fontUrl);
    const familyParam = url.searchParams.get('family');
    return familyParam ? familyParam.split(':')[0].replace(/\+/g, ' ') : 'sans-serif';
}
document.getElementById('fontUrlInput').value = (0, $c211e1d1e9151282$export$2e2bcd8739ae039).getData('urlFonts') ?? "";
// Обработчик применения шрифта по ссылке
document.getElementById('applyFontUrl').addEventListener('click', function() {
    const fontUrl = document.getElementById('fontUrlInput').value;
    if (fontUrl) $891048a322cecc4f$var$applyFontFromUrl(fontUrl);
});
function $891048a322cecc4f$var$isValidGoogleFontUrl(url) {
    // Регулярное выражение для проверки валидности URL на шрифт Google Fonts
    const googleFontsRegex = /^https:\/\/fonts\.googleapis\.com\/css2\?family=[A-Za-z+:\&=\d,%\s\-]+$/;
    // Проверяем, является ли URL строкой и соответствует ли он шаблону
    if (typeof url !== 'string') return false;
    return googleFontsRegex.test(url);
}
// Функция для применения локального файла шрифта
function $891048a322cecc4f$var$applyCustomFont(fontFile, fontName) {
    $891048a322cecc4f$var$applyUserFont(fontName);
    // Проверяем, существует ли уже шрифт с таким fontName
    if ($891048a322cecc4f$var$fontExists(fontName)) {
        console.log(`\u{428}\u{440}\u{438}\u{444}\u{442} ${fontName} \u{443}\u{436}\u{435} \u{434}\u{43E}\u{431}\u{430}\u{432}\u{43B}\u{435}\u{43D}`);
        return;
    }
    const fontUrl = URL.createObjectURL(fontFile);
    const style = document.createElement('style');
    style.textContent = `
        @font-face {
            font-family: '${fontName}';
            src: url('${fontUrl}');
        }
    `;
    document.head.appendChild(style);
}
function $891048a322cecc4f$var$fontExists(fontName) {
    // Регулярное выражение для извлечения значения font-family из cssText
    const fontFamilyRegex = /font-family\s*:\s*['"]?([^'";]+)['"]?/;
    // Перебираем все стили на странице
    for (let sheet of document.styleSheets)try {
        // Перебираем все правила в каждом стиле
        for (let rule of sheet.cssRules)// Проверяем, является ли это правилом @font-face
        if (rule instanceof CSSFontFaceRule) {
            const cssText = rule.cssText;
            // Ищем в правиле font-family
            const match = cssText.match(fontFamilyRegex);
            if (match && match[1] === fontName) return true;
        }
    } catch (e) {
        // Некоторые стили могут не поддерживать доступ из-за политики безопасности
        console.warn("\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0438\u043B\u044E:", sheet.href);
    }
    return false;
}
// Обработчик загрузки файла шрифта
document.getElementById('fontUpload').addEventListener('change', function(event) {
    const file = event.target.files[0];
    if (file) {
        const fileTextElement = this.closest('.input-file').querySelector('.input-file-text');
        if (fileTextElement) fileTextElement.textContent = file.name;
        const fontName = file.name.split('.')[0];
        $891048a322cecc4f$var$applyCustomFont(file, fontName);
    }
});
document.body.addEventListener('paste', function(e) {
    if ([
        'editor',
        'done',
        'err'
    ].some((cls)=>e.target.classList.contains(cls))) {
        e.preventDefault();
        const text = (e.clipboardData || window.clipboardData).getData('text/plain');
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        const range = selection.getRangeAt(0);
        range.deleteContents(); // Удаляем текущий выбор, если есть
        range.insertNode(document.createTextNode($891048a322cecc4f$var$escapeText(text))); // Вставляем новый текст
    }
});
function $891048a322cecc4f$var$escapeText(text) {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function(m) {
        return map[m];
    });
}
function $891048a322cecc4f$var$handleKeyPress(event, element) {
    if (event.key === 'Enter' || event.key === ' ') {
        element.click(); // Активирует нажатие на элемент
        event.preventDefault(); // Предотвращает прокрутку при нажатии пробела
    }
}
// Панель настроек
const $891048a322cecc4f$var$settingsPanel = document.querySelector('.side-button-1-wr .icon-button');
$891048a322cecc4f$var$settingsPanel.addEventListener('keydown', function(event) {
    $891048a322cecc4f$var$handleKeyPress(event, $891048a322cecc4f$var$settingsPanel);
});
// Переключение темы
const $891048a322cecc4f$var$themeSwitch = document.querySelector('#switch');
$891048a322cecc4f$var$themeSwitch.addEventListener('keydown', function(event) {
    $891048a322cecc4f$var$handleKeyPress(event, $891048a322cecc4f$var$themeSwitch);
});
const $891048a322cecc4f$var$tgArea = document.getElementById('spoiler-title');
$891048a322cecc4f$var$tgArea.addEventListener('click', $891048a322cecc4f$var$toggleAria);
function $891048a322cecc4f$var$toggleAria(e) {
    const summary = e.target;
    const details = summary.parentElement;
    const isOpen = details.getAttribute('open') !== null;
    details.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
}


//# sourceMappingURL=path0.e49b09c7.js.map
